import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO8601 datetime string */
  DateTime: string;
};

export type ApiKey = {
  __typename?: 'APIKey';
  createdAt: Scalars['DateTime'];
  hashType: Scalars['String'];
  id: Scalars['ID'];
  issuedAt: Scalars['DateTime'];
  keyHash: Scalars['String'];
  notAfter: Scalars['DateTime'];
  notBefore: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Account = {
  __typename?: 'Account';
  accountLocations: Array<AccountLocation>;
  accountRoles?: Maybe<Array<AccountRole>>;
  addressCity?: Maybe<Scalars['String']>;
  addressNumber?: Maybe<Scalars['String']>;
  addressPostal?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet?: Maybe<Scalars['String']>;
  billingAddressLocation?: Maybe<AccountLocation>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  fullfillmentReservations: Array<Reservation>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  invites: Array<Invite>;
  invoices: Array<Invoice>;
  isMoxion?: Maybe<Scalars['Boolean']>;
  moxionInternalNotes?: Maybe<Scalars['String']>;
  moxionReps?: Maybe<Array<User>>;
  name?: Maybe<Scalars['String']>;
  netsuiteCustomers?: Maybe<Array<NetSuiteCustomer>>;
  paymentMethods: Array<PaymentMethod>;
  pointOfContact?: Maybe<Scalars['String']>;
  reservations: Array<Reservation>;
  restrictedUserDomains: Array<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users: Array<User>;
  vat?: Maybe<Scalars['Float']>;
};

export type AccountConnection = {
  __typename?: 'AccountConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
};

export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** An opaque cursor that can be used to retrieve further pages of edges before or after this one. */
  cursor: Scalars['String'];
  /** The node object (belonging to type Account) attached to the edge. */
  node: Account;
};

export type AccountInput = {
  billingAddressLocationID?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  industry?: InputMaybe<Scalars['String']>;
  /** Notes about this account only visible to Moxion Account Users. Send null or empty string to clear. */
  moxionInternalNotes?: InputMaybe<Scalars['String']>;
  /** User IDs of the Moxion Employees who manage this Account. An empty array will clear the list. */
  moxionRepUserIDs?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  /** The main stakeholder for this Account */
  pointOfContact?: InputMaybe<Scalars['String']>;
  restrictedUserDomains?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
};

export type AccountLocation = {
  __typename?: 'AccountLocation';
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  formattedAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  placeProvider?: Maybe<PlaceProvider>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountLocationInput = {
  accountId: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  formattedAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeProvider?: InputMaybe<Scalars['String']>;
};

export type AccountLocationUpdateInput = {
  accountID: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  formattedAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeProvider?: InputMaybe<Scalars['String']>;
};

export type AccountPaginationFilters = {
  /** industries by which to filter results */
  industries?: InputMaybe<Array<Scalars['String']>>;
  /** company names by which to filter results */
  names?: InputMaybe<Array<Scalars['String']>>;
};

export type AccountRole = {
  __typename?: 'AccountRole';
  createdAt: Scalars['DateTime'];
  name: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActiveFault = {
  __typename?: 'ActiveFault';
  device: DeviceInstance;
  deviceID: Scalars['String'];
  /** The categorical actions that result from a fault. This is fixed for a given fault code */
  faultActions?: Maybe<Array<FaultAction>>;
  /** The fault code (name) identifying the type of fault */
  faultName: Scalars['String'];
  /** The Moxion opinionated severity of the fault. This is fixed for a given fault code */
  faultSeverity?: Maybe<FaultSeverity>;
  firstSeen: Scalars['DateTime'];
  /** Unique ID of the synthesized Active Fault */
  id: Scalars['ID'];
  lastUpdate: Scalars['DateTime'];
  resolved?: Maybe<Scalars['DateTime']>;
};

export type ActiveFaultConnection = {
  __typename?: 'ActiveFaultConnection';
  edges: Array<ActiveFaultEdge>;
  pageInfo: PageInfo;
};

export type ActiveFaultEdge = {
  __typename?: 'ActiveFaultEdge';
  /** An opaque cursor that can be used to retrieve further pages of edges before or after this one. */
  cursor: Scalars['String'];
  /** The node object (belonging to type ActiveFault) attached to the edge. */
  node: ActiveFault;
};

export type AddReservationItemsToReservationInput = {
  reservationID: Scalars['String'];
  reservationItems: Array<ReservationItemInput>;
};

export type Alarm = {
  __typename?: 'Alarm';
  /** ID Account to which this alerm applies */
  account: Account;
  /** Time the alarm was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID of the alarm */
  id: Scalars['ID'];
  /** Details about the alarm. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** When the alarm was resolved. A null value indicates that the alarm is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Time the alarm was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alarm */
  type: Scalars['String'];
  /** Time the alarm was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Alert = {
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum AlertSeverity {
  Critical = 'CRITICAL',
  Major = 'MAJOR'
}

export enum AlertType {
  MpuCriticalFault = 'MPU_CRITICAL_FAULT',
  MpuLowSoc = 'MPU_LOW_SOC',
  MpuOffline = 'MPU_OFFLINE',
  ReservationAllocation = 'RESERVATION_ALLOCATION',
  ReservationItemAllocation = 'RESERVATION_ITEM_ALLOCATION',
  ReservationStatusMismatch = 'RESERVATION_STATUS_MISMATCH'
}

/** what a device instance is scheduled for */
export enum Assignment {
  Charging = 'Charging',
  Discharging = 'Discharging',
  Maintenance = 'Maintenance',
  Transit = 'Transit'
}

export type AssociateNetSuiteCustomerWithAccountInput = {
  /** The MoxiOS Account ID to associate the NetSuite customer to. */
  accountID: Scalars['String'];
  /** The NetSuite customer ID to associate with the MoxiOS Account. */
  netsuiteCustomerID: Scalars['String'];
};

export type AvailableDeviceInstancesInput = {
  end: Scalars['DateTime'];
  ownerAccountID: Scalars['String'];
  start: Scalars['DateTime'];
};

export type ChargeDischargeTimeSummaryResult = {
  __typename?: 'ChargeDischargeTimeSummaryResult';
  charge_time_reservation: Scalars['Float'];
  charge_time_unit: Scalars['Float'];
  discharge_time_reservation: Scalars['Float'];
  discharge_time_unit: Scalars['Float'];
  unit: Scalars['String'];
};

export type ChargeDischargeTotalsSummaryResult = {
  __typename?: 'ChargeDischargeTotalsSummaryResult';
  average_load_kw_reservation: Scalars['Float'];
  average_load_kw_unit: Scalars['Float'];
  battery_capacity_used_percent_reservation: Scalars['Float'];
  battery_capacity_used_percent_unit: Scalars['Float'];
  e_cap_kwh_reservation: Scalars['Float'];
  e_cap_kwh_unit: Scalars['Float'];
  total_charge_hours_unit: Scalars['Float'];
  total_charge_kwh_reservation: Scalars['Float'];
  total_charge_kwh_unit: Scalars['Float'];
  total_discharge_hours_unit: Scalars['Float'];
  total_discharge_kwh_reservation: Scalars['Float'];
  total_discharge_kwh_unit: Scalars['Float'];
  unit: Scalars['String'];
};

export type CountActiveAlertsInput = {
  /** List of reservation IDs to list alerts for. If empty, alerts for all reservations will be returned. */
  reservationIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Types of Alerts to return. If empty, all alert types will be returned. */
  types?: InputMaybe<Array<AlertType>>;
};

export type CountActiveFaultsBySeverityInput = {
  /** AccountID owning the devices for faults to return */
  accountID?: InputMaybe<Scalars['String']>;
};

export type CreateApiKeyResult = {
  __typename?: 'CreateAPIKeyResult';
  apiKey: ApiKey;
  token: Scalars['String'];
};

export type CreateAccountInput = {
  industry?: InputMaybe<Scalars['String']>;
  /** This maps to the "company" field on the "Account" entity */
  name: Scalars['String'];
  restrictedUserDomains?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateDeviceInstanceInput = {
  assetID: Scalars['String'];
  deviceModelID: Scalars['String'];
  externalID?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ownerAccountID?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serviceAreaID?: InputMaybe<Scalars['String']>;
};

export type CreateFieldServiceRequestInput = {
  deviceID: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CreateNetSuiteCustomerInput = {
  accountID: Scalars['String'];
  netsuiteCustomerID: Scalars['String'];
  netsuiteCustomerName: Scalars['String'];
};

export type CreateScheduleInput = {
  assignment: Assignment;
  deviceInstance: IdObject;
  end: Scalars['DateTime'];
  internalNotes?: InputMaybe<Scalars['String']>;
  reservationItem?: InputMaybe<IdObject>;
  start: Scalars['DateTime'];
};

export type CreateSchedulesInput = {
  schedules: Array<CreateScheduleInput>;
};

export type CreateServiceAccountInput = {
  accountID: Scalars['String'];
  name: Scalars['String'];
};

export type CreateServiceAreaInput = {
  accountID: Scalars['String'];
  name: Scalars['String'];
};

export type CreateUserInput = {
  accountName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  inviteKey?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreatedInvite = {
  __typename?: 'CreatedInvite';
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  status: InviteStatus;
};

export type CurrentUserResult = {
  __typename?: 'CurrentUserResult';
  accounts: Array<Account>;
  admin?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  userPermissions?: Maybe<Array<Scalars['String']>>;
  userRoles: Array<Scalars['String']>;
};

export type Data2Fa = {
  __typename?: 'Data2FA';
  qr: Scalars['String'];
  uri: Scalars['String'];
};

export type DefaultUserNotificationPreference = {
  __typename?: 'DefaultUserNotificationPreference';
  defaultChannels: Array<UserNotificationChannel>;
  notificationStream: UserNotificationStream;
};

export type DeleteDeviceScheduleInput = {
  deviceScheduleID: Scalars['String'];
};

export type DeviceEnergyUsageInput = {
  deviceID: Scalars['String'];
  end: Scalars['DateTime'];
  groupBy?: GroupByInterval;
  start: Scalars['DateTime'];
};

export type DeviceFirmwareVersionsV1Result = {
  __typename?: 'DeviceFirmwareVersionsV1Result';
  /** The version of the firmware running on the Battery Management System subsystem */
  bmsVersion: Scalars['String'];
  /** The version of the firmware running on the Electronic Control Unit subsystem */
  ecuVersion: Scalars['String'];
  /** The version of the firmware running on the Electric Vehicle Charge Controller subsystem */
  evccVersion: Scalars['String'];
  /** The version of the firmware running on the Power Mode Controller subsystem */
  pmcVersion: Scalars['String'];
  /** The version of this response's format. Different device architectures have different firmware groups */
  schemaVersion: Scalars['String'];
  /** The version of the firmware running on the Telematics Gateway Unit subsystem */
  tguVersion: Scalars['String'];
};

export type DeviceInstance = {
  __typename?: 'DeviceInstance';
  activeFaults?: Maybe<Array<ActiveFault>>;
  /** The Device's Particle TGU Device ID */
  assetID: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceModel: DeviceModel;
  /** An ID for the Device provided by the Owner */
  externalID?: Maybe<Scalars['String']>;
  fieldServiceRequests?: Maybe<Array<FieldServiceRequest>>;
  firmwareVersions: DeviceFirmwareVersionsV1Result;
  historicalFaults?: Maybe<Array<ActiveFault>>;
  id: Scalars['ID'];
  latestDataTimestamp?: Maybe<Scalars['DateTime']>;
  latestDeviceLocation?: Maybe<DeviceLocation>;
  latestTelemetry: LatestTelemetriesResult;
  /** The colloquial name of the Device; this is not yet printed or stamped onto the Device itself */
  name: Scalars['String'];
  owner?: Maybe<Account>;
  /** The Device's Particle TGU Serial Number */
  particleSerialNumber?: Maybe<Scalars['String']>;
  schedulesIntersecting?: Maybe<Array<DeviceInstanceSchedule>>;
  /** The Serial Number assigned to the Device by Moxion's manufacturing process */
  serialNumber?: Maybe<Scalars['String']>;
  serviceArea?: Maybe<ServiceArea>;
  telemetry: TelemetryResult;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type DeviceInstanceFieldServiceRequestsArgs = {
  status: Array<FieldServiceRequestStatus>;
};


export type DeviceInstanceHistoricalFaultsArgs = {
  end: Scalars['DateTime'];
  faultNames?: InputMaybe<Array<Scalars['String']>>;
  start: Scalars['DateTime'];
};


export type DeviceInstanceLatestTelemetryArgs = {
  metrics: Array<Scalars['String']>;
};


export type DeviceInstanceSchedulesIntersectingArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};


export type DeviceInstanceTelemetryArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  metrics?: InputMaybe<Array<Scalars['String']>>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type DeviceInstanceConnection = {
  __typename?: 'DeviceInstanceConnection';
  edges: Array<DeviceInstanceEdge>;
  pageInfo: PageInfo;
};

export type DeviceInstanceEdge = {
  __typename?: 'DeviceInstanceEdge';
  /** An opaque cursor that can be used to retrieve further pages of edges before or after this one. */
  cursor: Scalars['String'];
  /** The node object (belonging to type DeviceInstance) attached to the edge. */
  node: DeviceInstance;
};

export type DeviceInstancePaginationFilters = {
  /** names by which to filter results */
  deviceNames?: InputMaybe<Array<Scalars['String']>>;
  /** external IDs by which to filter results */
  externalIDs?: InputMaybe<Array<Scalars['String']>>;
  /** accounts by which to filter results */
  ownerAccountIDs: Array<Scalars['String']>;
  /** particle devices by which to filter results */
  particleDeviceIDs?: InputMaybe<Array<Scalars['String']>>;
  /** serial numbers by which to filter results */
  serialNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** service areas by which to filter results */
  serviceAreaIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type DeviceInstanceSchedule = {
  __typename?: 'DeviceInstanceSchedule';
  assignment: Assignment;
  collectedTime?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deliveredTime?: Maybe<Scalars['Float']>;
  deviceInstance: DeviceInstance;
  /** The end of the schedule */
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  internalNotes?: Maybe<Scalars['String']>;
  reservationItem?: Maybe<ReservationItem>;
  /** The start of the schedule */
  start: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DeviceInstanceScheduleInput = {
  deviceInstanceScheduleID: Scalars['String'];
};

export type DeviceInstanceSchedulesInput = {
  deviceInstanceID: Scalars['String'];
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DeviceLocation = {
  __typename?: 'DeviceLocation';
  assetId: Scalars['String'];
  deviceID: Scalars['String'];
  horizontal_acc: Scalars['Float'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  time: Scalars['DateTime'];
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DeviceModelInput = {
  codename: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DeviceTelemetryInput = {
  deviceInstanceID: Scalars['String'];
  end: Scalars['DateTime'];
  groupBy?: GroupByInterval;
  metricNames: Array<Scalars['String']>;
  start: Scalars['DateTime'];
};

export type DeviceTelemetryPoint = {
  __typename?: 'DeviceTelemetryPoint';
  deviceID: Scalars['String'];
  metric: Scalars['String'];
  timestamp: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type EtaRequest = {
  from: LatLng;
  to: LatLng;
};

export type EtaResponse = {
  __typename?: 'ETAResponse';
  distanceMeters?: Maybe<Scalars['Float']>;
  durationSeconds: Scalars['Float'];
};

export type EstimatedTimeToEmpty = {
  __typename?: 'EstimatedTimeToEmpty';
  meta?: Maybe<EstimatedTimeToEmptyMeta>;
  when: Scalars['DateTime'];
};

export type EstimatedTimeToEmptyInput = {
  reservationItemID: Scalars['String'];
  when: Scalars['DateTime'];
};

export type EstimatedTimeToEmptyMeta = {
  __typename?: 'EstimatedTimeToEmptyMeta';
  forecastTime?: Maybe<Scalars['DateTime']>;
};

export type EventSubscription = {
  __typename?: 'EventSubscription';
  channels?: Maybe<Array<NotificationChannel>>;
  eventName: Scalars['String'];
  id: Scalars['String'];
  user: User;
};

export enum FaultAction {
  DisableAcCharging = 'DISABLE_AC_CHARGING',
  DisableDcCharging = 'DISABLE_DC_CHARGING',
  DisableHv = 'DISABLE_HV',
  NoAction = 'NO_ACTION',
  PcsDisabled = 'PCS_DISABLED'
}

export type FaultCount = {
  __typename?: 'FaultCount';
  count: Scalars['Float'];
  name: Scalars['String'];
};

/** Moxion opinionated severity of the fault. Different users and use cases may have different opinions about what is critical. */
export enum FaultSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO'
}

export type FieldServiceRequest = {
  __typename?: 'FieldServiceRequest';
  /** When the FSR was closed/ resolved */
  closedAt?: Maybe<Scalars['DateTime']>;
  /** The device for which the FSR is requested */
  deviceInstance?: Maybe<DeviceInstance>;
  /** The unique ID of the field service request */
  id: Scalars['String'];
  /** The user designated name of the field service request */
  name: Scalars['String'];
  /** When the FSR was created/ opened */
  openedAt: Scalars['DateTime'];
  /** The url link to the field service request, potentially to another application */
  url: Scalars['String'];
};

export enum FieldServiceRequestStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum FilterMode {
  Active = 'Active',
  All = 'All',
  Confirmed = 'Confirmed',
  Future = 'Future',
  Past = 'Past',
  Requested = 'Requested'
}

export enum GroupByInterval {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Second = 'SECOND'
}

export type IdObject = {
  id: Scalars['String'];
};

export type IntervalInput = {
  /** "end" of date range interval; exclusive */
  end?: InputMaybe<Scalars['DateTime']>;
  /** "start" of date range interval; inclusive */
  start?: InputMaybe<Scalars['DateTime']>;
};

export type Invite = {
  __typename?: 'Invite';
  account: Account;
  /** @deprecated use "invitedUser" instead */
  claimedUser?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inviteKey: Scalars['String'];
  invitedUser: User;
  status: InviteStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The status of a user invite. */
export enum InviteStatus {
  Claimed = 'CLAIMED',
  Pending = 'PENDING'
}

export type Invoice = {
  __typename?: 'Invoice';
  account: Account;
  createdAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoiceLineItems: Array<InvoiceLineItem>;
  notes?: Maybe<Scalars['String']>;
  paidDate?: Maybe<Scalars['DateTime']>;
  payments: Array<Payment>;
  reservation?: Maybe<Reservation>;
  status: Scalars['String'];
  subtotal?: Maybe<Scalars['Float']>;
  taxNumber?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vat?: Maybe<Scalars['Float']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  billableDays: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoice: Invoice;
  lineTotal: Scalars['Float'];
  pricePerDay: Scalars['Float'];
  reservation: Reservation;
  reservationItem: ReservationItem;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** sort parameters */
export type KeyOfSortArg = {
  /** direction to sort results by */
  direction: SortDirection;
  /** field to sort results by */
  field: Scalars['String'];
};

export type LatLng = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LatestTelemetriesResult = {
  __typename?: 'LatestTelemetriesResult';
  telemetryPoints: Array<TelemetryPoint>;
};

export type ListActiveAlertsInput = {
  /** List of reservation IDs to list alerts for. If empty, alerts for all reservations will be returned. */
  reservationIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Types of Alerts to return. If empty, all alert types will be returned. */
  types?: InputMaybe<Array<AlertType>>;
};

export type ListActiveFaultsByCountInput = {
  /** AccountID owning the devices for faults to return */
  accountID?: InputMaybe<Scalars['String']>;
  /** Number of counts to return, ordered by greatest first. Defaults to all. */
  limit?: InputMaybe<Scalars['Float']>;
};

export type ListDeviceLocationsInput = {
  /** The time at which to return the location of the device instance. If not provided, the most recent location will be returned */
  asOf?: InputMaybe<Scalars['DateTime']>;
  /** Device Instance IDs whose location to return */
  deviceInstanceIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Account ID of the owner of the device instance. If used with deviceInstanceIDs, their intersection will be returned */
  ownerAccountIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type ListFieldServiceRequestsInput = {
  /** The devices for which the FSRs are requested */
  deviceIDs?: InputMaybe<Array<Scalars['String']>>;
  /** The IDs of the specific field service requests to fetch */
  fieldServiceRequestIDs?: InputMaybe<Array<Scalars['String']>>;
  /** Whether to return open (unresolved), closed, or all field service requests. */
  status?: InputMaybe<Array<FieldServiceRequestStatus>>;
};

export type ListReservationItemsInput = {
  /** account servicing reservations */
  fulfillerAccountID?: InputMaybe<Scalars['String']>;
  /** interval intersecting reservation items */
  interval?: InputMaybe<IntervalInput>;
  /** account IDs of reservation requesters */
  requesterAccountIDs?: InputMaybe<Array<Scalars['String']>>;
  /** reservation IDs to filter by */
  reservationItemIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type ListReservationsInput = {
  /** the ID of the account owning and servicing the returned reservations */
  ownerAccountID?: InputMaybe<Scalars['String']>;
  /** requester account IDs to filter by */
  requesterAccountIDs?: InputMaybe<Array<Scalars['String']>>;
  /** reservation IDs to filter by */
  reservationIDs?: InputMaybe<Array<Scalars['String']>>;
  /** a set of reservation statuses to filter by */
  statuses?: InputMaybe<Array<ReservationStatus>>;
};

export type ListScheduleTransitionsInput = {
  accountID?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token2FA?: InputMaybe<Scalars['String']>;
};

export type LogoutResult = {
  __typename?: 'LogoutResult';
  logout: Scalars['Boolean'];
};

export type MpuCriticalFaultAlert = Alert & {
  __typename?: 'MPUCriticalFaultAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** The Device associated with this Alert */
  device: DeviceInstance;
  /** ID of DeviceInstance to which the alert applies */
  deviceID: Scalars['String'];
  /** The Fault associated with this Alert */
  fault: ActiveFault;
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MpuLowSocAlert = Alert & {
  __typename?: 'MPULowSOCAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** The Device associated with this Alert */
  device: DeviceInstance;
  /** ID of DeviceInstance to which the alert applies */
  deviceID: Scalars['String'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  soc: Scalars['Float'];
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MpuOfflineAlert = Alert & {
  __typename?: 'MPUOfflineAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** The Device associated with this Alert */
  device: DeviceInstance;
  /** ID of DeviceInstance to which the alert applies */
  deviceID: Scalars['String'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** The last time the MPU uploaded data */
  lastUploadTime: Scalars['String'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaxContinuousLoadSummaryResult = {
  __typename?: 'MaxContinuousLoadSummaryResult';
  maximum_continuous_load_kw_unit: Scalars['Float'];
  maximum_continuous_load_reservation: Scalars['Float'];
  unit: Scalars['String'];
};

export type Metric = {
  __typename?: 'Metric';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ModifyAccountRolesInput = {
  accountID: Scalars['String'];
  accountRoleNames: Array<Scalars['String']>;
};

export type ModifyServiceAccountRolesInput = {
  roles: Array<Scalars['String']>;
  serviceAccountID: Scalars['String'];
};

export type ModifyUserRolesInput = {
  roles: Array<Scalars['String']>;
  userID: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUser?: Maybe<User>;
  addAccountRoles: Account;
  /** Add ReservationItems to a Reservation */
  addItemsToReservation: Reservation;
  addServiceAccountRole: ServiceAccount;
  addUserRoles: User;
  /** Associates a NetSuite Customer [ e.g. 'Sunbelt Rentals, Inc.' ] with a MoxiOS Account i.e. 'Sunbelt Rentals' */
  associateNetSuiteCustomerWithAccount: Account;
  /**
   * Cancel a reservation. A renter can cancel a reservation up to 24 hours before the reservation start time.
   *         Admins should use updateReservation() to bypass time restrictions. Callable by rental users.
   */
  cancelReservation: Reservation;
  closeFieldServiceRequest: FieldServiceRequest;
  completeReservation: Reservation;
  confirmReservation: Reservation;
  createAPIKeyForServiceAccount: CreateApiKeyResult;
  createAccount: Account;
  createAccountLocation: AccountLocation;
  createDeviceInstance: DeviceInstance;
  createDeviceModel: DeviceModel;
  createFieldServiceRequest: FieldServiceRequest;
  createNetSuiteCustomer: NetSuiteCustomer;
  createSchedules: Array<DeviceInstanceSchedule>;
  createServiceAccount: ServiceAccount;
  createServiceArea: ServiceArea;
  createUser: SessionResult;
  createUserAccountInvite: CreatedInvite;
  deactivateUser?: Maybe<User>;
  deleteAccount: Account;
  deleteAccountLocation: AccountLocation;
  deleteDeviceInstance: DeviceInstance;
  deleteDeviceInstanceSchedule: Reservation;
  deleteDeviceSchedule: DeviceInstanceSchedule;
  deleteReservationItemHistory: ReservationItemHistory;
  enable2FA: Data2Fa;
  invalidateAPIKey: ApiKey;
  loginUser: SessionResult;
  logoutUser: LogoutResult;
  removeAccountRoles: Account;
  removeServiceAccountRole: ServiceAccount;
  removeUserRoles: User;
  resetPassword: ResetPasswordResult;
  /** Set the user's notification subscription preferences. Updated subscriptions will be returned */
  setUserNotificationSubscription: Array<UserNotificationSubscription>;
  startReservation: Reservation;
  /** Request a reservation. Callable by rental users. */
  submitReservationRequest: Reservation;
  submitResetPasswordToken: SubmitResetPasswordTokenResult;
  updateAccount: Account;
  updateAccountLocation: AccountLocation;
  updateDeviceInstance: DeviceInstance;
  updateDeviceModel: DeviceModel;
  updateDeviceSchedule: DeviceInstanceSchedule;
  updateDeviceSchedules: DeviceInstanceSchedule;
  updateReservation: Reservation;
  updateReservationItem: ReservationItem;
  updateUser: User;
  updateUserPhoneNumber: User;
  upsertDeviceInstanceSchedule: Reservation;
  upsertEventSubscription: EventSubscription;
  upsertReservationItemHistory: ReservationItemHistory;
  userSavePaymentMethod: Array<PaymentMethodData>;
  validate2FA: Validate2FaResult;
};


export type MutationActivateUserArgs = {
  id: Scalars['String'];
};


export type MutationAddAccountRolesArgs = {
  input: ModifyAccountRolesInput;
};


export type MutationAddItemsToReservationArgs = {
  input: AddReservationItemsToReservationInput;
};


export type MutationAddServiceAccountRoleArgs = {
  addServiceAccountRolesInput: ModifyServiceAccountRolesInput;
};


export type MutationAddUserRolesArgs = {
  addUserRolesInput: ModifyUserRolesInput;
};


export type MutationAssociateNetSuiteCustomerWithAccountArgs = {
  input: AssociateNetSuiteCustomerWithAccountInput;
};


export type MutationCancelReservationArgs = {
  id: Scalars['String'];
};


export type MutationCloseFieldServiceRequestArgs = {
  id: Scalars['String'];
};


export type MutationCompleteReservationArgs = {
  id: Scalars['String'];
};


export type MutationConfirmReservationArgs = {
  id: Scalars['String'];
};


export type MutationCreateApiKeyForServiceAccountArgs = {
  serviceAccountID: Scalars['String'];
};


export type MutationCreateAccountArgs = {
  accountDetails: CreateAccountInput;
};


export type MutationCreateAccountLocationArgs = {
  accountLocationInput: AccountLocationInput;
};


export type MutationCreateDeviceInstanceArgs = {
  input: CreateDeviceInstanceInput;
};


export type MutationCreateDeviceModelArgs = {
  deviceModelInput: DeviceModelInput;
};


export type MutationCreateFieldServiceRequestArgs = {
  input: CreateFieldServiceRequestInput;
};


export type MutationCreateNetSuiteCustomerArgs = {
  input: CreateNetSuiteCustomerInput;
};


export type MutationCreateSchedulesArgs = {
  input: CreateSchedulesInput;
};


export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};


export type MutationCreateServiceAreaArgs = {
  input: CreateServiceAreaInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateUserAccountInviteArgs = {
  accountID: Scalars['String'];
  email: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAccountArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAccountLocationArgs = {
  accountId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationDeleteDeviceInstanceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDeviceInstanceScheduleArgs = {
  deviceInstanceScheduleId: Scalars['String'];
};


export type MutationDeleteDeviceScheduleArgs = {
  input: DeleteDeviceScheduleInput;
};


export type MutationDeleteReservationItemHistoryArgs = {
  id: Scalars['String'];
};


export type MutationInvalidateApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationLoginUserArgs = {
  loginInput: LoginInput;
};


export type MutationRemoveAccountRolesArgs = {
  input: ModifyAccountRolesInput;
};


export type MutationRemoveServiceAccountRoleArgs = {
  removeServiceAccountRolesInput: ModifyServiceAccountRolesInput;
};


export type MutationRemoveUserRolesArgs = {
  removeUserRolesInput: ModifyUserRolesInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationSetUserNotificationSubscriptionArgs = {
  input: SetUserNotificationPreferencesInput;
};


export type MutationStartReservationArgs = {
  id: Scalars['String'];
};


export type MutationSubmitReservationRequestArgs = {
  submitReservationRequestInput: SubmitReservationRequestInput;
};


export type MutationSubmitResetPasswordTokenArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  token2FA?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAccountArgs = {
  accountInput: AccountInput;
};


export type MutationUpdateAccountLocationArgs = {
  input: AccountLocationUpdateInput;
};


export type MutationUpdateDeviceInstanceArgs = {
  input: UpdateDeviceInstanceInput;
};


export type MutationUpdateDeviceModelArgs = {
  deviceModelInput: DeviceModelInput;
};


export type MutationUpdateDeviceScheduleArgs = {
  input: UpdateDeviceScheduleInput;
};


export type MutationUpdateDeviceSchedulesArgs = {
  input: UpdateDeviceSchedulesInput;
};


export type MutationUpdateReservationArgs = {
  ReservationInput: ReservationInput;
};


export type MutationUpdateReservationItemArgs = {
  input: ReservationItemUpdateInput;
};


export type MutationUpdateUserArgs = {
  userInput: UserInput;
};


export type MutationUpdateUserPhoneNumberArgs = {
  input: UserPhoneNumberInput;
};


export type MutationUpsertDeviceInstanceScheduleArgs = {
  deviceInstanceScheduleInput: UpsertDeviceInstanceScheduleInput;
};


export type MutationUpsertEventSubscriptionArgs = {
  input: UpdateEventSubscriptionInput;
};


export type MutationUpsertReservationItemHistoryArgs = {
  reservationItemHistoryInput: ReservationItemHistoryInput;
};


export type MutationUserSavePaymentMethodArgs = {
  userSavePaymentMethodInput: UserSavePaymentMethodInput;
};


export type MutationValidate2FaArgs = {
  validate2FAInput: Validate2FaInput;
};

export type NetSuiteCustomer = {
  __typename?: 'NetSuiteCustomer';
  account?: Maybe<Account>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum NotificationChannel {
  Email = 'Email',
  Sms = 'SMS'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  totalEdges?: Maybe<Scalars['Int']>;
};

export type Payment = {
  __typename?: 'Payment';
  account: Array<Account>;
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoice: Array<Invoice>;
  memo: Scalars['String'];
  paymentDate: Scalars['String'];
  token: Scalars['String'];
  transactionId: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  account: Array<Account>;
  addressCity?: Maybe<Scalars['String']>;
  addressNumber?: Maybe<Scalars['String']>;
  addressPostal?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  last4: Scalars['Float'];
  token: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodData = {
  __typename?: 'PaymentMethodData';
  brand: Scalars['String'];
  expiryMonth: Scalars['Float'];
  expiryYear: Scalars['Float'];
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export enum PlaceProvider {
  GooglePlaces = 'GooglePlaces'
}

export type Query = {
  __typename?: 'Query';
  accountLocationsByAccount: Array<AccountLocation>;
  availableDeviceInstances: Array<DeviceInstance>;
  countActiveAlerts: Scalars['Int'];
  countActiveFaultsBySeverity: Array<SeverityCount>;
  countReservationsByStatus: ReservationStatusCounts;
  currentUserSession: CurrentUserResult;
  deviceEnergyUsage: TelemetryResult;
  deviceInstanceSchedule: DeviceInstanceSchedule;
  deviceInstanceSchedules: Array<DeviceInstanceSchedule>;
  deviceTelemetry: TelemetryResult;
  estimatedTimeToEmpty: EstimatedTimeToEmpty;
  getAccount: Account;
  getDeviceInstance: DeviceInstance;
  getDeviceModel: DeviceModel;
  getETA: EtaResponse;
  getInvoice: Invoice;
  /** @deprecated use getReservationItem instead */
  getRental: RentalResult;
  getReservation: Reservation;
  getReservationItem: ReservationItem;
  getUser?: Maybe<User>;
  listAccounts: AccountConnection;
  listActiveAlerts: Array<Alert>;
  listActiveFaults: ActiveFaultConnection;
  listAllowedMoxionReps: Array<User>;
  listDefaultUserNotificationPreferences: Array<DefaultUserNotificationPreference>;
  listDeviceInstances: DeviceInstanceConnection;
  listDeviceLocations: Array<DeviceLocation>;
  listDeviceModels: Array<DeviceModel>;
  listEventSubscriptions: Array<EventSubscription>;
  listFaultCountsByName: Array<FaultCount>;
  listFieldServiceRequests: Array<FieldServiceRequest>;
  listGrantableRoles: Array<Role>;
  listInvoices: Array<Invoice>;
  listLatestTelemetry: Array<DeviceTelemetryPoint>;
  /** List Metrics */
  listMetrics: Array<Metric>;
  listNetSuiteCustomers: Array<NetSuiteCustomer>;
  listReservationItems: Array<ReservationItem>;
  /** @deprecated use "listReservations" and pass a "status" filter */
  listReservationItemsByReservationStatus: Array<ReservationItem>;
  listReservations: Array<Reservation>;
  listRoles: Array<Role>;
  listScheduleTransitions: Array<ScheduleTransition>;
  listSchedulesForReservationItemIDs: Array<DeviceInstanceSchedule>;
  listServiceAccounts: Array<ServiceAccount>;
  listServiceAccountsRoles: Array<Role>;
  listServiceAreas: Array<ServiceArea>;
  listTriggeredAlarms: Array<Alarm>;
  listUpcomingReservations: Array<Reservation>;
  listUserNotificationSubscriptions: Array<UserNotificationSubscription>;
  listUserRoles: Array<Scalars['String']>;
  listUsers: UserConnection;
  reservationEnergyUsage: TelemetryResult;
  reservationItemHistory: Array<ReservationItemHistory>;
  reservationLatestTelemetry: LatestTelemetriesResult;
  reservationTelemetry: TelemetryResult;
  reservationTelemetrySummary: ReservationTelemetrySummaryResult;
  reservationsAllowedStatusTransitions: StateTransitions;
  userAccountInviteFindAll: Array<Invite>;
  userPaymentMethods: Array<PaymentMethodData>;
  userReservationPaymentInfo: ReservationPaymentOutput;
  /** Checks given an inviteKey for validity */
  validateInviteKey: ValidateInviteKeyResult;
};


export type QueryAccountLocationsByAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryAvailableDeviceInstancesArgs = {
  availableDeviceInstancesInput: AvailableDeviceInstancesInput;
};


export type QueryCountActiveAlertsArgs = {
  input?: InputMaybe<CountActiveAlertsInput>;
};


export type QueryCountActiveFaultsBySeverityArgs = {
  input: CountActiveFaultsBySeverityInput;
};


export type QueryCountReservationsByStatusArgs = {
  fulfillerAccountID: Scalars['String'];
};


export type QueryDeviceEnergyUsageArgs = {
  input: DeviceEnergyUsageInput;
};


export type QueryDeviceInstanceScheduleArgs = {
  input: DeviceInstanceScheduleInput;
};


export type QueryDeviceInstanceSchedulesArgs = {
  deviceInstanceSchedulesInput: DeviceInstanceSchedulesInput;
};


export type QueryDeviceTelemetryArgs = {
  deviceTelemetryInput: DeviceTelemetryInput;
};


export type QueryEstimatedTimeToEmptyArgs = {
  input: EstimatedTimeToEmptyInput;
};


export type QueryGetAccountArgs = {
  id: Scalars['String'];
};


export type QueryGetDeviceInstanceArgs = {
  id: Scalars['String'];
};


export type QueryGetDeviceModelArgs = {
  id: Scalars['String'];
};


export type QueryGetEtaArgs = {
  input: EtaRequest;
};


export type QueryGetInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryGetRentalArgs = {
  rentalId: Scalars['String'];
};


export type QueryGetReservationArgs = {
  id: Scalars['String'];
};


export type QueryGetReservationItemArgs = {
  id: Scalars['String'];
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryListAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AccountPaginationFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
};


export type QueryListActiveAlertsArgs = {
  input?: InputMaybe<ListActiveAlertsInput>;
};


export type QueryListActiveFaultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deviceIDs?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  ownerAccountID?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  severities?: InputMaybe<Array<FaultSeverity>>;
  sortBy?: InputMaybe<KeyOfSortArg>;
};


export type QueryListDefaultUserNotificationPreferencesArgs = {
  userID: Scalars['String'];
};


export type QueryListDeviceInstancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: DeviceInstancePaginationFilters;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
};


export type QueryListDeviceLocationsArgs = {
  input: ListDeviceLocationsInput;
};


export type QueryListEventSubscriptionsArgs = {
  userID: Scalars['String'];
};


export type QueryListFaultCountsByNameArgs = {
  input: ListActiveFaultsByCountInput;
};


export type QueryListFieldServiceRequestsArgs = {
  filters: ListFieldServiceRequestsInput;
};


export type QueryListGrantableRolesArgs = {
  grantorUserID: Scalars['String'];
};


export type QueryListLatestTelemetryArgs = {
  before: Scalars['DateTime'];
  deviceIDs: Array<Scalars['String']>;
  metricNames: Array<Scalars['String']>;
};


export type QueryListMetricsArgs = {
  deviceIDs?: InputMaybe<Array<Scalars['String']>>;
  since?: InputMaybe<Scalars['String']>;
};


export type QueryListReservationItemsArgs = {
  input: ListReservationItemsInput;
};


export type QueryListReservationItemsByReservationStatusArgs = {
  filterMode?: FilterMode;
};


export type QueryListReservationsArgs = {
  input: ListReservationsInput;
};


export type QueryListScheduleTransitionsArgs = {
  input: ListScheduleTransitionsInput;
};


export type QueryListSchedulesForReservationItemIDsArgs = {
  input: ReservationItemDeviceInstanceSchedulesInput;
};


export type QueryListServiceAccountsArgs = {
  accountID: Scalars['String'];
};


export type QueryListServiceAccountsRolesArgs = {
  serviceAccountID: Scalars['String'];
};


export type QueryListServiceAreasArgs = {
  accountID: Scalars['String'];
};


export type QueryListTriggeredAlarmsArgs = {
  accountID: Scalars['String'];
};


export type QueryListUserNotificationSubscriptionsArgs = {
  userID: Scalars['String'];
};


export type QueryListUserRolesArgs = {
  userID: Scalars['String'];
};


export type QueryListUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserPaginationFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
};


export type QueryReservationEnergyUsageArgs = {
  input: ReservationEnergyUsageInput;
};


export type QueryReservationLatestTelemetryArgs = {
  input: ReservationLatestTelemetryInput;
};


export type QueryReservationTelemetryArgs = {
  input: ReservationTelemetryInput;
};


export type QueryReservationTelemetrySummaryArgs = {
  input: ReservationTelemetrySummaryInput;
};


export type QueryReservationsAllowedStatusTransitionsArgs = {
  reservationId: Scalars['String'];
};


export type QueryUserReservationPaymentInfoArgs = {
  id: Scalars['String'];
};


export type QueryValidateInviteKeyArgs = {
  inviteKey: Scalars['String'];
};

export type RentalResult = {
  __typename?: 'RentalResult';
  account: Account;
  alias?: Maybe<Scalars['String']>;
  canMonitor: Scalars['Boolean'];
  end: Scalars['DateTime'];
  id: Scalars['String'];
  jobSite?: Maybe<AccountLocation>;
  nextSwapDate?: Maybe<Scalars['DateTime']>;
  start: Scalars['DateTime'];
  status: Scalars['String'];
  user: User;
};

export type Reservation = {
  __typename?: 'Reservation';
  account: Account;
  activeAlerts: Array<Alert>;
  additionalNotes?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fulfiller: Account;
  fulfillerNotes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  invoiceLineItems: Array<InvoiceLineItem>;
  name?: Maybe<Scalars['String']>;
  reservationItems: Array<ReservationItem>;
  reservation_seq_id: Scalars['Float'];
  serviceArea?: Maybe<ServiceArea>;
  status: ReservationStatus;
  type: ReservationType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userRequested: User;
};


export type ReservationActiveAlertsArgs = {
  types?: InputMaybe<Array<AlertType>>;
};

export type ReservationAllocationAlert = Alert & {
  __typename?: 'ReservationAllocationAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** List of reservation item IDs which are not fully allocated */
  reservationItemIDs: Array<Scalars['String']>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationEnergyUsageInput = {
  groupBy?: GroupByInterval;
  reservationItemID: Scalars['String'];
};

export type ReservationFaultSummaryResult = {
  __typename?: 'ReservationFaultSummaryResult';
  total_critical_faults_reservation: Scalars['Float'];
  total_critical_faults_unit: Scalars['Float'];
  total_faults_reservation: Scalars['Float'];
  total_faults_unit: Scalars['Float'];
  unit: Scalars['String'];
};

export type ReservationInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  fulfillerNotes?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  serviceAreaID?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ReservationStatus>;
  type?: InputMaybe<ReservationType>;
};

export type ReservationItem = {
  __typename?: 'ReservationItem';
  alias?: Maybe<Scalars['String']>;
  assignedDevice?: Maybe<DeviceInstance>;
  createdAt: Scalars['DateTime'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryLocation: AccountLocation;
  deliveryNotes?: Maybe<Scalars['String']>;
  deviceInstanceSchedule: Array<DeviceInstanceSchedule>;
  deviceModel: DeviceModel;
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  invoiceLineItem: InvoiceLineItem;
  pickupDate?: Maybe<Scalars['DateTime']>;
  pickupLocation: AccountLocation;
  pickupNotes?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  reservation: Reservation;
  reservationItemHistory: Array<ReservationItemHistory>;
  site?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ReservationItemAssignedDeviceArgs = {
  assignment: Scalars['String'];
  time: Scalars['DateTime'];
};

export type ReservationItemAllocationAlert = Alert & {
  __typename?: 'ReservationItemAllocationAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** Reservation Item to which this alert applies */
  reservationItem: ReservationItem;
  /** ID of Reservation Item to which the alert applies */
  reservationItemID: Scalars['String'];
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationItemDeviceInstanceSchedulesInput = {
  reservationItemIDs: Array<Scalars['String']>;
  time: Scalars['DateTime'];
};

export type ReservationItemHistory = {
  __typename?: 'ReservationItemHistory';
  createdAt: Scalars['DateTime'];
  deliveryDate: Scalars['DateTime'];
  endDay: Scalars['DateTime'];
  id: Scalars['ID'];
  pickupDate: Scalars['DateTime'];
  reservationItem: Array<ReservationItem>;
  startDay: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationItemHistoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReservationItemInput = {
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  deliveryLocationID: Scalars['String'];
  deviceModelID: Scalars['String'];
  end: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pickupDate?: InputMaybe<Scalars['DateTime']>;
  pickupLocationID: Scalars['String'];
  quantity: Scalars['Float'];
  start: Scalars['DateTime'];
};

export type ReservationItemUpdateInput = {
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  deliveryLocationID?: InputMaybe<Scalars['String']>;
  deviceModelID?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  pickupDate?: InputMaybe<Scalars['DateTime']>;
  pickupLocationID?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationLatestTelemetryInput = {
  metricNames: Array<Scalars['String']>;
  reservationItemID: Scalars['String'];
};

export type ReservationPaymentOutput = {
  __typename?: 'ReservationPaymentOutput';
  reservation: Reservation;
};

export enum ReservationStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  Requested = 'Requested',
  Started = 'Started'
}

export type ReservationStatusCounts = {
  __typename?: 'ReservationStatusCounts';
  confirmed: Scalars['Float'];
  requested: Scalars['Float'];
  started: Scalars['Float'];
};

export type ReservationStatusMismatchAlert = Alert & {
  __typename?: 'ReservationStatusMismatchAlert';
  /** Account to which this alert applies */
  account: Account;
  /** Subject of the alert. This is the ID of the related entity */
  audienceAccountID: Scalars['String'];
  /** Time the alert was created */
  createdAt: Scalars['DateTime'];
  /** Unique ID of the alert */
  id: Scalars['ID'];
  /** Details about the alert. Each type may use a different object schema. */
  payload?: Maybe<Scalars['String']>;
  /** Reservation to which this alert applies */
  reservation?: Maybe<Reservation>;
  /** When the alert was resolved. A null value indicates that the alert is active. Note that this may be slightly delayed from the actual resolution. */
  resolveTime?: Maybe<Scalars['DateTime']>;
  /** Severity of the alert */
  severity: AlertSeverity;
  /** Time the alert was raised. Note that this may be slightly delayed from the actual event. */
  triggerTime: Scalars['DateTime'];
  /** Type of alert */
  type: AlertType;
  /** Time the alert was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationTelemetryInput = {
  end: Scalars['DateTime'];
  groupBy?: GroupByInterval;
  metricNames: Array<Scalars['String']>;
  reservationItemID: Scalars['String'];
  start: Scalars['DateTime'];
};

export type ReservationTelemetrySummaryInput = {
  reservationID: Scalars['String'];
};

export type ReservationTelemetrySummaryResult = {
  __typename?: 'ReservationTelemetrySummaryResult';
  chargeDischargeTimes?: Maybe<Array<ChargeDischargeTimeSummaryResult>>;
  chargeDischargeTotals?: Maybe<Array<ChargeDischargeTotalsSummaryResult>>;
  faults?: Maybe<Array<ReservationFaultSummaryResult>>;
  maxContinousLoad?: Maybe<Array<MaxContinuousLoadSummaryResult>>;
};

export enum ReservationType {
  Demo = 'DEMO',
  Pilot = 'PILOT',
  Rental = 'RENTAL'
}

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  requested: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  name: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduleTransition = {
  __typename?: 'ScheduleTransition';
  from?: Maybe<DeviceInstanceSchedule>;
  time: Scalars['DateTime'];
  to?: Maybe<DeviceInstanceSchedule>;
  type: Scalars['String'];
};

export type ServiceAccount = {
  __typename?: 'ServiceAccount';
  apiKeys: Array<ApiKey>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  accountID: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SessionResult = {
  __typename?: 'SessionResult';
  accounts: Array<Account>;
  id: Scalars['String'];
  requires2FA: Scalars['Boolean'];
};

export type SetUserNotificationPreferencesInput = {
  notificationPreferences: Array<UserNotificationPreferenceInput>;
  userID: Scalars['String'];
};

export type SeverityCount = {
  __typename?: 'SeverityCount';
  count: Scalars['Float'];
  /** Moxion's opinion of the general severity of the fault. Different users and use cases may have different opinions about what is critical. */
  severity: Scalars['String'];
};

/** sort direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StateTransitions = {
  __typename?: 'StateTransitions';
  allowedTransitions: Array<ReservationStatus>;
};

export type SubmitReservationRequestInput = {
  additionalNotes?: InputMaybe<Scalars['String']>;
  /** the account that will fulfill the reservation; if null, the assumed fulfiller is moxion */
  fulfillerAccountID?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** The account ID of the account that is requesting the reservation. */
  requesterAccountID: Scalars['String'];
  reservationItems: Array<ReservationItemInput>;
  userID: Scalars['String'];
};

export type SubmitResetPasswordTokenResult = {
  __typename?: 'SubmitResetPasswordTokenResult';
  reset: Scalars['Boolean'];
};

export type Telemetry = {
  __typename?: 'Telemetry';
  /** @deprecated a metric may be associated with many devices; we are going to remove asset and device id fields from telemetry */
  assetId?: Maybe<Scalars['String']>;
  datapoints: Array<TelemetryValue>;
  metric: Scalars['String'];
};

export type TelemetryPoint = {
  __typename?: 'TelemetryPoint';
  metric: Scalars['String'];
  timestamp: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type TelemetryResult = {
  __typename?: 'TelemetryResult';
  telemetries: Array<Telemetry>;
};

export type TelemetryValue = {
  __typename?: 'TelemetryValue';
  timestamp: Scalars['DateTime'];
  value?: Maybe<Scalars['Float']>;
};

export type UpdateDeviceInstanceInput = {
  assetID?: InputMaybe<Scalars['String']>;
  deviceModelID?: InputMaybe<Scalars['String']>;
  externalID?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  ownerAccountID?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serviceAreaID?: InputMaybe<Scalars['String']>;
};

export type UpdateDeviceScheduleInput = {
  assignment?: InputMaybe<Assignment>;
  deviceScheduleID: Scalars['String'];
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type UpdateDeviceSchedulesInput = {
  schedules: Array<UpdateDeviceScheduleInput>;
};

export type UpdateEventSubscriptionInput = {
  channels: Array<NotificationChannel>;
  eventName: Scalars['String'];
  id: Scalars['String'];
  userID: Scalars['String'];
};

export type UpsertDeviceInstanceScheduleInput = {
  deviceInstanceId: Scalars['String'];
  deviceInstanceScheduleId?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  reservationItemId: Scalars['String'];
  start: Scalars['DateTime'];
};

export type User = {
  __typename?: 'User';
  accounts: Array<Account>;
  /** @deprecated use "status" instead */
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  /** a user's name; will be null for invited users */
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  status: UserStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** An opaque cursor that can be used to retrieve further pages of edges before or after this one. */
  cursor: Scalars['String'];
  /** The node object (belonging to type User) attached to the edge. */
  node: User;
};

export type UserInput = {
  accountIds?: InputMaybe<Array<Scalars['String']>>;
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  /** Unique identifier of the User to update */
  id: Scalars['String'];
  /** Name of the User */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number for the User. Explicit null will clear the phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum UserNotificationChannel {
  Email = 'Email'
}

export type UserNotificationPreferenceInput = {
  /** The notification channel to modify */
  channel: UserNotificationChannel;
  /** Whether to send notifications for this stream and channel. null will clear the preference and use the default. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  notificationStream: UserNotificationStream;
};

export enum UserNotificationStream {
  ReservationCancelledFulfiller = 'RESERVATION_CANCELLED_FULFILLER',
  ReservationCancelledRequester = 'RESERVATION_CANCELLED_REQUESTER',
  ReservationCompletedFulfiller = 'RESERVATION_COMPLETED_FULFILLER',
  ReservationCompletedRequester = 'RESERVATION_COMPLETED_REQUESTER',
  ReservationConfirmedFulfiller = 'RESERVATION_CONFIRMED_FULFILLER',
  ReservationConfirmedRequester = 'RESERVATION_CONFIRMED_REQUESTER',
  ReservationDeclinedFulfiller = 'RESERVATION_DECLINED_FULFILLER',
  ReservationDeclinedRequester = 'RESERVATION_DECLINED_REQUESTER',
  ReservationRequestedFulfiller = 'RESERVATION_REQUESTED_FULFILLER',
  ReservationRequestedRequester = 'RESERVATION_REQUESTED_REQUESTER',
  ReservationReRequestedFulfiller = 'RESERVATION_RE_REQUESTED_FULFILLER',
  ReservationReRequestedRequester = 'RESERVATION_RE_REQUESTED_REQUESTER',
  ReservationStartedFulfiller = 'RESERVATION_STARTED_FULFILLER',
  ReservationStartedRequester = 'RESERVATION_STARTED_REQUESTER'
}

export type UserNotificationSubscription = {
  __typename?: 'UserNotificationSubscription';
  notificationStream: UserNotificationStream;
  sendEmail?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type UserPaginationFilters = {
  /** accounts by which to filter results */
  accountIDs?: InputMaybe<Array<Scalars['String']>>;
  /** emails by which to filter results */
  emails?: InputMaybe<Array<Scalars['String']>>;
  /** names by which to filter results */
  names?: InputMaybe<Array<Scalars['String']>>;
  /** roles by which to filter results */
  roleNames?: InputMaybe<Array<Scalars['String']>>;
  /** filter for users by status */
  status?: InputMaybe<UserStatus>;
};

export type UserPhoneNumberInput = {
  /** The updated phone number for the User. Explicit null will clear the phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** ID of the User to update */
  userID: Scalars['String'];
};

export type UserSavePaymentMethodInput = {
  paymentMethodId: Scalars['String'];
};

/** The status of a user */
export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Invited = 'INVITED'
}

export type Validate2FaInput = {
  code: Scalars['String'];
};

export type Validate2FaResult = {
  __typename?: 'Validate2FAResult';
  ok: Scalars['Boolean'];
};

export type ValidateInviteKeyResult = {
  __typename?: 'ValidateInviteKeyResult';
  /** Whether the invite exists or not */
  exists: Scalars['Boolean'];
  /** Whether the invite has been claimed */
  isClaimed: Scalars['Boolean'];
  /** Whether the invite is expired or not */
  isExpired: Scalars['Boolean'];
};

export type CountActiveAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountActiveAlertsQuery = { __typename?: 'Query', countActiveAlerts: number };

export type UserAccountInviteUpsertMutationVariables = Exact<{
  email: Scalars['String'];
  accountID: Scalars['String'];
  roles?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UserAccountInviteUpsertMutation = { __typename?: 'Mutation', createUserAccountInvite: { __typename?: 'CreatedInvite', email: string } };

export type AccountLocationsByAccountQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type AccountLocationsByAccountQuery = { __typename?: 'Query', accountLocationsByAccount: Array<{ __typename?: 'AccountLocation', id: string, contactName?: string | null, contactPhone?: string | null, formattedAddress?: string | null, notes?: string | null, createdAt: string }> };

export type CreateAccountLocationMutationVariables = Exact<{
  accountLocationInput: AccountLocationInput;
}>;


export type CreateAccountLocationMutation = { __typename?: 'Mutation', createAccountLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, notes?: string | null } };

export type BillingAddressLocationFragment = { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null };

export type CreateAccountLocationForProfileMutationVariables = Exact<{
  accountLocationInput: AccountLocationInput;
}>;


export type CreateAccountLocationForProfileMutation = { __typename?: 'Mutation', createAccountLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } };

export type DeleteAccountLocationForProfileMutationVariables = Exact<{
  accountID: Scalars['String'];
  accountLocationID: Scalars['String'];
}>;


export type DeleteAccountLocationForProfileMutation = { __typename?: 'Mutation', deleteAccountLocation: { __typename?: 'AccountLocation', id: string } };

export type UpdateAccountLocationForProfileMutationVariables = Exact<{
  accountLocationUpdateInput: AccountLocationUpdateInput;
}>;


export type UpdateAccountLocationForProfileMutation = { __typename?: 'Mutation', updateAccountLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } };

export type GetAccountRestrictedDomainsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAccountRestrictedDomainsQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', id: string, restrictedUserDomains: Array<string> } };

export type UpdateAccountRestrictedDomainsMutationVariables = Exact<{
  accountInput: AccountInput;
}>;


export type UpdateAccountRestrictedDomainsMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, restrictedUserDomains: Array<string> } };

export type AccountSelectorQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
}>;


export type AccountSelectorQuery = { __typename?: 'Query', listAccounts: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node: { __typename?: 'Account', id: string, name?: string | null } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type GetServiceAccountsForSettingsQueryVariables = Exact<{
  accountID: Scalars['String'];
}>;


export type GetServiceAccountsForSettingsQuery = { __typename?: 'Query', listServiceAccounts: Array<{ __typename?: 'ServiceAccount', id: string, name: string, createdAt: string, apiKeys: Array<{ __typename?: 'APIKey', id: string, keyHash: string, hashType: string, issuedAt: string, notBefore: string, notAfter: string }> }> };

export type CreateServiceAccountMutationVariables = Exact<{
  accountID: Scalars['String'];
  serviceAccountName: Scalars['String'];
}>;


export type CreateServiceAccountMutation = { __typename?: 'Mutation', createServiceAccount: { __typename?: 'ServiceAccount', id: string, name: string } };

export type CreateApiKeyForServiceAccountMutationVariables = Exact<{
  serviceAccountID: Scalars['String'];
}>;


export type CreateApiKeyForServiceAccountMutation = { __typename?: 'Mutation', createAPIKeyForServiceAccount: { __typename?: 'CreateAPIKeyResult', token: string, apiKey: { __typename?: 'APIKey', id: string, notBefore: string, notAfter: string } } };

export type GetTeamMembersForSettingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTeamMembersForSettingsQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', users: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, status: UserStatus }> } };

export type AccountUserSelectorQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AccountUserSelectorQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', id: string, users: Array<{ __typename?: 'User', id: string, name?: string | null, email: string }> } };

export type ActiveAlertsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAlertsSummaryQuery = { __typename?: 'Query', listActiveAlerts: Array<{ __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null } | { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null } | { __typename?: 'MPUOfflineAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null } | { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null } | { __typename?: 'ReservationItemAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null } | { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string } | null }> };

export type ListActiveDeviceFaultsQueryVariables = Exact<{
  deviceIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ListActiveDeviceFaultsQuery = { __typename?: 'Query', listActiveFaults: { __typename?: 'ActiveFaultConnection', edges: Array<{ __typename?: 'ActiveFaultEdge', node: { __typename?: 'ActiveFault', id: string, faultName: string, faultSeverity?: FaultSeverity | null, firstSeen: string, lastUpdate: string } }> } };

export type ActiveFaultsSummaryQueryVariables = Exact<{
  input: CountActiveFaultsBySeverityInput;
}>;


export type ActiveFaultsSummaryQuery = { __typename?: 'Query', countActiveFaultsBySeverity: Array<{ __typename?: 'SeverityCount', severity: string, count: number }> };

export type MpuOfflineAlertForReservationPageFragment = { __typename?: 'MPUOfflineAlert', lastUploadTime: string, device: { __typename?: 'DeviceInstance', id: string, name: string } };

export type MpuLowSocAlertForReservationPageFragment = { __typename?: 'MPULowSOCAlert', device: { __typename?: 'DeviceInstance', id: string, name: string } };

export type ReservationItemAllocationAlertForReservationPageFragment = { __typename?: 'ReservationItemAllocationAlert', reservationItemID: string };

export type MpuCriticalFaultAlertForReservationPageFragment = { __typename?: 'MPUCriticalFaultAlert', device: { __typename?: 'DeviceInstance', id: string, name: string } };

type ActiveAlertForReservationPage_MpuCriticalFaultAlert_Fragment = { __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

type ActiveAlertForReservationPage_MpuLowSocAlert_Fragment = { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

type ActiveAlertForReservationPage_MpuOfflineAlert_Fragment = { __typename?: 'MPUOfflineAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

type ActiveAlertForReservationPage_ReservationAllocationAlert_Fragment = { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

type ActiveAlertForReservationPage_ReservationItemAllocationAlert_Fragment = { __typename?: 'ReservationItemAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

type ActiveAlertForReservationPage_ReservationStatusMismatchAlert_Fragment = { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity };

export type ActiveAlertForReservationPageFragment = ActiveAlertForReservationPage_MpuCriticalFaultAlert_Fragment | ActiveAlertForReservationPage_MpuLowSocAlert_Fragment | ActiveAlertForReservationPage_MpuOfflineAlert_Fragment | ActiveAlertForReservationPage_ReservationAllocationAlert_Fragment | ActiveAlertForReservationPage_ReservationItemAllocationAlert_Fragment | ActiveAlertForReservationPage_ReservationStatusMismatchAlert_Fragment;

export type ListActiveReservationAlertsQueryVariables = Exact<{
  reservationID: Scalars['String'];
}>;


export type ListActiveReservationAlertsQuery = { __typename?: 'Query', listActiveAlerts: Array<{ __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'MPUOfflineAlert', lastUploadTime: string, type: AlertType, triggerTime: string, severity: AlertSeverity, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity } | { __typename?: 'ReservationItemAllocationAlert', reservationItemID: string, type: AlertType, triggerTime: string, severity: AlertSeverity } | { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity }> };

export type AvailableUnitSelectorQueryVariables = Exact<{
  availableDeviceInstancesInput: AvailableDeviceInstancesInput;
}>;


export type AvailableUnitSelectorQuery = { __typename?: 'Query', availableDeviceInstances: Array<{ __typename?: 'DeviceInstance', id: string, assetID: string, name: string }> };

export type DowntimePeriodFragment = { __typename?: 'DeviceInstanceSchedule', id: string, start: string, end: string, assignment: Assignment, internalNotes?: string | null, deviceInstance: { __typename?: 'DeviceInstance', id: string } };

export type GetDowntimePeriodQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDowntimePeriodQuery = { __typename?: 'Query', deviceInstanceSchedule: { __typename?: 'DeviceInstanceSchedule', id: string, start: string, end: string, assignment: Assignment, internalNotes?: string | null, deviceInstance: { __typename?: 'DeviceInstance', id: string } } };

export type ListMpuExternalIDsForSelectorQueryVariables = Exact<{
  ownerAccountIDs: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListMpuExternalIDsForSelectorQuery = { __typename?: 'Query', listDeviceInstances: { __typename?: 'DeviceInstanceConnection', edges: Array<{ __typename?: 'DeviceInstanceEdge', node: { __typename?: 'DeviceInstance', externalID?: string | null } }> } };

export type ListMpUsForSelectorQueryVariables = Exact<{
  ownerAccountIDs: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListMpUsForSelectorQuery = { __typename?: 'Query', listDeviceInstances: { __typename?: 'DeviceInstanceConnection', edges: Array<{ __typename?: 'DeviceInstanceEdge', node: { __typename?: 'DeviceInstance', name: string } }> } };

export type GetMpuIndexScheduleDeviceInstanceQueryVariables = Exact<{
  id: Scalars['String'];
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
}>;


export type GetMpuIndexScheduleDeviceInstanceQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, schedules?: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, createdAt: string, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string }, reservationItem?: { __typename?: 'ReservationItem', id: string, end: string, start: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, sequentialID: number, serviceArea?: { __typename?: 'ServiceArea', name: string } | null } } | null }> | null, serviceArea?: { __typename?: 'ServiceArea', name: string } | null, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number, time: string } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } };

export type MpuIndexScheduleDeviceInstanceFragment = { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null } };

export type GetMpuIndexScheduleDeviceInstanceListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
  filters: DeviceInstancePaginationFilters;
}>;


export type GetMpuIndexScheduleDeviceInstanceListQuery = { __typename?: 'Query', listDeviceInstances: { __typename?: 'DeviceInstanceConnection', edges: Array<{ __typename?: 'DeviceInstanceEdge', node: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type MpuScheduleReservationItemFragment = { __typename?: 'ReservationItem', id: string, end: string, start: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, sequentialID: number, serviceArea?: { __typename?: 'ServiceArea', name: string } | null } };

export type MpuScheduleDeviceInstanceScheduleFragment = { __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, createdAt: string, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string }, reservationItem?: { __typename?: 'ReservationItem', id: string, end: string, start: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, sequentialID: number, serviceArea?: { __typename?: 'ServiceArea', name: string } | null } } | null };

export type MpuScheduleDeviceInstanceFragment = { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, schedules?: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, createdAt: string, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string }, reservationItem?: { __typename?: 'ReservationItem', id: string, end: string, start: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, sequentialID: number, serviceArea?: { __typename?: 'ServiceArea', name: string } | null } } | null }> | null, serviceArea?: { __typename?: 'ServiceArea', name: string } | null, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number, time: string } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } };

export type GetMpuScheduleDeviceInstanceQueryVariables = Exact<{
  deviceInstanceID: Scalars['String'];
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
}>;


export type GetMpuScheduleDeviceInstanceQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, schedules?: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, createdAt: string, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string }, reservationItem?: { __typename?: 'ReservationItem', id: string, end: string, start: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, sequentialID: number, serviceArea?: { __typename?: 'ServiceArea', name: string } | null } } | null }> | null, serviceArea?: { __typename?: 'ServiceArea', name: string } | null, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number, time: string } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } };

export type ListNetsuiteCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListNetsuiteCustomersQuery = { __typename?: 'Query', listNetSuiteCustomers: Array<{ __typename?: 'NetSuiteCustomer', id: string, name: string, account?: { __typename?: 'Account', id: string, name?: string | null } | null }> };

export type ReservationScheduleDeviceInstanceScheduleFragment = { __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } };

export type ReservationScheduleReservationItemFragment = { __typename?: 'ReservationItem', id: string, alias?: string | null, end: string, start: string, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> };

export type ReservationScheduleReservationFragment = { __typename?: 'Reservation', id: string, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, end: string, start: string, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> }> };

export type GetReservationScheduleReservationQueryVariables = Exact<{
  reservationID: Scalars['String'];
}>;


export type GetReservationScheduleReservationQuery = { __typename?: 'Query', getReservation: { __typename?: 'Reservation', id: string, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, end: string, start: string, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, assignment: Assignment, end: string, start: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> }> } };

export type DeleteReservationScheduleDeviceInstanceScheduleMutationVariables = Exact<{
  deviceScheduleID: Scalars['String'];
}>;


export type DeleteReservationScheduleDeviceInstanceScheduleMutation = { __typename?: 'Mutation', deleteDeviceSchedule: { __typename?: 'DeviceInstanceSchedule', id: string } };

export type PersistReservationScheduleDeviceInstanceSchedulesMutationVariables = Exact<{
  input: CreateSchedulesInput;
}>;


export type PersistReservationScheduleDeviceInstanceSchedulesMutation = { __typename?: 'Mutation', createSchedules: Array<{ __typename?: 'DeviceInstanceSchedule', id: string }> };

export type ListReservationsForSelectorQueryVariables = Exact<{
  statuses?: InputMaybe<Array<ReservationStatus> | ReservationStatus>;
}>;


export type ListReservationsForSelectorQuery = { __typename?: 'Query', listReservations: Array<{ __typename?: 'Reservation', id: string, name?: string | null }> };

export type ListRolesQueryVariables = Exact<{
  grantorUserID: Scalars['String'];
}>;


export type ListRolesQuery = { __typename?: 'Query', listGrantableRoles: Array<{ __typename?: 'Role', name: string }> };

export type ListMpuSerialNumbersForSelectorQueryVariables = Exact<{
  ownerAccountIDs: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListMpuSerialNumbersForSelectorQuery = { __typename?: 'Query', listDeviceInstances: { __typename?: 'DeviceInstanceConnection', edges: Array<{ __typename?: 'DeviceInstanceEdge', node: { __typename?: 'DeviceInstance', serialNumber?: string | null } }> } };

export type ListServiceAreasForSelectorQueryVariables = Exact<{
  accountID: Scalars['String'];
}>;


export type ListServiceAreasForSelectorQuery = { __typename?: 'Query', listServiceAreas: Array<{ __typename?: 'ServiceArea', id: string, name: string }> };

export type GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables = Exact<{
  availableDeviceInstancesInput: AvailableDeviceInstancesInput;
}>;


export type GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery = { __typename?: 'Query', availableDeviceInstances: Array<{ __typename?: 'DeviceInstance', id: string }> };

export type GetHistoricalFaultsQueryVariables = Exact<{
  id: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  faultNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetHistoricalFaultsQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, historicalFaults?: Array<{ __typename?: 'ActiveFault', id: string, faultName: string, firstSeen: string, resolved?: string | null, faultSeverity?: FaultSeverity | null }> | null } };

export type MpuOfflineAlertForAlertsPageFragment = { __typename?: 'MPUOfflineAlert', lastUploadTime: string, device: { __typename?: 'DeviceInstance', id: string, name: string } };

export type MpuLowSocAlertForAlertsPageFragment = { __typename?: 'MPULowSOCAlert', device: { __typename?: 'DeviceInstance', id: string, name: string } };

export type ReservationItemAllocationAlertForAlertsPageFragment = { __typename?: 'ReservationItemAllocationAlert', reservationItemID: string };

export type ReservationAllocationAlertForAlertsPageFragment = { __typename?: 'ReservationAllocationAlert', reservationItemIDs: Array<string> };

export type MpuCriticalFaultAlertForAlertsPageFragment = { __typename?: 'MPUCriticalFaultAlert', device: { __typename?: 'DeviceInstance', id: string, name: string }, fault: { __typename?: 'ActiveFault', faultName: string } };

export type ReservationForAlertsPageFragment = { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> };

export type AccountForAlertsPageFragment = { __typename?: 'Account', id: string, name?: string | null };

type ActiveAlertForAlertsPage_MpuCriticalFaultAlert_Fragment = { __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

type ActiveAlertForAlertsPage_MpuLowSocAlert_Fragment = { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

type ActiveAlertForAlertsPage_MpuOfflineAlert_Fragment = { __typename?: 'MPUOfflineAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

type ActiveAlertForAlertsPage_ReservationAllocationAlert_Fragment = { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

type ActiveAlertForAlertsPage_ReservationItemAllocationAlert_Fragment = { __typename?: 'ReservationItemAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

type ActiveAlertForAlertsPage_ReservationStatusMismatchAlert_Fragment = { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } };

export type ActiveAlertForAlertsPageFragment = ActiveAlertForAlertsPage_MpuCriticalFaultAlert_Fragment | ActiveAlertForAlertsPage_MpuLowSocAlert_Fragment | ActiveAlertForAlertsPage_MpuOfflineAlert_Fragment | ActiveAlertForAlertsPage_ReservationAllocationAlert_Fragment | ActiveAlertForAlertsPage_ReservationItemAllocationAlert_Fragment | ActiveAlertForAlertsPage_ReservationStatusMismatchAlert_Fragment;

export type ListActiveAlertsQueryVariables = Exact<{
  reservationIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ListActiveAlertsQuery = { __typename?: 'Query', listActiveAlerts: Array<{ __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string }, fault: { __typename?: 'ActiveFault', faultName: string } } | { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'MPUOfflineAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, lastUploadTime: string, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservationItemIDs: Array<string>, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } } | { __typename?: 'ReservationItemAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservationItemID: string, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } } | { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } }> };

export type GlobalListDeviceModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalListDeviceModelsQuery = { __typename?: 'Query', listDeviceModels: Array<{ __typename?: 'DeviceModel', id: string, name?: string | null }> };

export type ValidateInviteKeyQueryVariables = Exact<{
  inviteKey: Scalars['String'];
}>;


export type ValidateInviteKeyQuery = { __typename?: 'Query', validateInviteKey: { __typename?: 'ValidateInviteKeyResult', exists: boolean, isClaimed: boolean, isExpired: boolean } };

export type GetReservationWithPaymentInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReservationWithPaymentInfoQuery = { __typename?: 'Query', userReservationPaymentInfo: { __typename?: 'ReservationPaymentOutput', reservation: { __typename?: 'Reservation', id: string, status: ReservationStatus, createdAt: string, additionalNotes?: string | null, reservation_seq_id: number, account: { __typename?: 'Account', id: string, name?: string | null }, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, start: string, end: string, quantity?: number | null, pickupDate?: string | null, deliveryDate?: string | null, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, pickupLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null }, deliveryLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null } }> } } };

export type UserSubmitReservationRequestMutationVariables = Exact<{
  input: SubmitReservationRequestInput;
}>;


export type UserSubmitReservationRequestMutation = { __typename?: 'Mutation', submitReservationRequest: { __typename?: 'Reservation', id: string } };

export type GetUserSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSessionQuery = { __typename?: 'Query', currentUserSession: { __typename?: 'CurrentUserResult', id: string, email: string, name: string, userRoles: Array<string>, userPermissions?: Array<string> | null, admin?: boolean | null, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null, accountRoles?: Array<{ __typename?: 'AccountRole', name: string }> | null }> } };

export type LogOutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogOutUserMutation = { __typename?: 'Mutation', logoutUser: { __typename?: 'LogoutResult', logout: boolean } };

export type GetReservationItemTelemetryQueryVariables = Exact<{
  input: ReservationTelemetryInput;
}>;


export type GetReservationItemTelemetryQuery = { __typename?: 'Query', reservationTelemetry: { __typename?: 'TelemetryResult', telemetries: Array<{ __typename?: 'Telemetry', metric: string, datapoints: Array<{ __typename?: 'TelemetryValue', value?: number | null, timestamp: string }> }> } };

export type GetDeviceTelemetryQueryVariables = Exact<{
  input: DeviceTelemetryInput;
}>;


export type GetDeviceTelemetryQuery = { __typename?: 'Query', deviceTelemetry: { __typename?: 'TelemetryResult', telemetries: Array<{ __typename?: 'Telemetry', metric: string, datapoints: Array<{ __typename?: 'TelemetryValue', value?: number | null, timestamp: string }> }> } };

export type GetReservationItemLatestTelemetryQueryVariables = Exact<{
  id: Scalars['String'];
  metricNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetReservationItemLatestTelemetryQuery = { __typename?: 'Query', reservationLatestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } };

export type GetDeviceLatestTelemetryQueryVariables = Exact<{
  id: Scalars['String'];
  metricNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetDeviceLatestTelemetryQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } };

export type GetEnergyUsageForMpuQueryVariables = Exact<{
  id: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  groupBy: GroupByInterval;
}>;


export type GetEnergyUsageForMpuQuery = { __typename?: 'Query', deviceEnergyUsage: { __typename?: 'TelemetryResult', telemetries: Array<{ __typename?: 'Telemetry', metric: string, datapoints: Array<{ __typename?: 'TelemetryValue', value?: number | null, timestamp: string }> }> } };

export type GetEnergyUsageForUnitQueryVariables = Exact<{
  id: Scalars['String'];
  groupBy: GroupByInterval;
}>;


export type GetEnergyUsageForUnitQuery = { __typename?: 'Query', reservationEnergyUsage: { __typename?: 'TelemetryResult', telemetries: Array<{ __typename?: 'Telemetry', metric: string, datapoints: Array<{ __typename?: 'TelemetryValue', value?: number | null, timestamp: string }> }> } };

export type GetMpuBasicDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMpuBasicDetailsQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, serialNumber?: string | null, externalID?: string | null, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, owner?: { __typename?: 'Account', id: string, name?: string | null } | null } };

export type GetMpuSpotlightStatsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMpuSpotlightStatsQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, latestDataTimestamp?: string | null, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number, time: string } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } };

export type CreateDeviceInstanceMutationVariables = Exact<{
  input: CreateDeviceInstanceInput;
}>;


export type CreateDeviceInstanceMutation = { __typename?: 'Mutation', createDeviceInstance: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null } };

export type UpdateDeviceInstanceMutationVariables = Exact<{
  input: UpdateDeviceInstanceInput;
}>;


export type UpdateDeviceInstanceMutation = { __typename?: 'Mutation', updateDeviceInstance: { __typename?: 'DeviceInstance', id: string, name: string, assetID: string, serialNumber?: string | null, externalID?: string | null, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null } };

export type DeleteDeviceInstanceMutationVariables = Exact<{
  deviceInstanceID: Scalars['String'];
}>;


export type DeleteDeviceInstanceMutation = { __typename?: 'Mutation', deleteDeviceInstance: { __typename?: 'DeviceInstance', id: string } };

export type ListDeviceModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDeviceModelsQuery = { __typename?: 'Query', listDeviceModels: Array<{ __typename?: 'DeviceModel', id: string, name?: string | null }> };

export type ListAccountsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
  filters?: InputMaybe<AccountPaginationFilters>;
}>;


export type ListAccountsQuery = { __typename?: 'Query', listAccounts: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', node: { __typename?: 'Account', id: string, name?: string | null, industry?: string | null } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type CreateAccountMutationVariables = Exact<{
  accountDetails: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string } };

export type GetMoxionRepsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMoxionRepsQuery = { __typename?: 'Query', listAllowedMoxionReps: Array<{ __typename?: 'User', id: string, name?: string | null, roles: Array<{ __typename?: 'Role', name: string }> }> };

export type AccountPageBillingAddressLocationFragment = { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null };

export type BasicDetailsFragment = { __typename?: 'Account', id: string, industry?: string | null, type?: string | null, name?: string | null, contactPhone?: string | null, restrictedUserDomains: Array<string>, pointOfContact?: string | null, moxionInternalNotes?: string | null, createdAt: string, netsuiteCustomers?: Array<{ __typename?: 'NetSuiteCustomer', id: string }> | null, moxionReps?: Array<{ __typename?: 'User', id: string, name?: string | null }> | null, billingAddressLocation?: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAccountQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', createdAt: string, updatedAt?: string | null, id: string, industry?: string | null, type?: string | null, name?: string | null, contactPhone?: string | null, restrictedUserDomains: Array<string>, pointOfContact?: string | null, moxionInternalNotes?: string | null, invites: Array<{ __typename?: 'Invite', id: string, email: string }>, accountRoles?: Array<{ __typename?: 'AccountRole', name: string }> | null, netsuiteCustomers?: Array<{ __typename?: 'NetSuiteCustomer', id: string }> | null, moxionReps?: Array<{ __typename?: 'User', id: string, name?: string | null }> | null, billingAddressLocation?: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } | null }, listUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, name?: string | null, email: string, status: UserStatus, roles: Array<{ __typename?: 'Role', name: string }> } }> } };

export type UpdateAccountBasicsMutationVariables = Exact<{
  accountInput: AccountInput;
}>;


export type UpdateAccountBasicsMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, industry?: string | null, type?: string | null, name?: string | null, contactPhone?: string | null, restrictedUserDomains: Array<string>, pointOfContact?: string | null, moxionInternalNotes?: string | null, createdAt: string, netsuiteCustomers?: Array<{ __typename?: 'NetSuiteCustomer', id: string }> | null, moxionReps?: Array<{ __typename?: 'User', id: string, name?: string | null }> | null, billingAddressLocation?: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } | null } };

export type AssociateNetSuiteCustomerWithAccountMutationVariables = Exact<{
  input: AssociateNetSuiteCustomerWithAccountInput;
}>;


export type AssociateNetSuiteCustomerWithAccountMutation = { __typename?: 'Mutation', associateNetSuiteCustomerWithAccount: { __typename?: 'Account', id: string, netsuiteCustomers?: Array<{ __typename?: 'NetSuiteCustomer', id: string }> | null } };

export type DeleteAccountMutationVariables = Exact<{
  accountID: Scalars['String'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'Account', id: string } };

export type AddAccountRolesMutationVariables = Exact<{
  input: ModifyAccountRolesInput;
}>;


export type AddAccountRolesMutation = { __typename?: 'Mutation', addAccountRoles: { __typename?: 'Account', id: string, accountRoles?: Array<{ __typename?: 'AccountRole', name: string }> | null } };

export type RemoveAccountRolesMutationVariables = Exact<{
  input: ModifyAccountRolesInput;
}>;


export type RemoveAccountRolesMutation = { __typename?: 'Mutation', removeAccountRoles: { __typename?: 'Account', id: string, accountRoles?: Array<{ __typename?: 'AccountRole', name: string }> | null } };

export type GetAccountRolesForAccountQueryVariables = Exact<{
  accountID: Scalars['String'];
}>;


export type GetAccountRolesForAccountQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', accountRoles?: Array<{ __typename?: 'AccountRole', name: string }> | null } };

export type ListUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
  filters?: InputMaybe<UserPaginationFilters>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, name?: string | null, email: string, status: UserStatus, roles: Array<{ __typename?: 'Role', name: string }>, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type GetUserQueryVariables = Exact<{
  userID: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, name?: string | null, active: boolean, email: string, phoneNumber?: string | null, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }>, roles: Array<{ __typename?: 'Role', name: string }> } | null };

export type ListUserRolesQueryVariables = Exact<{
  userID: Scalars['String'];
}>;


export type ListUserRolesQuery = { __typename?: 'Query', listUserRoles: Array<string> };

export type AddUserRolesMutationVariables = Exact<{
  input: ModifyUserRolesInput;
}>;


export type AddUserRolesMutation = { __typename?: 'Mutation', addUserRoles: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'Role', name: string }> } };

export type RemoveUserRolesMutationVariables = Exact<{
  input: ModifyUserRolesInput;
}>;


export type RemoveUserRolesMutation = { __typename?: 'Mutation', removeUserRoles: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'Role', name: string }> } };

export type UpdateUserMutationVariables = Exact<{
  userInput: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name?: string | null, status: UserStatus, email: string, phoneNumber?: string | null, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }> } };

export type DeactivateUserMutationVariables = Exact<{
  userID: Scalars['String'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser?: { __typename?: 'User', id: string, status: UserStatus } | null };

export type ActivateUserMutationVariables = Exact<{
  userID: Scalars['String'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser?: { __typename?: 'User', id: string, status: UserStatus } | null };

export type ListAllAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllAccountsQuery = { __typename?: 'Query', listAccounts: { __typename?: 'AccountConnection', edges: Array<{ __typename?: 'AccountEdge', cursor: string, node: { __typename?: 'Account', id: string, name?: string | null } }> } };

export type ListAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllRolesQuery = { __typename?: 'Query', listRoles: Array<{ __typename?: 'Role', name: string }> };

export type AddItemsToReservationMutationVariables = Exact<{
  input: AddReservationItemsToReservationInput;
}>;


export type AddItemsToReservationMutation = { __typename?: 'Mutation', addItemsToReservation: { __typename?: 'Reservation', id: string, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, start: string, end: string, pickupLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deliveryLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, start: string, end: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> }> } };

export type LocationForReservationPageFragment = { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null };

export type ReservationItemForReservationPageFragment = { __typename?: 'ReservationItem', id: string, alias?: string | null, start: string, end: string, pickupLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deliveryLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, start: string, end: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> };

export type GetReservationQueryVariables = Exact<{
  reservationId: Scalars['String'];
}>;


export type GetReservationQuery = { __typename?: 'Query', getReservation: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, type: ReservationType, createdAt: string, additionalNotes?: string | null, reservation_seq_id: number, fulfillerNotes?: string | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, account: { __typename?: 'Account', id: string, name?: string | null, industry?: string | null, contactPhone?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null, email: string }, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, start: string, end: string, pickupLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deliveryLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactPhone?: string | null, contactName?: string | null, lat?: number | null, lon?: number | null }, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', id: string, start: string, end: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }> }> } };

export type ListReservationsAllowedStatusTransitionsQueryVariables = Exact<{
  reservationId: Scalars['String'];
}>;


export type ListReservationsAllowedStatusTransitionsQuery = { __typename?: 'Query', reservationsAllowedStatusTransitions: { __typename?: 'StateTransitions', allowedTransitions: Array<ReservationStatus> } };

export type UpdateReservationMutationVariables = Exact<{
  reservationInput: ReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation: { __typename?: 'Reservation', id: string, name?: string | null, type: ReservationType, fulfillerNotes?: string | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null } };

export type UpdateReservationStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: ReservationStatus;
}>;


export type UpdateReservationStatusMutation = { __typename?: 'Mutation', updateReservation: { __typename?: 'Reservation', id: string, status: ReservationStatus } };

export type UpdateReservationItemMutationVariables = Exact<{
  input: ReservationItemUpdateInput;
}>;


export type UpdateReservationItemMutation = { __typename?: 'Mutation', updateReservationItem: { __typename?: 'ReservationItem', id: string, start: string, end: string } };

export type ReservationTelemetrySummaryQueryVariables = Exact<{
  input: ReservationTelemetrySummaryInput;
}>;


export type ReservationTelemetrySummaryQuery = { __typename?: 'Query', reservationTelemetrySummary: { __typename?: 'ReservationTelemetrySummaryResult', chargeDischargeTimes?: Array<{ __typename?: 'ChargeDischargeTimeSummaryResult', unit: string }> | null, chargeDischargeTotals?: Array<{ __typename?: 'ChargeDischargeTotalsSummaryResult', average_load_kw_reservation: number, average_load_kw_unit: number, battery_capacity_used_percent_reservation: number, battery_capacity_used_percent_unit: number, e_cap_kwh_reservation: number, e_cap_kwh_unit: number, total_charge_hours_unit: number, total_charge_kwh_reservation: number, total_charge_kwh_unit: number, total_discharge_hours_unit: number, total_discharge_kwh_reservation: number, total_discharge_kwh_unit: number, unit: string }> | null, faults?: Array<{ __typename?: 'ReservationFaultSummaryResult', total_critical_faults_reservation: number, total_critical_faults_unit: number, total_faults_reservation: number, total_faults_unit: number, unit: string }> | null, maxContinousLoad?: Array<{ __typename?: 'MaxContinuousLoadSummaryResult', maximum_continuous_load_kw_unit: number, maximum_continuous_load_reservation: number, unit: string }> | null } };

export type ListReservationItemsByReservationStatusQueryVariables = Exact<{
  filterMode?: InputMaybe<FilterMode>;
  time: Scalars['DateTime'];
}>;


export type ListReservationItemsByReservationStatusQuery = { __typename?: 'Query', listReservationItemsByReservationStatus: Array<{ __typename?: 'ReservationItem', id: string, createdAt: string, start: string, end: string, quantity?: number | null, alias?: string | null, assignedDevice?: { __typename?: 'DeviceInstance', id: string, name: string } | null, deviceInstanceSchedule: Array<{ __typename?: 'DeviceInstanceSchedule', assignment: Assignment, start: string, end: string, deviceInstance: { __typename?: 'DeviceInstance', id: string, name: string } }>, reservation: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, type: ReservationType, createdAt: string, account: { __typename?: 'Account', name?: string | null }, userRequested: { __typename?: 'User', name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, activeAlerts: Array<{ __typename?: 'MPUCriticalFaultAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string }, fault: { __typename?: 'ActiveFault', faultName: string } } | { __typename?: 'MPULowSOCAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'MPUOfflineAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, lastUploadTime: string, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null }, device: { __typename?: 'DeviceInstance', id: string, name: string } } | { __typename?: 'ReservationAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } } | { __typename?: 'ReservationItemAllocationAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservationItemID: string, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } } | { __typename?: 'ReservationStatusMismatchAlert', type: AlertType, triggerTime: string, severity: AlertSeverity, reservation?: { __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, account: { __typename?: 'Account', id: string, name?: string | null }, userRequested: { __typename?: 'User', id: string, name?: string | null }, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, reservationItems: Array<{ __typename?: 'ReservationItem', start: string, end: string }> } | null, account: { __typename?: 'Account', id: string, name?: string | null } }> } }> };

export type GetReservationStatusCountsQueryVariables = Exact<{
  fulfillerAccountID: Scalars['String'];
}>;


export type GetReservationStatusCountsQuery = { __typename?: 'Query', countReservationsByStatus: { __typename?: 'ReservationStatusCounts', requested: number, confirmed: number, started: number } };

export type ReservationForCustomerReservationsPageFragment = { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus };

export type BaseReservationItemForCustomerReservationsPageFragment = { __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } };

export type BaseReservationItemWithReservationForCustomerReservationsPageFragment = { __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus }, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } };

export type FullReservationItemForCustomerReservationsPageFragment = { __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, assignedDevice?: { __typename?: 'DeviceInstance', id: string, assetID: string, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } | null, reservation: { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus }, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } };

export type ListCurrentReservationsForCustomerReservationsPageQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
  assignment: Scalars['String'];
  telemetryEnd: Scalars['DateTime'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type ListCurrentReservationsForCustomerReservationsPageQuery = { __typename?: 'Query', listReservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, assignedDevice?: { __typename?: 'DeviceInstance', id: string, assetID: string, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } | null, reservation: { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus }, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } }> };

export type ListUpcomingReservationsForCustomerReservationsPageQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type ListUpcomingReservationsForCustomerReservationsPageQuery = { __typename?: 'Query', listReservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus }, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } }> };

export type ListPastReservationsForCustomerReservationsPageQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type ListPastReservationsForCustomerReservationsPageQuery = { __typename?: 'Query', listReservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, reservation: { __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus }, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } }> };

export type ListCancelledReservationsForCustomerReservationsPageQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
}>;


export type ListCancelledReservationsForCustomerReservationsPageQuery = { __typename?: 'Query', listReservations: Array<{ __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } }> }> };

export type ListDeclinedReservationsForCustomerReservationsPageQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
}>;


export type ListDeclinedReservationsForCustomerReservationsPageQuery = { __typename?: 'Query', listReservations: Array<{ __typename?: 'Reservation', id: string, name?: string | null, additionalNotes?: string | null, status: ReservationStatus, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, createdAt: string, deliveryLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null }, pickupLocation: { __typename?: 'AccountLocation', formattedAddress?: string | null } }> }> };

export type CancelReservationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', cancelReservation: { __typename?: 'Reservation', id: string, status: ReservationStatus } };

export type ListEventSubscriptionsQueryVariables = Exact<{
  userID: Scalars['String'];
}>;


export type ListEventSubscriptionsQuery = { __typename?: 'Query', listEventSubscriptions: Array<{ __typename?: 'EventSubscription', id: string, eventName: string, channels?: Array<NotificationChannel> | null }> };

export type UpsertEventSubscriptionMutationVariables = Exact<{
  input: UpdateEventSubscriptionInput;
}>;


export type UpsertEventSubscriptionMutation = { __typename?: 'Mutation', upsertEventSubscription: { __typename?: 'EventSubscription', id: string, eventName: string, channels?: Array<NotificationChannel> | null } };

export type GetAccountForProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAccountForProfileQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', id: string, name?: string | null, contactPhone?: string | null, restrictedUserDomains: Array<string>, billingAddressLocation?: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } | null } };

export type UpdateAccountMutationVariables = Exact<{
  accountInput: AccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, industry?: string | null, name?: string | null, contactPhone?: string | null, billingAddressLocation?: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null, contactName?: string | null, contactPhone?: string | null, placeId?: string | null, notes?: string | null } | null } };

export type ListActiveReservationItemsQueryVariables = Exact<{
  requesterAccountID: Scalars['String'];
  end: Scalars['DateTime'];
}>;


export type ListActiveReservationItemsQuery = { __typename?: 'Query', listReservations: Array<{ __typename?: 'Reservation', id: string, name?: string | null, status: ReservationStatus, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, start: string, end: string, alias?: string | null, quantity?: number | null, createdAt: string, deliveryLocation: { __typename?: 'AccountLocation', id: string, formattedAddress?: string | null }, assignedDevice?: { __typename?: 'DeviceInstance', id: string, assetID: string, name: string, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number } | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } | null }> }> };

export type GetReservationDetailsForMonitoringQueryVariables = Exact<{
  id: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type GetReservationDetailsForMonitoringQuery = { __typename?: 'Query', getReservation: { __typename?: 'Reservation', id: string, name?: string | null, reservationItems: Array<{ __typename?: 'ReservationItem', id: string, alias?: string | null, start: string, end: string, assignedDevice?: { __typename?: 'DeviceInstance', id: string, name: string, latestDataTimestamp?: string | null, latestDeviceLocation?: { __typename?: 'DeviceLocation', lat: number, lon: number } | null, telemetry: { __typename?: 'TelemetryResult', telemetries: Array<{ __typename?: 'Telemetry', assetId?: string | null, metric: string, datapoints: Array<{ __typename?: 'TelemetryValue', value?: number | null, timestamp: string }> }> } } | null }> } };

export type SubmitResetPasswordTokenMutationVariables = Exact<{
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
}>;


export type SubmitResetPasswordTokenMutation = { __typename?: 'Mutation', submitResetPasswordToken: { __typename?: 'SubmitResetPasswordTokenResult', reset: boolean } };

export type LogInUserMutationVariables = Exact<{
  loginInput: LoginInput;
}>;


export type LogInUserMutation = { __typename?: 'Mutation', loginUser: { __typename?: 'SessionResult', id: string, requires2FA: boolean, accounts: Array<{ __typename?: 'Account', id: string }> } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResult', requested: boolean } };

export type SignUpUserMutationVariables = Exact<{
  signUpUserInput: CreateUserInput;
}>;


export type SignUpUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'SessionResult', id: string, accounts: Array<{ __typename?: 'Account', id: string }> } };

export type ListScheduleTransitionsQueryVariables = Exact<{
  input: ListScheduleTransitionsInput;
}>;


export type ListScheduleTransitionsQuery = { __typename?: 'Query', listScheduleTransitions: Array<{ __typename?: 'ScheduleTransition', type: string, time: string, from?: { __typename?: 'DeviceInstanceSchedule', id: string, reservationItem?: { __typename?: 'ReservationItem', id: string, reservation: { __typename?: 'Reservation', id: string } } | null } | null, to?: { __typename?: 'DeviceInstanceSchedule', id: string, reservationItem?: { __typename?: 'ReservationItem', id: string, reservation: { __typename?: 'Reservation', id: string } } | null } | null }> };

export type GetMpuBuildDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMpuBuildDetailsQuery = { __typename?: 'Query', getDeviceInstance: { __typename?: 'DeviceInstance', id: string, serialNumber?: string | null, firmwareVersions: { __typename?: 'DeviceFirmwareVersionsV1Result', bmsVersion: string, ecuVersion: string, evccVersion: string, pmcVersion: string, tguVersion: string }, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> } } };

export type ActiveFaultsPageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  ownerAccountID?: InputMaybe<Scalars['String']>;
  deviceIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  severities?: InputMaybe<Array<FaultSeverity> | FaultSeverity>;
  sortBy?: InputMaybe<KeyOfSortArg>;
}>;


export type ActiveFaultsPageQuery = { __typename?: 'Query', listActiveFaults: { __typename?: 'ActiveFaultConnection', edges: Array<{ __typename?: 'ActiveFaultEdge', cursor: string, node: { __typename?: 'ActiveFault', id: string, faultSeverity?: FaultSeverity | null, faultName: string, firstSeen: string, lastUpdate: string, device: { __typename?: 'DeviceInstance', id: string, name: string, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null, totalEdges?: number | null } } };

export type MpuIndexDeviceInstanceFragment = { __typename?: 'DeviceInstance', id: string, serialNumber?: string | null, externalID?: string | null, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, schedulesIntersecting?: Array<{ __typename?: 'DeviceInstanceSchedule', start: string, end: string, assignment: Assignment }> | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> }, activeFaults?: Array<{ __typename?: 'ActiveFault', id: string, faultSeverity?: FaultSeverity | null, faultName: string }> | null };

export type MpuIndexDeviceLocationFragment = { __typename?: 'DeviceLocation', deviceID: string, lat: number, lon: number, time: string };

export type ListDeviceInstancesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<KeyOfSortArg>;
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  filters: DeviceInstancePaginationFilters;
}>;


export type ListDeviceInstancesQuery = { __typename?: 'Query', listDeviceInstances: { __typename?: 'DeviceInstanceConnection', edges: Array<{ __typename?: 'DeviceInstanceEdge', node: { __typename?: 'DeviceInstance', id: string, serialNumber?: string | null, externalID?: string | null, name: string, assetID: string, deviceModel: { __typename?: 'DeviceModel', id: string, name?: string | null }, owner?: { __typename?: 'Account', id: string, name?: string | null } | null, serviceArea?: { __typename?: 'ServiceArea', id: string, name: string } | null, schedulesIntersecting?: Array<{ __typename?: 'DeviceInstanceSchedule', start: string, end: string, assignment: Assignment }> | null, latestTelemetry: { __typename?: 'LatestTelemetriesResult', telemetryPoints: Array<{ __typename?: 'TelemetryPoint', metric: string, timestamp: string, value: number }> }, activeFaults?: Array<{ __typename?: 'ActiveFault', id: string, faultSeverity?: FaultSeverity | null, faultName: string }> | null } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null, hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type ListLatestMpuLocationsQueryVariables = Exact<{
  ownerAccountIDs: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListLatestMpuLocationsQuery = { __typename?: 'Query', listDeviceLocations: Array<{ __typename?: 'DeviceLocation', deviceID: string, lat: number, lon: number, time: string }> };

export type ListServiceAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type ListServiceAreasQuery = { __typename?: 'Query', listServiceAreas: Array<{ __typename?: 'ServiceArea', id: string, name: string }> };

export const BillingAddressLocationFragmentDoc = gql`
    fragment BillingAddressLocation on AccountLocation {
  id
  formattedAddress
  contactName
  contactPhone
  placeId
  notes
}
    `;
export const MpuOfflineAlertForReservationPageFragmentDoc = gql`
    fragment MPUOfflineAlertForReservationPage on MPUOfflineAlert {
  device {
    id
    name
  }
  lastUploadTime
}
    `;
export const MpuLowSocAlertForReservationPageFragmentDoc = gql`
    fragment MPULowSOCAlertForReservationPage on MPULowSOCAlert {
  device {
    id
    name
  }
}
    `;
export const ReservationItemAllocationAlertForReservationPageFragmentDoc = gql`
    fragment ReservationItemAllocationAlertForReservationPage on ReservationItemAllocationAlert {
  reservationItemID
}
    `;
export const MpuCriticalFaultAlertForReservationPageFragmentDoc = gql`
    fragment MPUCriticalFaultAlertForReservationPage on MPUCriticalFaultAlert {
  device {
    id
    name
  }
}
    `;
export const ActiveAlertForReservationPageFragmentDoc = gql`
    fragment ActiveAlertForReservationPage on Alert {
  type
  triggerTime
  severity
}
    `;
export const DowntimePeriodFragmentDoc = gql`
    fragment DowntimePeriod on DeviceInstanceSchedule {
  id
  start
  end
  assignment
  internalNotes
  deviceInstance {
    id
  }
}
    `;
export const MpuIndexScheduleDeviceInstanceFragmentDoc = gql`
    fragment MpuIndexScheduleDeviceInstance on DeviceInstance {
  id
  name
  assetID
  deviceModel {
    id
    name
  }
}
    `;
export const MpuScheduleReservationItemFragmentDoc = gql`
    fragment MpuScheduleReservationItem on ReservationItem {
  id
  end
  start
  reservation {
    id
    name
    sequentialID: reservation_seq_id
    serviceArea {
      name
    }
  }
}
    `;
export const MpuScheduleDeviceInstanceScheduleFragmentDoc = gql`
    fragment MpuScheduleDeviceInstanceSchedule on DeviceInstanceSchedule {
  id
  assignment
  createdAt
  end
  start
  deviceInstance {
    id
  }
  reservationItem {
    ...MpuScheduleReservationItem
  }
}
    ${MpuScheduleReservationItemFragmentDoc}`;
export const MpuScheduleDeviceInstanceFragmentDoc = gql`
    fragment MpuScheduleDeviceInstance on DeviceInstance {
  id
  name
  assetID
  deviceModel {
    id
    name
  }
  owner {
    id
    name
  }
  schedules: schedulesIntersecting(end: $end, start: $start) {
    ...MpuScheduleDeviceInstanceSchedule
  }
  serviceArea {
    name
  }
  latestDeviceLocation {
    lat
    lon
    time
  }
  latestTelemetry(metrics: ["soc", "s_time_to_empty"]) {
    telemetryPoints {
      metric
      timestamp
      value
    }
  }
}
    ${MpuScheduleDeviceInstanceScheduleFragmentDoc}`;
export const ReservationScheduleDeviceInstanceScheduleFragmentDoc = gql`
    fragment ReservationScheduleDeviceInstanceSchedule on DeviceInstanceSchedule {
  id
  assignment
  end
  start
  deviceInstance {
    id
    name
  }
}
    `;
export const ReservationScheduleReservationItemFragmentDoc = gql`
    fragment ReservationScheduleReservationItem on ReservationItem {
  id
  alias
  end
  start
  deviceInstanceSchedule {
    ...ReservationScheduleDeviceInstanceSchedule
  }
}
    ${ReservationScheduleDeviceInstanceScheduleFragmentDoc}`;
export const ReservationScheduleReservationFragmentDoc = gql`
    fragment ReservationScheduleReservation on Reservation {
  id
  reservationItems {
    ...ReservationScheduleReservationItem
  }
}
    ${ReservationScheduleReservationItemFragmentDoc}`;
export const MpuOfflineAlertForAlertsPageFragmentDoc = gql`
    fragment MPUOfflineAlertForAlertsPage on MPUOfflineAlert {
  device {
    id
    name
  }
  lastUploadTime
}
    `;
export const MpuLowSocAlertForAlertsPageFragmentDoc = gql`
    fragment MPULowSOCAlertForAlertsPage on MPULowSOCAlert {
  device {
    id
    name
  }
}
    `;
export const ReservationItemAllocationAlertForAlertsPageFragmentDoc = gql`
    fragment ReservationItemAllocationAlertForAlertsPage on ReservationItemAllocationAlert {
  reservationItemID
}
    `;
export const ReservationAllocationAlertForAlertsPageFragmentDoc = gql`
    fragment ReservationAllocationAlertForAlertsPage on ReservationAllocationAlert {
  reservationItemIDs
}
    `;
export const MpuCriticalFaultAlertForAlertsPageFragmentDoc = gql`
    fragment MPUCriticalFaultAlertForAlertsPage on MPUCriticalFaultAlert {
  device {
    id
    name
  }
  fault {
    faultName
  }
}
    `;
export const ReservationForAlertsPageFragmentDoc = gql`
    fragment ReservationForAlertsPage on Reservation {
  id
  name
  status
  account {
    id
    name
  }
  userRequested {
    id
    name
  }
  serviceArea {
    id
    name
  }
  reservationItems {
    start
    end
  }
}
    `;
export const AccountForAlertsPageFragmentDoc = gql`
    fragment AccountForAlertsPage on Account {
  id
  name
}
    `;
export const ActiveAlertForAlertsPageFragmentDoc = gql`
    fragment ActiveAlertForAlertsPage on Alert {
  type
  triggerTime
  severity
  reservation {
    ...ReservationForAlertsPage
  }
  account {
    ...AccountForAlertsPage
  }
}
    ${ReservationForAlertsPageFragmentDoc}
${AccountForAlertsPageFragmentDoc}`;
export const AccountPageBillingAddressLocationFragmentDoc = gql`
    fragment AccountPageBillingAddressLocation on AccountLocation {
  id
  formattedAddress
  contactName
  contactPhone
  placeId
  notes
}
    `;
export const BasicDetailsFragmentDoc = gql`
    fragment BasicDetails on Account {
  id
  industry
  type
  name
  contactPhone
  restrictedUserDomains
  pointOfContact
  moxionInternalNotes
  createdAt
  netsuiteCustomers {
    id
  }
  moxionReps {
    id
    name
  }
  billingAddressLocation {
    ...AccountPageBillingAddressLocation
  }
}
    ${AccountPageBillingAddressLocationFragmentDoc}`;
export const LocationForReservationPageFragmentDoc = gql`
    fragment LocationForReservationPage on AccountLocation {
  id
  formattedAddress
  contactPhone
  contactName
  lat
  lon
}
    `;
export const ReservationItemForReservationPageFragmentDoc = gql`
    fragment ReservationItemForReservationPage on ReservationItem {
  id
  alias
  start
  end
  pickupLocation {
    ...LocationForReservationPage
  }
  deliveryLocation {
    ...LocationForReservationPage
  }
  deviceModel {
    id
    name
  }
  deviceInstanceSchedule {
    id
    start
    end
    deviceInstance {
      id
      name
    }
  }
}
    ${LocationForReservationPageFragmentDoc}`;
export const BaseReservationItemForCustomerReservationsPageFragmentDoc = gql`
    fragment BaseReservationItemForCustomerReservationsPage on ReservationItem {
  id
  start
  end
  alias
  createdAt
  deliveryLocation {
    formattedAddress
  }
  pickupLocation {
    formattedAddress
  }
}
    `;
export const ReservationForCustomerReservationsPageFragmentDoc = gql`
    fragment ReservationForCustomerReservationsPage on Reservation {
  id
  name
  additionalNotes
  status
}
    `;
export const BaseReservationItemWithReservationForCustomerReservationsPageFragmentDoc = gql`
    fragment BaseReservationItemWithReservationForCustomerReservationsPage on ReservationItem {
  ...BaseReservationItemForCustomerReservationsPage
  reservation {
    ...ReservationForCustomerReservationsPage
  }
}
    ${BaseReservationItemForCustomerReservationsPageFragmentDoc}
${ReservationForCustomerReservationsPageFragmentDoc}`;
export const FullReservationItemForCustomerReservationsPageFragmentDoc = gql`
    fragment FullReservationItemForCustomerReservationsPage on ReservationItem {
  ...BaseReservationItemWithReservationForCustomerReservationsPage
  assignedDevice(time: $telemetryEnd, assignment: $assignment) {
    id
    assetID
    latestDeviceLocation {
      lat
      lon
    }
    latestTelemetry(metrics: ["soc", "s_time_to_empty"]) {
      telemetryPoints {
        metric
        timestamp
        value
      }
    }
  }
}
    ${BaseReservationItemWithReservationForCustomerReservationsPageFragmentDoc}`;
export const MpuIndexDeviceInstanceFragmentDoc = gql`
    fragment MPUIndexDeviceInstance on DeviceInstance {
  id
  serialNumber
  externalID
  name
  assetID
  deviceModel {
    id
    name
  }
  owner {
    id
    name
  }
  serviceArea {
    id
    name
  }
  schedulesIntersecting(start: $start, end: $end) {
    start
    end
    assignment
  }
  latestTelemetry(
    metrics: ["soc", "s_time_to_empty", "mode_selection_state", "pcs_state"]
  ) {
    telemetryPoints {
      metric
      timestamp
      value
    }
  }
  activeFaults {
    id
    faultSeverity
    faultName
  }
}
    `;
export const MpuIndexDeviceLocationFragmentDoc = gql`
    fragment MPUIndexDeviceLocation on DeviceLocation {
  deviceID
  lat
  lon
  time
}
    `;
export const CountActiveAlertsDocument = gql`
    query CountActiveAlerts {
  countActiveAlerts
}
    `;

/**
 * __useCountActiveAlertsQuery__
 *
 * To run a query within a React component, call `useCountActiveAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountActiveAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountActiveAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountActiveAlertsQuery(baseOptions?: Apollo.QueryHookOptions<CountActiveAlertsQuery, CountActiveAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountActiveAlertsQuery, CountActiveAlertsQueryVariables>(CountActiveAlertsDocument, options);
      }
export function useCountActiveAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountActiveAlertsQuery, CountActiveAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountActiveAlertsQuery, CountActiveAlertsQueryVariables>(CountActiveAlertsDocument, options);
        }
export type CountActiveAlertsQueryHookResult = ReturnType<typeof useCountActiveAlertsQuery>;
export type CountActiveAlertsLazyQueryHookResult = ReturnType<typeof useCountActiveAlertsLazyQuery>;
export type CountActiveAlertsQueryResult = Apollo.QueryResult<CountActiveAlertsQuery, CountActiveAlertsQueryVariables>;
export const UserAccountInviteUpsertDocument = gql`
    mutation UserAccountInviteUpsert($email: String!, $accountID: String!, $roles: [String!]) {
  createUserAccountInvite(email: $email, accountID: $accountID, roles: $roles) {
    email
  }
}
    `;
export type UserAccountInviteUpsertMutationFn = Apollo.MutationFunction<UserAccountInviteUpsertMutation, UserAccountInviteUpsertMutationVariables>;

/**
 * __useUserAccountInviteUpsertMutation__
 *
 * To run a mutation, you first call `useUserAccountInviteUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAccountInviteUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAccountInviteUpsertMutation, { data, loading, error }] = useUserAccountInviteUpsertMutation({
 *   variables: {
 *      email: // value for 'email'
 *      accountID: // value for 'accountID'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useUserAccountInviteUpsertMutation(baseOptions?: Apollo.MutationHookOptions<UserAccountInviteUpsertMutation, UserAccountInviteUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserAccountInviteUpsertMutation, UserAccountInviteUpsertMutationVariables>(UserAccountInviteUpsertDocument, options);
      }
export type UserAccountInviteUpsertMutationHookResult = ReturnType<typeof useUserAccountInviteUpsertMutation>;
export type UserAccountInviteUpsertMutationResult = Apollo.MutationResult<UserAccountInviteUpsertMutation>;
export type UserAccountInviteUpsertMutationOptions = Apollo.BaseMutationOptions<UserAccountInviteUpsertMutation, UserAccountInviteUpsertMutationVariables>;
export const AccountLocationsByAccountDocument = gql`
    query AccountLocationsByAccount($accountId: String!) {
  accountLocationsByAccount(accountId: $accountId) {
    id
    contactName
    contactPhone
    formattedAddress
    notes
    createdAt
  }
}
    `;

/**
 * __useAccountLocationsByAccountQuery__
 *
 * To run a query within a React component, call `useAccountLocationsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLocationsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLocationsByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountLocationsByAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountLocationsByAccountQuery, AccountLocationsByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLocationsByAccountQuery, AccountLocationsByAccountQueryVariables>(AccountLocationsByAccountDocument, options);
      }
export function useAccountLocationsByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLocationsByAccountQuery, AccountLocationsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLocationsByAccountQuery, AccountLocationsByAccountQueryVariables>(AccountLocationsByAccountDocument, options);
        }
export type AccountLocationsByAccountQueryHookResult = ReturnType<typeof useAccountLocationsByAccountQuery>;
export type AccountLocationsByAccountLazyQueryHookResult = ReturnType<typeof useAccountLocationsByAccountLazyQuery>;
export type AccountLocationsByAccountQueryResult = Apollo.QueryResult<AccountLocationsByAccountQuery, AccountLocationsByAccountQueryVariables>;
export const CreateAccountLocationDocument = gql`
    mutation createAccountLocation($accountLocationInput: AccountLocationInput!) {
  createAccountLocation(accountLocationInput: $accountLocationInput) {
    id
    formattedAddress
    contactName
    contactPhone
    notes
  }
}
    `;
export type CreateAccountLocationMutationFn = Apollo.MutationFunction<CreateAccountLocationMutation, CreateAccountLocationMutationVariables>;

/**
 * __useCreateAccountLocationMutation__
 *
 * To run a mutation, you first call `useCreateAccountLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountLocationMutation, { data, loading, error }] = useCreateAccountLocationMutation({
 *   variables: {
 *      accountLocationInput: // value for 'accountLocationInput'
 *   },
 * });
 */
export function useCreateAccountLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountLocationMutation, CreateAccountLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountLocationMutation, CreateAccountLocationMutationVariables>(CreateAccountLocationDocument, options);
      }
export type CreateAccountLocationMutationHookResult = ReturnType<typeof useCreateAccountLocationMutation>;
export type CreateAccountLocationMutationResult = Apollo.MutationResult<CreateAccountLocationMutation>;
export type CreateAccountLocationMutationOptions = Apollo.BaseMutationOptions<CreateAccountLocationMutation, CreateAccountLocationMutationVariables>;
export const CreateAccountLocationForProfileDocument = gql`
    mutation CreateAccountLocationForProfile($accountLocationInput: AccountLocationInput!) {
  createAccountLocation(accountLocationInput: $accountLocationInput) {
    ...BillingAddressLocation
  }
}
    ${BillingAddressLocationFragmentDoc}`;
export type CreateAccountLocationForProfileMutationFn = Apollo.MutationFunction<CreateAccountLocationForProfileMutation, CreateAccountLocationForProfileMutationVariables>;

/**
 * __useCreateAccountLocationForProfileMutation__
 *
 * To run a mutation, you first call `useCreateAccountLocationForProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountLocationForProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountLocationForProfileMutation, { data, loading, error }] = useCreateAccountLocationForProfileMutation({
 *   variables: {
 *      accountLocationInput: // value for 'accountLocationInput'
 *   },
 * });
 */
export function useCreateAccountLocationForProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountLocationForProfileMutation, CreateAccountLocationForProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountLocationForProfileMutation, CreateAccountLocationForProfileMutationVariables>(CreateAccountLocationForProfileDocument, options);
      }
export type CreateAccountLocationForProfileMutationHookResult = ReturnType<typeof useCreateAccountLocationForProfileMutation>;
export type CreateAccountLocationForProfileMutationResult = Apollo.MutationResult<CreateAccountLocationForProfileMutation>;
export type CreateAccountLocationForProfileMutationOptions = Apollo.BaseMutationOptions<CreateAccountLocationForProfileMutation, CreateAccountLocationForProfileMutationVariables>;
export const DeleteAccountLocationForProfileDocument = gql`
    mutation DeleteAccountLocationForProfile($accountID: String!, $accountLocationID: String!) {
  deleteAccountLocation(accountId: $accountID, id: $accountLocationID) {
    id
  }
}
    `;
export type DeleteAccountLocationForProfileMutationFn = Apollo.MutationFunction<DeleteAccountLocationForProfileMutation, DeleteAccountLocationForProfileMutationVariables>;

/**
 * __useDeleteAccountLocationForProfileMutation__
 *
 * To run a mutation, you first call `useDeleteAccountLocationForProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountLocationForProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountLocationForProfileMutation, { data, loading, error }] = useDeleteAccountLocationForProfileMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      accountLocationID: // value for 'accountLocationID'
 *   },
 * });
 */
export function useDeleteAccountLocationForProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountLocationForProfileMutation, DeleteAccountLocationForProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountLocationForProfileMutation, DeleteAccountLocationForProfileMutationVariables>(DeleteAccountLocationForProfileDocument, options);
      }
export type DeleteAccountLocationForProfileMutationHookResult = ReturnType<typeof useDeleteAccountLocationForProfileMutation>;
export type DeleteAccountLocationForProfileMutationResult = Apollo.MutationResult<DeleteAccountLocationForProfileMutation>;
export type DeleteAccountLocationForProfileMutationOptions = Apollo.BaseMutationOptions<DeleteAccountLocationForProfileMutation, DeleteAccountLocationForProfileMutationVariables>;
export const UpdateAccountLocationForProfileDocument = gql`
    mutation UpdateAccountLocationForProfile($accountLocationUpdateInput: AccountLocationUpdateInput!) {
  updateAccountLocation(input: $accountLocationUpdateInput) {
    ...BillingAddressLocation
  }
}
    ${BillingAddressLocationFragmentDoc}`;
export type UpdateAccountLocationForProfileMutationFn = Apollo.MutationFunction<UpdateAccountLocationForProfileMutation, UpdateAccountLocationForProfileMutationVariables>;

/**
 * __useUpdateAccountLocationForProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAccountLocationForProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountLocationForProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountLocationForProfileMutation, { data, loading, error }] = useUpdateAccountLocationForProfileMutation({
 *   variables: {
 *      accountLocationUpdateInput: // value for 'accountLocationUpdateInput'
 *   },
 * });
 */
export function useUpdateAccountLocationForProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountLocationForProfileMutation, UpdateAccountLocationForProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountLocationForProfileMutation, UpdateAccountLocationForProfileMutationVariables>(UpdateAccountLocationForProfileDocument, options);
      }
export type UpdateAccountLocationForProfileMutationHookResult = ReturnType<typeof useUpdateAccountLocationForProfileMutation>;
export type UpdateAccountLocationForProfileMutationResult = Apollo.MutationResult<UpdateAccountLocationForProfileMutation>;
export type UpdateAccountLocationForProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAccountLocationForProfileMutation, UpdateAccountLocationForProfileMutationVariables>;
export const GetAccountRestrictedDomainsDocument = gql`
    query GetAccountRestrictedDomains($id: String!) {
  getAccount(id: $id) {
    id
    restrictedUserDomains
  }
}
    `;

/**
 * __useGetAccountRestrictedDomainsQuery__
 *
 * To run a query within a React component, call `useGetAccountRestrictedDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountRestrictedDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountRestrictedDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountRestrictedDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountRestrictedDomainsQuery, GetAccountRestrictedDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountRestrictedDomainsQuery, GetAccountRestrictedDomainsQueryVariables>(GetAccountRestrictedDomainsDocument, options);
      }
export function useGetAccountRestrictedDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountRestrictedDomainsQuery, GetAccountRestrictedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountRestrictedDomainsQuery, GetAccountRestrictedDomainsQueryVariables>(GetAccountRestrictedDomainsDocument, options);
        }
export type GetAccountRestrictedDomainsQueryHookResult = ReturnType<typeof useGetAccountRestrictedDomainsQuery>;
export type GetAccountRestrictedDomainsLazyQueryHookResult = ReturnType<typeof useGetAccountRestrictedDomainsLazyQuery>;
export type GetAccountRestrictedDomainsQueryResult = Apollo.QueryResult<GetAccountRestrictedDomainsQuery, GetAccountRestrictedDomainsQueryVariables>;
export const UpdateAccountRestrictedDomainsDocument = gql`
    mutation UpdateAccountRestrictedDomains($accountInput: AccountInput!) {
  updateAccount(accountInput: $accountInput) {
    id
    restrictedUserDomains
  }
}
    `;
export type UpdateAccountRestrictedDomainsMutationFn = Apollo.MutationFunction<UpdateAccountRestrictedDomainsMutation, UpdateAccountRestrictedDomainsMutationVariables>;

/**
 * __useUpdateAccountRestrictedDomainsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountRestrictedDomainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountRestrictedDomainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountRestrictedDomainsMutation, { data, loading, error }] = useUpdateAccountRestrictedDomainsMutation({
 *   variables: {
 *      accountInput: // value for 'accountInput'
 *   },
 * });
 */
export function useUpdateAccountRestrictedDomainsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountRestrictedDomainsMutation, UpdateAccountRestrictedDomainsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountRestrictedDomainsMutation, UpdateAccountRestrictedDomainsMutationVariables>(UpdateAccountRestrictedDomainsDocument, options);
      }
export type UpdateAccountRestrictedDomainsMutationHookResult = ReturnType<typeof useUpdateAccountRestrictedDomainsMutation>;
export type UpdateAccountRestrictedDomainsMutationResult = Apollo.MutationResult<UpdateAccountRestrictedDomainsMutation>;
export type UpdateAccountRestrictedDomainsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountRestrictedDomainsMutation, UpdateAccountRestrictedDomainsMutationVariables>;
export const AccountSelectorDocument = gql`
    query AccountSelector($after: String, $first: Int, $sortBy: KeyOfSortArg) {
  listAccounts(after: $after, first: $first, sortBy: $sortBy) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      totalEdges
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useAccountSelectorQuery__
 *
 * To run a query within a React component, call `useAccountSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSelectorQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useAccountSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AccountSelectorQuery, AccountSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSelectorQuery, AccountSelectorQueryVariables>(AccountSelectorDocument, options);
      }
export function useAccountSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSelectorQuery, AccountSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSelectorQuery, AccountSelectorQueryVariables>(AccountSelectorDocument, options);
        }
export type AccountSelectorQueryHookResult = ReturnType<typeof useAccountSelectorQuery>;
export type AccountSelectorLazyQueryHookResult = ReturnType<typeof useAccountSelectorLazyQuery>;
export type AccountSelectorQueryResult = Apollo.QueryResult<AccountSelectorQuery, AccountSelectorQueryVariables>;
export const GetServiceAccountsForSettingsDocument = gql`
    query getServiceAccountsForSettings($accountID: String!) {
  listServiceAccounts(accountID: $accountID) {
    id
    name
    createdAt
    apiKeys {
      id
      keyHash
      hashType
      issuedAt
      notBefore
      notAfter
    }
  }
}
    `;

/**
 * __useGetServiceAccountsForSettingsQuery__
 *
 * To run a query within a React component, call `useGetServiceAccountsForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAccountsForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAccountsForSettingsQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useGetServiceAccountsForSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAccountsForSettingsQuery, GetServiceAccountsForSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAccountsForSettingsQuery, GetServiceAccountsForSettingsQueryVariables>(GetServiceAccountsForSettingsDocument, options);
      }
export function useGetServiceAccountsForSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAccountsForSettingsQuery, GetServiceAccountsForSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAccountsForSettingsQuery, GetServiceAccountsForSettingsQueryVariables>(GetServiceAccountsForSettingsDocument, options);
        }
export type GetServiceAccountsForSettingsQueryHookResult = ReturnType<typeof useGetServiceAccountsForSettingsQuery>;
export type GetServiceAccountsForSettingsLazyQueryHookResult = ReturnType<typeof useGetServiceAccountsForSettingsLazyQuery>;
export type GetServiceAccountsForSettingsQueryResult = Apollo.QueryResult<GetServiceAccountsForSettingsQuery, GetServiceAccountsForSettingsQueryVariables>;
export const CreateServiceAccountDocument = gql`
    mutation createServiceAccount($accountID: String!, $serviceAccountName: String!) {
  createServiceAccount(input: {accountID: $accountID, name: $serviceAccountName}) {
    id
    name
  }
}
    `;
export type CreateServiceAccountMutationFn = Apollo.MutationFunction<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;

/**
 * __useCreateServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountMutation, { data, loading, error }] = useCreateServiceAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      serviceAccountName: // value for 'serviceAccountName'
 *   },
 * });
 */
export function useCreateServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>(CreateServiceAccountDocument, options);
      }
export type CreateServiceAccountMutationHookResult = ReturnType<typeof useCreateServiceAccountMutation>;
export type CreateServiceAccountMutationResult = Apollo.MutationResult<CreateServiceAccountMutation>;
export type CreateServiceAccountMutationOptions = Apollo.BaseMutationOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;
export const CreateApiKeyForServiceAccountDocument = gql`
    mutation createAPIKeyForServiceAccount($serviceAccountID: String!) {
  createAPIKeyForServiceAccount(serviceAccountID: $serviceAccountID) {
    token
    apiKey {
      id
      notBefore
      notAfter
    }
  }
}
    `;
export type CreateApiKeyForServiceAccountMutationFn = Apollo.MutationFunction<CreateApiKeyForServiceAccountMutation, CreateApiKeyForServiceAccountMutationVariables>;

/**
 * __useCreateApiKeyForServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyForServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyForServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyForServiceAccountMutation, { data, loading, error }] = useCreateApiKeyForServiceAccountMutation({
 *   variables: {
 *      serviceAccountID: // value for 'serviceAccountID'
 *   },
 * });
 */
export function useCreateApiKeyForServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyForServiceAccountMutation, CreateApiKeyForServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyForServiceAccountMutation, CreateApiKeyForServiceAccountMutationVariables>(CreateApiKeyForServiceAccountDocument, options);
      }
export type CreateApiKeyForServiceAccountMutationHookResult = ReturnType<typeof useCreateApiKeyForServiceAccountMutation>;
export type CreateApiKeyForServiceAccountMutationResult = Apollo.MutationResult<CreateApiKeyForServiceAccountMutation>;
export type CreateApiKeyForServiceAccountMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyForServiceAccountMutation, CreateApiKeyForServiceAccountMutationVariables>;
export const GetTeamMembersForSettingsDocument = gql`
    query getTeamMembersForSettings($id: String!) {
  getAccount(id: $id) {
    users {
      id
      name
      email
      status
    }
  }
}
    `;

/**
 * __useGetTeamMembersForSettingsQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersForSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamMembersForSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMembersForSettingsQuery, GetTeamMembersForSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersForSettingsQuery, GetTeamMembersForSettingsQueryVariables>(GetTeamMembersForSettingsDocument, options);
      }
export function useGetTeamMembersForSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersForSettingsQuery, GetTeamMembersForSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersForSettingsQuery, GetTeamMembersForSettingsQueryVariables>(GetTeamMembersForSettingsDocument, options);
        }
export type GetTeamMembersForSettingsQueryHookResult = ReturnType<typeof useGetTeamMembersForSettingsQuery>;
export type GetTeamMembersForSettingsLazyQueryHookResult = ReturnType<typeof useGetTeamMembersForSettingsLazyQuery>;
export type GetTeamMembersForSettingsQueryResult = Apollo.QueryResult<GetTeamMembersForSettingsQuery, GetTeamMembersForSettingsQueryVariables>;
export const AccountUserSelectorDocument = gql`
    query AccountUserSelector($id: String!) {
  getAccount(id: $id) {
    id
    users {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useAccountUserSelectorQuery__
 *
 * To run a query within a React component, call `useAccountUserSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUserSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUserSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountUserSelectorQuery(baseOptions: Apollo.QueryHookOptions<AccountUserSelectorQuery, AccountUserSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUserSelectorQuery, AccountUserSelectorQueryVariables>(AccountUserSelectorDocument, options);
      }
export function useAccountUserSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUserSelectorQuery, AccountUserSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUserSelectorQuery, AccountUserSelectorQueryVariables>(AccountUserSelectorDocument, options);
        }
export type AccountUserSelectorQueryHookResult = ReturnType<typeof useAccountUserSelectorQuery>;
export type AccountUserSelectorLazyQueryHookResult = ReturnType<typeof useAccountUserSelectorLazyQuery>;
export type AccountUserSelectorQueryResult = Apollo.QueryResult<AccountUserSelectorQuery, AccountUserSelectorQueryVariables>;
export const ActiveAlertsSummaryDocument = gql`
    query ActiveAlertsSummary {
  listActiveAlerts {
    type
    triggerTime
    severity
    reservation {
      id
    }
  }
}
    `;

/**
 * __useActiveAlertsSummaryQuery__
 *
 * To run a query within a React component, call `useActiveAlertsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAlertsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAlertsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAlertsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ActiveAlertsSummaryQuery, ActiveAlertsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveAlertsSummaryQuery, ActiveAlertsSummaryQueryVariables>(ActiveAlertsSummaryDocument, options);
      }
export function useActiveAlertsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveAlertsSummaryQuery, ActiveAlertsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveAlertsSummaryQuery, ActiveAlertsSummaryQueryVariables>(ActiveAlertsSummaryDocument, options);
        }
export type ActiveAlertsSummaryQueryHookResult = ReturnType<typeof useActiveAlertsSummaryQuery>;
export type ActiveAlertsSummaryLazyQueryHookResult = ReturnType<typeof useActiveAlertsSummaryLazyQuery>;
export type ActiveAlertsSummaryQueryResult = Apollo.QueryResult<ActiveAlertsSummaryQuery, ActiveAlertsSummaryQueryVariables>;
export const ListActiveDeviceFaultsDocument = gql`
    query ListActiveDeviceFaults($deviceIDs: [String!]) {
  listActiveFaults(deviceIDs: $deviceIDs) {
    edges {
      node {
        id
        faultName
        faultSeverity
        firstSeen
        lastUpdate
      }
    }
  }
}
    `;

/**
 * __useListActiveDeviceFaultsQuery__
 *
 * To run a query within a React component, call `useListActiveDeviceFaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveDeviceFaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveDeviceFaultsQuery({
 *   variables: {
 *      deviceIDs: // value for 'deviceIDs'
 *   },
 * });
 */
export function useListActiveDeviceFaultsQuery(baseOptions?: Apollo.QueryHookOptions<ListActiveDeviceFaultsQuery, ListActiveDeviceFaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveDeviceFaultsQuery, ListActiveDeviceFaultsQueryVariables>(ListActiveDeviceFaultsDocument, options);
      }
export function useListActiveDeviceFaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveDeviceFaultsQuery, ListActiveDeviceFaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveDeviceFaultsQuery, ListActiveDeviceFaultsQueryVariables>(ListActiveDeviceFaultsDocument, options);
        }
export type ListActiveDeviceFaultsQueryHookResult = ReturnType<typeof useListActiveDeviceFaultsQuery>;
export type ListActiveDeviceFaultsLazyQueryHookResult = ReturnType<typeof useListActiveDeviceFaultsLazyQuery>;
export type ListActiveDeviceFaultsQueryResult = Apollo.QueryResult<ListActiveDeviceFaultsQuery, ListActiveDeviceFaultsQueryVariables>;
export const ActiveFaultsSummaryDocument = gql`
    query ActiveFaultsSummary($input: CountActiveFaultsBySeverityInput!) {
  countActiveFaultsBySeverity(input: $input) {
    severity
    count
  }
}
    `;

/**
 * __useActiveFaultsSummaryQuery__
 *
 * To run a query within a React component, call `useActiveFaultsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFaultsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFaultsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActiveFaultsSummaryQuery(baseOptions: Apollo.QueryHookOptions<ActiveFaultsSummaryQuery, ActiveFaultsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFaultsSummaryQuery, ActiveFaultsSummaryQueryVariables>(ActiveFaultsSummaryDocument, options);
      }
export function useActiveFaultsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFaultsSummaryQuery, ActiveFaultsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFaultsSummaryQuery, ActiveFaultsSummaryQueryVariables>(ActiveFaultsSummaryDocument, options);
        }
export type ActiveFaultsSummaryQueryHookResult = ReturnType<typeof useActiveFaultsSummaryQuery>;
export type ActiveFaultsSummaryLazyQueryHookResult = ReturnType<typeof useActiveFaultsSummaryLazyQuery>;
export type ActiveFaultsSummaryQueryResult = Apollo.QueryResult<ActiveFaultsSummaryQuery, ActiveFaultsSummaryQueryVariables>;
export const ListActiveReservationAlertsDocument = gql`
    query ListActiveReservationAlerts($reservationID: String!) {
  listActiveAlerts(input: {reservationIDs: [$reservationID]}) {
    ...ActiveAlertForReservationPage
    ... on MPUOfflineAlert {
      ...MPUOfflineAlertForReservationPage
    }
    ... on MPULowSOCAlert {
      ...MPULowSOCAlertForReservationPage
    }
    ... on MPUCriticalFaultAlert {
      ...MPUCriticalFaultAlertForReservationPage
    }
    ... on ReservationItemAllocationAlert {
      ...ReservationItemAllocationAlertForReservationPage
    }
  }
}
    ${ActiveAlertForReservationPageFragmentDoc}
${MpuOfflineAlertForReservationPageFragmentDoc}
${MpuLowSocAlertForReservationPageFragmentDoc}
${MpuCriticalFaultAlertForReservationPageFragmentDoc}
${ReservationItemAllocationAlertForReservationPageFragmentDoc}`;

/**
 * __useListActiveReservationAlertsQuery__
 *
 * To run a query within a React component, call `useListActiveReservationAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveReservationAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveReservationAlertsQuery({
 *   variables: {
 *      reservationID: // value for 'reservationID'
 *   },
 * });
 */
export function useListActiveReservationAlertsQuery(baseOptions: Apollo.QueryHookOptions<ListActiveReservationAlertsQuery, ListActiveReservationAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveReservationAlertsQuery, ListActiveReservationAlertsQueryVariables>(ListActiveReservationAlertsDocument, options);
      }
export function useListActiveReservationAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveReservationAlertsQuery, ListActiveReservationAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveReservationAlertsQuery, ListActiveReservationAlertsQueryVariables>(ListActiveReservationAlertsDocument, options);
        }
export type ListActiveReservationAlertsQueryHookResult = ReturnType<typeof useListActiveReservationAlertsQuery>;
export type ListActiveReservationAlertsLazyQueryHookResult = ReturnType<typeof useListActiveReservationAlertsLazyQuery>;
export type ListActiveReservationAlertsQueryResult = Apollo.QueryResult<ListActiveReservationAlertsQuery, ListActiveReservationAlertsQueryVariables>;
export const AvailableUnitSelectorDocument = gql`
    query AvailableUnitSelector($availableDeviceInstancesInput: AvailableDeviceInstancesInput!) {
  availableDeviceInstances(
    availableDeviceInstancesInput: $availableDeviceInstancesInput
  ) {
    id
    assetID
    name
  }
}
    `;

/**
 * __useAvailableUnitSelectorQuery__
 *
 * To run a query within a React component, call `useAvailableUnitSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableUnitSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableUnitSelectorQuery({
 *   variables: {
 *      availableDeviceInstancesInput: // value for 'availableDeviceInstancesInput'
 *   },
 * });
 */
export function useAvailableUnitSelectorQuery(baseOptions: Apollo.QueryHookOptions<AvailableUnitSelectorQuery, AvailableUnitSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableUnitSelectorQuery, AvailableUnitSelectorQueryVariables>(AvailableUnitSelectorDocument, options);
      }
export function useAvailableUnitSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableUnitSelectorQuery, AvailableUnitSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableUnitSelectorQuery, AvailableUnitSelectorQueryVariables>(AvailableUnitSelectorDocument, options);
        }
export type AvailableUnitSelectorQueryHookResult = ReturnType<typeof useAvailableUnitSelectorQuery>;
export type AvailableUnitSelectorLazyQueryHookResult = ReturnType<typeof useAvailableUnitSelectorLazyQuery>;
export type AvailableUnitSelectorQueryResult = Apollo.QueryResult<AvailableUnitSelectorQuery, AvailableUnitSelectorQueryVariables>;
export const GetDowntimePeriodDocument = gql`
    query GetDowntimePeriod($id: String!) {
  deviceInstanceSchedule(input: {deviceInstanceScheduleID: $id}) {
    ...DowntimePeriod
  }
}
    ${DowntimePeriodFragmentDoc}`;

/**
 * __useGetDowntimePeriodQuery__
 *
 * To run a query within a React component, call `useGetDowntimePeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDowntimePeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDowntimePeriodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDowntimePeriodQuery(baseOptions: Apollo.QueryHookOptions<GetDowntimePeriodQuery, GetDowntimePeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDowntimePeriodQuery, GetDowntimePeriodQueryVariables>(GetDowntimePeriodDocument, options);
      }
export function useGetDowntimePeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDowntimePeriodQuery, GetDowntimePeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDowntimePeriodQuery, GetDowntimePeriodQueryVariables>(GetDowntimePeriodDocument, options);
        }
export type GetDowntimePeriodQueryHookResult = ReturnType<typeof useGetDowntimePeriodQuery>;
export type GetDowntimePeriodLazyQueryHookResult = ReturnType<typeof useGetDowntimePeriodLazyQuery>;
export type GetDowntimePeriodQueryResult = Apollo.QueryResult<GetDowntimePeriodQuery, GetDowntimePeriodQueryVariables>;
export const ListMpuExternalIDsForSelectorDocument = gql`
    query ListMPUExternalIDsForSelector($ownerAccountIDs: [String!]!) {
  listDeviceInstances(filters: {ownerAccountIDs: $ownerAccountIDs}) {
    edges {
      node {
        externalID
      }
    }
  }
}
    `;

/**
 * __useListMpuExternalIDsForSelectorQuery__
 *
 * To run a query within a React component, call `useListMpuExternalIDsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMpuExternalIDsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMpuExternalIDsForSelectorQuery({
 *   variables: {
 *      ownerAccountIDs: // value for 'ownerAccountIDs'
 *   },
 * });
 */
export function useListMpuExternalIDsForSelectorQuery(baseOptions: Apollo.QueryHookOptions<ListMpuExternalIDsForSelectorQuery, ListMpuExternalIDsForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMpuExternalIDsForSelectorQuery, ListMpuExternalIDsForSelectorQueryVariables>(ListMpuExternalIDsForSelectorDocument, options);
      }
export function useListMpuExternalIDsForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMpuExternalIDsForSelectorQuery, ListMpuExternalIDsForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMpuExternalIDsForSelectorQuery, ListMpuExternalIDsForSelectorQueryVariables>(ListMpuExternalIDsForSelectorDocument, options);
        }
export type ListMpuExternalIDsForSelectorQueryHookResult = ReturnType<typeof useListMpuExternalIDsForSelectorQuery>;
export type ListMpuExternalIDsForSelectorLazyQueryHookResult = ReturnType<typeof useListMpuExternalIDsForSelectorLazyQuery>;
export type ListMpuExternalIDsForSelectorQueryResult = Apollo.QueryResult<ListMpuExternalIDsForSelectorQuery, ListMpuExternalIDsForSelectorQueryVariables>;
export const ListMpUsForSelectorDocument = gql`
    query ListMPUsForSelector($ownerAccountIDs: [String!]!) {
  listDeviceInstances(filters: {ownerAccountIDs: $ownerAccountIDs}) {
    edges {
      node {
        name
      }
    }
  }
}
    `;

/**
 * __useListMpUsForSelectorQuery__
 *
 * To run a query within a React component, call `useListMpUsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMpUsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMpUsForSelectorQuery({
 *   variables: {
 *      ownerAccountIDs: // value for 'ownerAccountIDs'
 *   },
 * });
 */
export function useListMpUsForSelectorQuery(baseOptions: Apollo.QueryHookOptions<ListMpUsForSelectorQuery, ListMpUsForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMpUsForSelectorQuery, ListMpUsForSelectorQueryVariables>(ListMpUsForSelectorDocument, options);
      }
export function useListMpUsForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMpUsForSelectorQuery, ListMpUsForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMpUsForSelectorQuery, ListMpUsForSelectorQueryVariables>(ListMpUsForSelectorDocument, options);
        }
export type ListMpUsForSelectorQueryHookResult = ReturnType<typeof useListMpUsForSelectorQuery>;
export type ListMpUsForSelectorLazyQueryHookResult = ReturnType<typeof useListMpUsForSelectorLazyQuery>;
export type ListMpUsForSelectorQueryResult = Apollo.QueryResult<ListMpUsForSelectorQuery, ListMpUsForSelectorQueryVariables>;
export const GetMpuIndexScheduleDeviceInstanceDocument = gql`
    query GetMpuIndexScheduleDeviceInstance($id: String!, $end: DateTime!, $start: DateTime!) {
  getDeviceInstance(id: $id) {
    ...MpuScheduleDeviceInstance
  }
}
    ${MpuScheduleDeviceInstanceFragmentDoc}`;

/**
 * __useGetMpuIndexScheduleDeviceInstanceQuery__
 *
 * To run a query within a React component, call `useGetMpuIndexScheduleDeviceInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuIndexScheduleDeviceInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuIndexScheduleDeviceInstanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      end: // value for 'end'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetMpuIndexScheduleDeviceInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetMpuIndexScheduleDeviceInstanceQuery, GetMpuIndexScheduleDeviceInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuIndexScheduleDeviceInstanceQuery, GetMpuIndexScheduleDeviceInstanceQueryVariables>(GetMpuIndexScheduleDeviceInstanceDocument, options);
      }
export function useGetMpuIndexScheduleDeviceInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuIndexScheduleDeviceInstanceQuery, GetMpuIndexScheduleDeviceInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuIndexScheduleDeviceInstanceQuery, GetMpuIndexScheduleDeviceInstanceQueryVariables>(GetMpuIndexScheduleDeviceInstanceDocument, options);
        }
export type GetMpuIndexScheduleDeviceInstanceQueryHookResult = ReturnType<typeof useGetMpuIndexScheduleDeviceInstanceQuery>;
export type GetMpuIndexScheduleDeviceInstanceLazyQueryHookResult = ReturnType<typeof useGetMpuIndexScheduleDeviceInstanceLazyQuery>;
export type GetMpuIndexScheduleDeviceInstanceQueryResult = Apollo.QueryResult<GetMpuIndexScheduleDeviceInstanceQuery, GetMpuIndexScheduleDeviceInstanceQueryVariables>;
export const GetMpuIndexScheduleDeviceInstanceListDocument = gql`
    query GetMpuIndexScheduleDeviceInstanceList($after: String, $first: Int, $before: String, $last: Int, $sortBy: KeyOfSortArg, $filters: DeviceInstancePaginationFilters!) {
  listDeviceInstances(
    after: $after
    first: $first
    before: $before
    last: $last
    sortBy: $sortBy
    filters: $filters
  ) {
    edges {
      node {
        ...MpuIndexScheduleDeviceInstance
      }
    }
    pageInfo {
      totalEdges
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    ${MpuIndexScheduleDeviceInstanceFragmentDoc}`;

/**
 * __useGetMpuIndexScheduleDeviceInstanceListQuery__
 *
 * To run a query within a React component, call `useGetMpuIndexScheduleDeviceInstanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuIndexScheduleDeviceInstanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuIndexScheduleDeviceInstanceListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMpuIndexScheduleDeviceInstanceListQuery(baseOptions: Apollo.QueryHookOptions<GetMpuIndexScheduleDeviceInstanceListQuery, GetMpuIndexScheduleDeviceInstanceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuIndexScheduleDeviceInstanceListQuery, GetMpuIndexScheduleDeviceInstanceListQueryVariables>(GetMpuIndexScheduleDeviceInstanceListDocument, options);
      }
export function useGetMpuIndexScheduleDeviceInstanceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuIndexScheduleDeviceInstanceListQuery, GetMpuIndexScheduleDeviceInstanceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuIndexScheduleDeviceInstanceListQuery, GetMpuIndexScheduleDeviceInstanceListQueryVariables>(GetMpuIndexScheduleDeviceInstanceListDocument, options);
        }
export type GetMpuIndexScheduleDeviceInstanceListQueryHookResult = ReturnType<typeof useGetMpuIndexScheduleDeviceInstanceListQuery>;
export type GetMpuIndexScheduleDeviceInstanceListLazyQueryHookResult = ReturnType<typeof useGetMpuIndexScheduleDeviceInstanceListLazyQuery>;
export type GetMpuIndexScheduleDeviceInstanceListQueryResult = Apollo.QueryResult<GetMpuIndexScheduleDeviceInstanceListQuery, GetMpuIndexScheduleDeviceInstanceListQueryVariables>;
export const GetMpuScheduleDeviceInstanceDocument = gql`
    query GetMpuScheduleDeviceInstance($deviceInstanceID: String!, $end: DateTime!, $start: DateTime!) {
  getDeviceInstance(id: $deviceInstanceID) {
    ...MpuScheduleDeviceInstance
  }
}
    ${MpuScheduleDeviceInstanceFragmentDoc}`;

/**
 * __useGetMpuScheduleDeviceInstanceQuery__
 *
 * To run a query within a React component, call `useGetMpuScheduleDeviceInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuScheduleDeviceInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuScheduleDeviceInstanceQuery({
 *   variables: {
 *      deviceInstanceID: // value for 'deviceInstanceID'
 *      end: // value for 'end'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetMpuScheduleDeviceInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetMpuScheduleDeviceInstanceQuery, GetMpuScheduleDeviceInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuScheduleDeviceInstanceQuery, GetMpuScheduleDeviceInstanceQueryVariables>(GetMpuScheduleDeviceInstanceDocument, options);
      }
export function useGetMpuScheduleDeviceInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuScheduleDeviceInstanceQuery, GetMpuScheduleDeviceInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuScheduleDeviceInstanceQuery, GetMpuScheduleDeviceInstanceQueryVariables>(GetMpuScheduleDeviceInstanceDocument, options);
        }
export type GetMpuScheduleDeviceInstanceQueryHookResult = ReturnType<typeof useGetMpuScheduleDeviceInstanceQuery>;
export type GetMpuScheduleDeviceInstanceLazyQueryHookResult = ReturnType<typeof useGetMpuScheduleDeviceInstanceLazyQuery>;
export type GetMpuScheduleDeviceInstanceQueryResult = Apollo.QueryResult<GetMpuScheduleDeviceInstanceQuery, GetMpuScheduleDeviceInstanceQueryVariables>;
export const ListNetsuiteCustomersDocument = gql`
    query ListNetsuiteCustomers {
  listNetSuiteCustomers {
    id
    name
    account {
      id
      name
    }
  }
}
    `;

/**
 * __useListNetsuiteCustomersQuery__
 *
 * To run a query within a React component, call `useListNetsuiteCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNetsuiteCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNetsuiteCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListNetsuiteCustomersQuery(baseOptions?: Apollo.QueryHookOptions<ListNetsuiteCustomersQuery, ListNetsuiteCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNetsuiteCustomersQuery, ListNetsuiteCustomersQueryVariables>(ListNetsuiteCustomersDocument, options);
      }
export function useListNetsuiteCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNetsuiteCustomersQuery, ListNetsuiteCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNetsuiteCustomersQuery, ListNetsuiteCustomersQueryVariables>(ListNetsuiteCustomersDocument, options);
        }
export type ListNetsuiteCustomersQueryHookResult = ReturnType<typeof useListNetsuiteCustomersQuery>;
export type ListNetsuiteCustomersLazyQueryHookResult = ReturnType<typeof useListNetsuiteCustomersLazyQuery>;
export type ListNetsuiteCustomersQueryResult = Apollo.QueryResult<ListNetsuiteCustomersQuery, ListNetsuiteCustomersQueryVariables>;
export const GetReservationScheduleReservationDocument = gql`
    query GetReservationScheduleReservation($reservationID: String!) {
  getReservation(id: $reservationID) {
    ...ReservationScheduleReservation
  }
}
    ${ReservationScheduleReservationFragmentDoc}`;

/**
 * __useGetReservationScheduleReservationQuery__
 *
 * To run a query within a React component, call `useGetReservationScheduleReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationScheduleReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationScheduleReservationQuery({
 *   variables: {
 *      reservationID: // value for 'reservationID'
 *   },
 * });
 */
export function useGetReservationScheduleReservationQuery(baseOptions: Apollo.QueryHookOptions<GetReservationScheduleReservationQuery, GetReservationScheduleReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationScheduleReservationQuery, GetReservationScheduleReservationQueryVariables>(GetReservationScheduleReservationDocument, options);
      }
export function useGetReservationScheduleReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationScheduleReservationQuery, GetReservationScheduleReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationScheduleReservationQuery, GetReservationScheduleReservationQueryVariables>(GetReservationScheduleReservationDocument, options);
        }
export type GetReservationScheduleReservationQueryHookResult = ReturnType<typeof useGetReservationScheduleReservationQuery>;
export type GetReservationScheduleReservationLazyQueryHookResult = ReturnType<typeof useGetReservationScheduleReservationLazyQuery>;
export type GetReservationScheduleReservationQueryResult = Apollo.QueryResult<GetReservationScheduleReservationQuery, GetReservationScheduleReservationQueryVariables>;
export const DeleteReservationScheduleDeviceInstanceScheduleDocument = gql`
    mutation DeleteReservationScheduleDeviceInstanceSchedule($deviceScheduleID: String!) {
  deleteDeviceSchedule(input: {deviceScheduleID: $deviceScheduleID}) {
    id
  }
}
    `;
export type DeleteReservationScheduleDeviceInstanceScheduleMutationFn = Apollo.MutationFunction<DeleteReservationScheduleDeviceInstanceScheduleMutation, DeleteReservationScheduleDeviceInstanceScheduleMutationVariables>;

/**
 * __useDeleteReservationScheduleDeviceInstanceScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteReservationScheduleDeviceInstanceScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationScheduleDeviceInstanceScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservationScheduleDeviceInstanceScheduleMutation, { data, loading, error }] = useDeleteReservationScheduleDeviceInstanceScheduleMutation({
 *   variables: {
 *      deviceScheduleID: // value for 'deviceScheduleID'
 *   },
 * });
 */
export function useDeleteReservationScheduleDeviceInstanceScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservationScheduleDeviceInstanceScheduleMutation, DeleteReservationScheduleDeviceInstanceScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservationScheduleDeviceInstanceScheduleMutation, DeleteReservationScheduleDeviceInstanceScheduleMutationVariables>(DeleteReservationScheduleDeviceInstanceScheduleDocument, options);
      }
export type DeleteReservationScheduleDeviceInstanceScheduleMutationHookResult = ReturnType<typeof useDeleteReservationScheduleDeviceInstanceScheduleMutation>;
export type DeleteReservationScheduleDeviceInstanceScheduleMutationResult = Apollo.MutationResult<DeleteReservationScheduleDeviceInstanceScheduleMutation>;
export type DeleteReservationScheduleDeviceInstanceScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteReservationScheduleDeviceInstanceScheduleMutation, DeleteReservationScheduleDeviceInstanceScheduleMutationVariables>;
export const PersistReservationScheduleDeviceInstanceSchedulesDocument = gql`
    mutation PersistReservationScheduleDeviceInstanceSchedules($input: CreateSchedulesInput!) {
  createSchedules(input: $input) {
    id
  }
}
    `;
export type PersistReservationScheduleDeviceInstanceSchedulesMutationFn = Apollo.MutationFunction<PersistReservationScheduleDeviceInstanceSchedulesMutation, PersistReservationScheduleDeviceInstanceSchedulesMutationVariables>;

/**
 * __usePersistReservationScheduleDeviceInstanceSchedulesMutation__
 *
 * To run a mutation, you first call `usePersistReservationScheduleDeviceInstanceSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistReservationScheduleDeviceInstanceSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistReservationScheduleDeviceInstanceSchedulesMutation, { data, loading, error }] = usePersistReservationScheduleDeviceInstanceSchedulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersistReservationScheduleDeviceInstanceSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<PersistReservationScheduleDeviceInstanceSchedulesMutation, PersistReservationScheduleDeviceInstanceSchedulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersistReservationScheduleDeviceInstanceSchedulesMutation, PersistReservationScheduleDeviceInstanceSchedulesMutationVariables>(PersistReservationScheduleDeviceInstanceSchedulesDocument, options);
      }
export type PersistReservationScheduleDeviceInstanceSchedulesMutationHookResult = ReturnType<typeof usePersistReservationScheduleDeviceInstanceSchedulesMutation>;
export type PersistReservationScheduleDeviceInstanceSchedulesMutationResult = Apollo.MutationResult<PersistReservationScheduleDeviceInstanceSchedulesMutation>;
export type PersistReservationScheduleDeviceInstanceSchedulesMutationOptions = Apollo.BaseMutationOptions<PersistReservationScheduleDeviceInstanceSchedulesMutation, PersistReservationScheduleDeviceInstanceSchedulesMutationVariables>;
export const ListReservationsForSelectorDocument = gql`
    query ListReservationsForSelector($statuses: [ReservationStatus!]) {
  listReservations(input: {statuses: $statuses}) {
    id
    name
  }
}
    `;

/**
 * __useListReservationsForSelectorQuery__
 *
 * To run a query within a React component, call `useListReservationsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReservationsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReservationsForSelectorQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useListReservationsForSelectorQuery(baseOptions?: Apollo.QueryHookOptions<ListReservationsForSelectorQuery, ListReservationsForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReservationsForSelectorQuery, ListReservationsForSelectorQueryVariables>(ListReservationsForSelectorDocument, options);
      }
export function useListReservationsForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReservationsForSelectorQuery, ListReservationsForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReservationsForSelectorQuery, ListReservationsForSelectorQueryVariables>(ListReservationsForSelectorDocument, options);
        }
export type ListReservationsForSelectorQueryHookResult = ReturnType<typeof useListReservationsForSelectorQuery>;
export type ListReservationsForSelectorLazyQueryHookResult = ReturnType<typeof useListReservationsForSelectorLazyQuery>;
export type ListReservationsForSelectorQueryResult = Apollo.QueryResult<ListReservationsForSelectorQuery, ListReservationsForSelectorQueryVariables>;
export const ListRolesDocument = gql`
    query listRoles($grantorUserID: String!) {
  listGrantableRoles(grantorUserID: $grantorUserID) {
    name
  }
}
    `;

/**
 * __useListRolesQuery__
 *
 * To run a query within a React component, call `useListRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRolesQuery({
 *   variables: {
 *      grantorUserID: // value for 'grantorUserID'
 *   },
 * });
 */
export function useListRolesQuery(baseOptions: Apollo.QueryHookOptions<ListRolesQuery, ListRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
      }
export function useListRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRolesQuery, ListRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRolesQuery, ListRolesQueryVariables>(ListRolesDocument, options);
        }
export type ListRolesQueryHookResult = ReturnType<typeof useListRolesQuery>;
export type ListRolesLazyQueryHookResult = ReturnType<typeof useListRolesLazyQuery>;
export type ListRolesQueryResult = Apollo.QueryResult<ListRolesQuery, ListRolesQueryVariables>;
export const ListMpuSerialNumbersForSelectorDocument = gql`
    query ListMPUSerialNumbersForSelector($ownerAccountIDs: [String!]!) {
  listDeviceInstances(filters: {ownerAccountIDs: $ownerAccountIDs}) {
    edges {
      node {
        serialNumber
      }
    }
  }
}
    `;

/**
 * __useListMpuSerialNumbersForSelectorQuery__
 *
 * To run a query within a React component, call `useListMpuSerialNumbersForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMpuSerialNumbersForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMpuSerialNumbersForSelectorQuery({
 *   variables: {
 *      ownerAccountIDs: // value for 'ownerAccountIDs'
 *   },
 * });
 */
export function useListMpuSerialNumbersForSelectorQuery(baseOptions: Apollo.QueryHookOptions<ListMpuSerialNumbersForSelectorQuery, ListMpuSerialNumbersForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMpuSerialNumbersForSelectorQuery, ListMpuSerialNumbersForSelectorQueryVariables>(ListMpuSerialNumbersForSelectorDocument, options);
      }
export function useListMpuSerialNumbersForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMpuSerialNumbersForSelectorQuery, ListMpuSerialNumbersForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMpuSerialNumbersForSelectorQuery, ListMpuSerialNumbersForSelectorQueryVariables>(ListMpuSerialNumbersForSelectorDocument, options);
        }
export type ListMpuSerialNumbersForSelectorQueryHookResult = ReturnType<typeof useListMpuSerialNumbersForSelectorQuery>;
export type ListMpuSerialNumbersForSelectorLazyQueryHookResult = ReturnType<typeof useListMpuSerialNumbersForSelectorLazyQuery>;
export type ListMpuSerialNumbersForSelectorQueryResult = Apollo.QueryResult<ListMpuSerialNumbersForSelectorQuery, ListMpuSerialNumbersForSelectorQueryVariables>;
export const ListServiceAreasForSelectorDocument = gql`
    query ListServiceAreasForSelector($accountID: String!) {
  listServiceAreas(accountID: $accountID) {
    id
    name
  }
}
    `;

/**
 * __useListServiceAreasForSelectorQuery__
 *
 * To run a query within a React component, call `useListServiceAreasForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListServiceAreasForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListServiceAreasForSelectorQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useListServiceAreasForSelectorQuery(baseOptions: Apollo.QueryHookOptions<ListServiceAreasForSelectorQuery, ListServiceAreasForSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListServiceAreasForSelectorQuery, ListServiceAreasForSelectorQueryVariables>(ListServiceAreasForSelectorDocument, options);
      }
export function useListServiceAreasForSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListServiceAreasForSelectorQuery, ListServiceAreasForSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListServiceAreasForSelectorQuery, ListServiceAreasForSelectorQueryVariables>(ListServiceAreasForSelectorDocument, options);
        }
export type ListServiceAreasForSelectorQueryHookResult = ReturnType<typeof useListServiceAreasForSelectorQuery>;
export type ListServiceAreasForSelectorLazyQueryHookResult = ReturnType<typeof useListServiceAreasForSelectorLazyQuery>;
export type ListServiceAreasForSelectorQueryResult = Apollo.QueryResult<ListServiceAreasForSelectorQuery, ListServiceAreasForSelectorQueryVariables>;
export const GetUnitAssignmentScheduleAvailableDeviceInstanceIDsDocument = gql`
    query GetUnitAssignmentScheduleAvailableDeviceInstanceIDs($availableDeviceInstancesInput: AvailableDeviceInstancesInput!) {
  availableDeviceInstances(
    availableDeviceInstancesInput: $availableDeviceInstancesInput
  ) {
    id
  }
}
    `;

/**
 * __useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery__
 *
 * To run a query within a React component, call `useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery({
 *   variables: {
 *      availableDeviceInstancesInput: // value for 'availableDeviceInstancesInput'
 *   },
 * });
 */
export function useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery(baseOptions: Apollo.QueryHookOptions<GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery, GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery, GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables>(GetUnitAssignmentScheduleAvailableDeviceInstanceIDsDocument, options);
      }
export function useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery, GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery, GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables>(GetUnitAssignmentScheduleAvailableDeviceInstanceIDsDocument, options);
        }
export type GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryHookResult = ReturnType<typeof useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery>;
export type GetUnitAssignmentScheduleAvailableDeviceInstanceIDsLazyQueryHookResult = ReturnType<typeof useGetUnitAssignmentScheduleAvailableDeviceInstanceIDsLazyQuery>;
export type GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryResult = Apollo.QueryResult<GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQuery, GetUnitAssignmentScheduleAvailableDeviceInstanceIDsQueryVariables>;
export const GetHistoricalFaultsDocument = gql`
    query GetHistoricalFaults($id: String!, $start: DateTime!, $end: DateTime!, $faultNames: [String!]) {
  getDeviceInstance(id: $id) {
    id
    historicalFaults(start: $start, end: $end, faultNames: $faultNames) {
      id
      faultName
      firstSeen
      resolved
      faultSeverity
    }
  }
}
    `;

/**
 * __useGetHistoricalFaultsQuery__
 *
 * To run a query within a React component, call `useGetHistoricalFaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalFaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalFaultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      faultNames: // value for 'faultNames'
 *   },
 * });
 */
export function useGetHistoricalFaultsQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalFaultsQuery, GetHistoricalFaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalFaultsQuery, GetHistoricalFaultsQueryVariables>(GetHistoricalFaultsDocument, options);
      }
export function useGetHistoricalFaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalFaultsQuery, GetHistoricalFaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalFaultsQuery, GetHistoricalFaultsQueryVariables>(GetHistoricalFaultsDocument, options);
        }
export type GetHistoricalFaultsQueryHookResult = ReturnType<typeof useGetHistoricalFaultsQuery>;
export type GetHistoricalFaultsLazyQueryHookResult = ReturnType<typeof useGetHistoricalFaultsLazyQuery>;
export type GetHistoricalFaultsQueryResult = Apollo.QueryResult<GetHistoricalFaultsQuery, GetHistoricalFaultsQueryVariables>;
export const ListActiveAlertsDocument = gql`
    query listActiveAlerts($reservationIDs: [String!]) {
  listActiveAlerts(input: {reservationIDs: $reservationIDs}) {
    type
    triggerTime
    severity
    reservation {
      ...ReservationForAlertsPage
    }
    account {
      ...AccountForAlertsPage
    }
    ... on MPUOfflineAlert {
      ...MPUOfflineAlertForAlertsPage
    }
    ... on MPULowSOCAlert {
      ...MPULowSOCAlertForAlertsPage
    }
    ... on MPUCriticalFaultAlert {
      ...MPUCriticalFaultAlertForAlertsPage
    }
    ... on ReservationItemAllocationAlert {
      ...ReservationItemAllocationAlertForAlertsPage
    }
    ... on ReservationAllocationAlert {
      ...ReservationAllocationAlertForAlertsPage
    }
  }
}
    ${ReservationForAlertsPageFragmentDoc}
${AccountForAlertsPageFragmentDoc}
${MpuOfflineAlertForAlertsPageFragmentDoc}
${MpuLowSocAlertForAlertsPageFragmentDoc}
${MpuCriticalFaultAlertForAlertsPageFragmentDoc}
${ReservationItemAllocationAlertForAlertsPageFragmentDoc}
${ReservationAllocationAlertForAlertsPageFragmentDoc}`;

/**
 * __useListActiveAlertsQuery__
 *
 * To run a query within a React component, call `useListActiveAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveAlertsQuery({
 *   variables: {
 *      reservationIDs: // value for 'reservationIDs'
 *   },
 * });
 */
export function useListActiveAlertsQuery(baseOptions?: Apollo.QueryHookOptions<ListActiveAlertsQuery, ListActiveAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveAlertsQuery, ListActiveAlertsQueryVariables>(ListActiveAlertsDocument, options);
      }
export function useListActiveAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveAlertsQuery, ListActiveAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveAlertsQuery, ListActiveAlertsQueryVariables>(ListActiveAlertsDocument, options);
        }
export type ListActiveAlertsQueryHookResult = ReturnType<typeof useListActiveAlertsQuery>;
export type ListActiveAlertsLazyQueryHookResult = ReturnType<typeof useListActiveAlertsLazyQuery>;
export type ListActiveAlertsQueryResult = Apollo.QueryResult<ListActiveAlertsQuery, ListActiveAlertsQueryVariables>;
export const GlobalListDeviceModelsDocument = gql`
    query GlobalListDeviceModels {
  listDeviceModels {
    id
    name
  }
}
    `;

/**
 * __useGlobalListDeviceModelsQuery__
 *
 * To run a query within a React component, call `useGlobalListDeviceModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalListDeviceModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalListDeviceModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalListDeviceModelsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalListDeviceModelsQuery, GlobalListDeviceModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalListDeviceModelsQuery, GlobalListDeviceModelsQueryVariables>(GlobalListDeviceModelsDocument, options);
      }
export function useGlobalListDeviceModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalListDeviceModelsQuery, GlobalListDeviceModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalListDeviceModelsQuery, GlobalListDeviceModelsQueryVariables>(GlobalListDeviceModelsDocument, options);
        }
export type GlobalListDeviceModelsQueryHookResult = ReturnType<typeof useGlobalListDeviceModelsQuery>;
export type GlobalListDeviceModelsLazyQueryHookResult = ReturnType<typeof useGlobalListDeviceModelsLazyQuery>;
export type GlobalListDeviceModelsQueryResult = Apollo.QueryResult<GlobalListDeviceModelsQuery, GlobalListDeviceModelsQueryVariables>;
export const ValidateInviteKeyDocument = gql`
    query ValidateInviteKey($inviteKey: String!) {
  validateInviteKey(inviteKey: $inviteKey) {
    exists
    isClaimed
    isExpired
  }
}
    `;

/**
 * __useValidateInviteKeyQuery__
 *
 * To run a query within a React component, call `useValidateInviteKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateInviteKeyQuery({
 *   variables: {
 *      inviteKey: // value for 'inviteKey'
 *   },
 * });
 */
export function useValidateInviteKeyQuery(baseOptions: Apollo.QueryHookOptions<ValidateInviteKeyQuery, ValidateInviteKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateInviteKeyQuery, ValidateInviteKeyQueryVariables>(ValidateInviteKeyDocument, options);
      }
export function useValidateInviteKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateInviteKeyQuery, ValidateInviteKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateInviteKeyQuery, ValidateInviteKeyQueryVariables>(ValidateInviteKeyDocument, options);
        }
export type ValidateInviteKeyQueryHookResult = ReturnType<typeof useValidateInviteKeyQuery>;
export type ValidateInviteKeyLazyQueryHookResult = ReturnType<typeof useValidateInviteKeyLazyQuery>;
export type ValidateInviteKeyQueryResult = Apollo.QueryResult<ValidateInviteKeyQuery, ValidateInviteKeyQueryVariables>;
export const GetReservationWithPaymentInfoDocument = gql`
    query GetReservationWithPaymentInfo($id: String!) {
  userReservationPaymentInfo(id: $id) {
    reservation {
      id
      status
      createdAt
      additionalNotes
      reservation_seq_id
      account {
        id
        name
      }
      reservationItems {
        id
        alias
        start
        end
        quantity
        deviceModel {
          id
          name
        }
        pickupLocation {
          id
          formattedAddress
          contactPhone
          contactName
        }
        deliveryLocation {
          id
          formattedAddress
          contactPhone
          contactName
        }
        pickupDate
        deliveryDate
      }
    }
  }
}
    `;

/**
 * __useGetReservationWithPaymentInfoQuery__
 *
 * To run a query within a React component, call `useGetReservationWithPaymentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationWithPaymentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationWithPaymentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReservationWithPaymentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetReservationWithPaymentInfoQuery, GetReservationWithPaymentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationWithPaymentInfoQuery, GetReservationWithPaymentInfoQueryVariables>(GetReservationWithPaymentInfoDocument, options);
      }
export function useGetReservationWithPaymentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationWithPaymentInfoQuery, GetReservationWithPaymentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationWithPaymentInfoQuery, GetReservationWithPaymentInfoQueryVariables>(GetReservationWithPaymentInfoDocument, options);
        }
export type GetReservationWithPaymentInfoQueryHookResult = ReturnType<typeof useGetReservationWithPaymentInfoQuery>;
export type GetReservationWithPaymentInfoLazyQueryHookResult = ReturnType<typeof useGetReservationWithPaymentInfoLazyQuery>;
export type GetReservationWithPaymentInfoQueryResult = Apollo.QueryResult<GetReservationWithPaymentInfoQuery, GetReservationWithPaymentInfoQueryVariables>;
export const UserSubmitReservationRequestDocument = gql`
    mutation UserSubmitReservationRequest($input: SubmitReservationRequestInput!) {
  submitReservationRequest(submitReservationRequestInput: $input) {
    id
  }
}
    `;
export type UserSubmitReservationRequestMutationFn = Apollo.MutationFunction<UserSubmitReservationRequestMutation, UserSubmitReservationRequestMutationVariables>;

/**
 * __useUserSubmitReservationRequestMutation__
 *
 * To run a mutation, you first call `useUserSubmitReservationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSubmitReservationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSubmitReservationRequestMutation, { data, loading, error }] = useUserSubmitReservationRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSubmitReservationRequestMutation(baseOptions?: Apollo.MutationHookOptions<UserSubmitReservationRequestMutation, UserSubmitReservationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSubmitReservationRequestMutation, UserSubmitReservationRequestMutationVariables>(UserSubmitReservationRequestDocument, options);
      }
export type UserSubmitReservationRequestMutationHookResult = ReturnType<typeof useUserSubmitReservationRequestMutation>;
export type UserSubmitReservationRequestMutationResult = Apollo.MutationResult<UserSubmitReservationRequestMutation>;
export type UserSubmitReservationRequestMutationOptions = Apollo.BaseMutationOptions<UserSubmitReservationRequestMutation, UserSubmitReservationRequestMutationVariables>;
export const GetUserSessionDocument = gql`
    query GetUserSession {
  currentUserSession {
    id
    email
    name
    accounts {
      id
      name
      accountRoles {
        name
      }
    }
    userRoles
    userPermissions
    admin
  }
}
    `;

/**
 * __useGetUserSessionQuery__
 *
 * To run a query within a React component, call `useGetUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSessionQuery, GetUserSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSessionQuery, GetUserSessionQueryVariables>(GetUserSessionDocument, options);
      }
export function useGetUserSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSessionQuery, GetUserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSessionQuery, GetUserSessionQueryVariables>(GetUserSessionDocument, options);
        }
export type GetUserSessionQueryHookResult = ReturnType<typeof useGetUserSessionQuery>;
export type GetUserSessionLazyQueryHookResult = ReturnType<typeof useGetUserSessionLazyQuery>;
export type GetUserSessionQueryResult = Apollo.QueryResult<GetUserSessionQuery, GetUserSessionQueryVariables>;
export const LogOutUserDocument = gql`
    mutation LogOutUser {
  logoutUser {
    logout
  }
}
    `;
export type LogOutUserMutationFn = Apollo.MutationFunction<LogOutUserMutation, LogOutUserMutationVariables>;

/**
 * __useLogOutUserMutation__
 *
 * To run a mutation, you first call `useLogOutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutUserMutation, { data, loading, error }] = useLogOutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogOutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogOutUserMutation, LogOutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutUserMutation, LogOutUserMutationVariables>(LogOutUserDocument, options);
      }
export type LogOutUserMutationHookResult = ReturnType<typeof useLogOutUserMutation>;
export type LogOutUserMutationResult = Apollo.MutationResult<LogOutUserMutation>;
export type LogOutUserMutationOptions = Apollo.BaseMutationOptions<LogOutUserMutation, LogOutUserMutationVariables>;
export const GetReservationItemTelemetryDocument = gql`
    query GetReservationItemTelemetry($input: ReservationTelemetryInput!) {
  reservationTelemetry(input: $input) {
    telemetries {
      metric
      datapoints {
        value
        timestamp
      }
    }
  }
}
    `;

/**
 * __useGetReservationItemTelemetryQuery__
 *
 * To run a query within a React component, call `useGetReservationItemTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationItemTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationItemTelemetryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReservationItemTelemetryQuery(baseOptions: Apollo.QueryHookOptions<GetReservationItemTelemetryQuery, GetReservationItemTelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationItemTelemetryQuery, GetReservationItemTelemetryQueryVariables>(GetReservationItemTelemetryDocument, options);
      }
export function useGetReservationItemTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationItemTelemetryQuery, GetReservationItemTelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationItemTelemetryQuery, GetReservationItemTelemetryQueryVariables>(GetReservationItemTelemetryDocument, options);
        }
export type GetReservationItemTelemetryQueryHookResult = ReturnType<typeof useGetReservationItemTelemetryQuery>;
export type GetReservationItemTelemetryLazyQueryHookResult = ReturnType<typeof useGetReservationItemTelemetryLazyQuery>;
export type GetReservationItemTelemetryQueryResult = Apollo.QueryResult<GetReservationItemTelemetryQuery, GetReservationItemTelemetryQueryVariables>;
export const GetDeviceTelemetryDocument = gql`
    query GetDeviceTelemetry($input: DeviceTelemetryInput!) {
  deviceTelemetry(deviceTelemetryInput: $input) {
    telemetries {
      metric
      datapoints {
        value
        timestamp
      }
    }
  }
}
    `;

/**
 * __useGetDeviceTelemetryQuery__
 *
 * To run a query within a React component, call `useGetDeviceTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTelemetryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDeviceTelemetryQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceTelemetryQuery, GetDeviceTelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceTelemetryQuery, GetDeviceTelemetryQueryVariables>(GetDeviceTelemetryDocument, options);
      }
export function useGetDeviceTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceTelemetryQuery, GetDeviceTelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceTelemetryQuery, GetDeviceTelemetryQueryVariables>(GetDeviceTelemetryDocument, options);
        }
export type GetDeviceTelemetryQueryHookResult = ReturnType<typeof useGetDeviceTelemetryQuery>;
export type GetDeviceTelemetryLazyQueryHookResult = ReturnType<typeof useGetDeviceTelemetryLazyQuery>;
export type GetDeviceTelemetryQueryResult = Apollo.QueryResult<GetDeviceTelemetryQuery, GetDeviceTelemetryQueryVariables>;
export const GetReservationItemLatestTelemetryDocument = gql`
    query GetReservationItemLatestTelemetry($id: String!, $metricNames: [String!]!) {
  reservationLatestTelemetry(
    input: {reservationItemID: $id, metricNames: $metricNames}
  ) {
    telemetryPoints {
      metric
      timestamp
      value
    }
  }
}
    `;

/**
 * __useGetReservationItemLatestTelemetryQuery__
 *
 * To run a query within a React component, call `useGetReservationItemLatestTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationItemLatestTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationItemLatestTelemetryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metricNames: // value for 'metricNames'
 *   },
 * });
 */
export function useGetReservationItemLatestTelemetryQuery(baseOptions: Apollo.QueryHookOptions<GetReservationItemLatestTelemetryQuery, GetReservationItemLatestTelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationItemLatestTelemetryQuery, GetReservationItemLatestTelemetryQueryVariables>(GetReservationItemLatestTelemetryDocument, options);
      }
export function useGetReservationItemLatestTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationItemLatestTelemetryQuery, GetReservationItemLatestTelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationItemLatestTelemetryQuery, GetReservationItemLatestTelemetryQueryVariables>(GetReservationItemLatestTelemetryDocument, options);
        }
export type GetReservationItemLatestTelemetryQueryHookResult = ReturnType<typeof useGetReservationItemLatestTelemetryQuery>;
export type GetReservationItemLatestTelemetryLazyQueryHookResult = ReturnType<typeof useGetReservationItemLatestTelemetryLazyQuery>;
export type GetReservationItemLatestTelemetryQueryResult = Apollo.QueryResult<GetReservationItemLatestTelemetryQuery, GetReservationItemLatestTelemetryQueryVariables>;
export const GetDeviceLatestTelemetryDocument = gql`
    query GetDeviceLatestTelemetry($id: String!, $metricNames: [String!]!) {
  getDeviceInstance(id: $id) {
    latestTelemetry(metrics: $metricNames) {
      telemetryPoints {
        metric
        timestamp
        value
      }
    }
  }
}
    `;

/**
 * __useGetDeviceLatestTelemetryQuery__
 *
 * To run a query within a React component, call `useGetDeviceLatestTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceLatestTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceLatestTelemetryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metricNames: // value for 'metricNames'
 *   },
 * });
 */
export function useGetDeviceLatestTelemetryQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceLatestTelemetryQuery, GetDeviceLatestTelemetryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceLatestTelemetryQuery, GetDeviceLatestTelemetryQueryVariables>(GetDeviceLatestTelemetryDocument, options);
      }
export function useGetDeviceLatestTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceLatestTelemetryQuery, GetDeviceLatestTelemetryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceLatestTelemetryQuery, GetDeviceLatestTelemetryQueryVariables>(GetDeviceLatestTelemetryDocument, options);
        }
export type GetDeviceLatestTelemetryQueryHookResult = ReturnType<typeof useGetDeviceLatestTelemetryQuery>;
export type GetDeviceLatestTelemetryLazyQueryHookResult = ReturnType<typeof useGetDeviceLatestTelemetryLazyQuery>;
export type GetDeviceLatestTelemetryQueryResult = Apollo.QueryResult<GetDeviceLatestTelemetryQuery, GetDeviceLatestTelemetryQueryVariables>;
export const GetEnergyUsageForMpuDocument = gql`
    query GetEnergyUsageForMPU($id: String!, $start: DateTime!, $end: DateTime!, $groupBy: GroupByInterval!) {
  deviceEnergyUsage(
    input: {deviceID: $id, start: $start, end: $end, groupBy: $groupBy}
  ) {
    telemetries {
      metric
      datapoints {
        value
        timestamp
      }
    }
  }
}
    `;

/**
 * __useGetEnergyUsageForMpuQuery__
 *
 * To run a query within a React component, call `useGetEnergyUsageForMpuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnergyUsageForMpuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnergyUsageForMpuQuery({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useGetEnergyUsageForMpuQuery(baseOptions: Apollo.QueryHookOptions<GetEnergyUsageForMpuQuery, GetEnergyUsageForMpuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnergyUsageForMpuQuery, GetEnergyUsageForMpuQueryVariables>(GetEnergyUsageForMpuDocument, options);
      }
export function useGetEnergyUsageForMpuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnergyUsageForMpuQuery, GetEnergyUsageForMpuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnergyUsageForMpuQuery, GetEnergyUsageForMpuQueryVariables>(GetEnergyUsageForMpuDocument, options);
        }
export type GetEnergyUsageForMpuQueryHookResult = ReturnType<typeof useGetEnergyUsageForMpuQuery>;
export type GetEnergyUsageForMpuLazyQueryHookResult = ReturnType<typeof useGetEnergyUsageForMpuLazyQuery>;
export type GetEnergyUsageForMpuQueryResult = Apollo.QueryResult<GetEnergyUsageForMpuQuery, GetEnergyUsageForMpuQueryVariables>;
export const GetEnergyUsageForUnitDocument = gql`
    query GetEnergyUsageForUnit($id: String!, $groupBy: GroupByInterval!) {
  reservationEnergyUsage(input: {reservationItemID: $id, groupBy: $groupBy}) {
    telemetries {
      metric
      datapoints {
        value
        timestamp
      }
    }
  }
}
    `;

/**
 * __useGetEnergyUsageForUnitQuery__
 *
 * To run a query within a React component, call `useGetEnergyUsageForUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnergyUsageForUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnergyUsageForUnitQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useGetEnergyUsageForUnitQuery(baseOptions: Apollo.QueryHookOptions<GetEnergyUsageForUnitQuery, GetEnergyUsageForUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnergyUsageForUnitQuery, GetEnergyUsageForUnitQueryVariables>(GetEnergyUsageForUnitDocument, options);
      }
export function useGetEnergyUsageForUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnergyUsageForUnitQuery, GetEnergyUsageForUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnergyUsageForUnitQuery, GetEnergyUsageForUnitQueryVariables>(GetEnergyUsageForUnitDocument, options);
        }
export type GetEnergyUsageForUnitQueryHookResult = ReturnType<typeof useGetEnergyUsageForUnitQuery>;
export type GetEnergyUsageForUnitLazyQueryHookResult = ReturnType<typeof useGetEnergyUsageForUnitLazyQuery>;
export type GetEnergyUsageForUnitQueryResult = Apollo.QueryResult<GetEnergyUsageForUnitQuery, GetEnergyUsageForUnitQueryVariables>;
export const GetMpuBasicDetailsDocument = gql`
    query GetMPUBasicDetails($id: String!) {
  getDeviceInstance(id: $id) {
    id
    name
    assetID
    serialNumber
    externalID
    deviceModel {
      id
      name
    }
    serviceArea {
      id
      name
    }
    owner {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMpuBasicDetailsQuery__
 *
 * To run a query within a React component, call `useGetMpuBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuBasicDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMpuBasicDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMpuBasicDetailsQuery, GetMpuBasicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuBasicDetailsQuery, GetMpuBasicDetailsQueryVariables>(GetMpuBasicDetailsDocument, options);
      }
export function useGetMpuBasicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuBasicDetailsQuery, GetMpuBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuBasicDetailsQuery, GetMpuBasicDetailsQueryVariables>(GetMpuBasicDetailsDocument, options);
        }
export type GetMpuBasicDetailsQueryHookResult = ReturnType<typeof useGetMpuBasicDetailsQuery>;
export type GetMpuBasicDetailsLazyQueryHookResult = ReturnType<typeof useGetMpuBasicDetailsLazyQuery>;
export type GetMpuBasicDetailsQueryResult = Apollo.QueryResult<GetMpuBasicDetailsQuery, GetMpuBasicDetailsQueryVariables>;
export const GetMpuSpotlightStatsDocument = gql`
    query GetMPUSpotlightStats($id: String!) {
  getDeviceInstance(id: $id) {
    id
    latestDataTimestamp
    latestDeviceLocation {
      lat
      lon
      time
    }
    latestTelemetry(metrics: ["soc", "s_time_to_empty"]) {
      telemetryPoints {
        metric
        timestamp
        value
      }
    }
  }
}
    `;

/**
 * __useGetMpuSpotlightStatsQuery__
 *
 * To run a query within a React component, call `useGetMpuSpotlightStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuSpotlightStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuSpotlightStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMpuSpotlightStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMpuSpotlightStatsQuery, GetMpuSpotlightStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuSpotlightStatsQuery, GetMpuSpotlightStatsQueryVariables>(GetMpuSpotlightStatsDocument, options);
      }
export function useGetMpuSpotlightStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuSpotlightStatsQuery, GetMpuSpotlightStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuSpotlightStatsQuery, GetMpuSpotlightStatsQueryVariables>(GetMpuSpotlightStatsDocument, options);
        }
export type GetMpuSpotlightStatsQueryHookResult = ReturnType<typeof useGetMpuSpotlightStatsQuery>;
export type GetMpuSpotlightStatsLazyQueryHookResult = ReturnType<typeof useGetMpuSpotlightStatsLazyQuery>;
export type GetMpuSpotlightStatsQueryResult = Apollo.QueryResult<GetMpuSpotlightStatsQuery, GetMpuSpotlightStatsQueryVariables>;
export const CreateDeviceInstanceDocument = gql`
    mutation CreateDeviceInstance($input: CreateDeviceInstanceInput!) {
  createDeviceInstance(input: $input) {
    id
    name
    assetID
    deviceModel {
      id
      name
    }
    owner {
      id
      name
    }
  }
}
    `;
export type CreateDeviceInstanceMutationFn = Apollo.MutationFunction<CreateDeviceInstanceMutation, CreateDeviceInstanceMutationVariables>;

/**
 * __useCreateDeviceInstanceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceInstanceMutation, { data, loading, error }] = useCreateDeviceInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceInstanceMutation, CreateDeviceInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceInstanceMutation, CreateDeviceInstanceMutationVariables>(CreateDeviceInstanceDocument, options);
      }
export type CreateDeviceInstanceMutationHookResult = ReturnType<typeof useCreateDeviceInstanceMutation>;
export type CreateDeviceInstanceMutationResult = Apollo.MutationResult<CreateDeviceInstanceMutation>;
export type CreateDeviceInstanceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceInstanceMutation, CreateDeviceInstanceMutationVariables>;
export const UpdateDeviceInstanceDocument = gql`
    mutation UpdateDeviceInstance($input: UpdateDeviceInstanceInput!) {
  updateDeviceInstance(input: $input) {
    id
    name
    assetID
    deviceModel {
      id
      name
    }
    owner {
      id
      name
    }
    serialNumber
    serviceArea {
      id
      name
    }
    externalID
  }
}
    `;
export type UpdateDeviceInstanceMutationFn = Apollo.MutationFunction<UpdateDeviceInstanceMutation, UpdateDeviceInstanceMutationVariables>;

/**
 * __useUpdateDeviceInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceInstanceMutation, { data, loading, error }] = useUpdateDeviceInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceInstanceMutation, UpdateDeviceInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceInstanceMutation, UpdateDeviceInstanceMutationVariables>(UpdateDeviceInstanceDocument, options);
      }
export type UpdateDeviceInstanceMutationHookResult = ReturnType<typeof useUpdateDeviceInstanceMutation>;
export type UpdateDeviceInstanceMutationResult = Apollo.MutationResult<UpdateDeviceInstanceMutation>;
export type UpdateDeviceInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceInstanceMutation, UpdateDeviceInstanceMutationVariables>;
export const DeleteDeviceInstanceDocument = gql`
    mutation DeleteDeviceInstance($deviceInstanceID: String!) {
  deleteDeviceInstance(id: $deviceInstanceID) {
    id
  }
}
    `;
export type DeleteDeviceInstanceMutationFn = Apollo.MutationFunction<DeleteDeviceInstanceMutation, DeleteDeviceInstanceMutationVariables>;

/**
 * __useDeleteDeviceInstanceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceInstanceMutation, { data, loading, error }] = useDeleteDeviceInstanceMutation({
 *   variables: {
 *      deviceInstanceID: // value for 'deviceInstanceID'
 *   },
 * });
 */
export function useDeleteDeviceInstanceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceInstanceMutation, DeleteDeviceInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceInstanceMutation, DeleteDeviceInstanceMutationVariables>(DeleteDeviceInstanceDocument, options);
      }
export type DeleteDeviceInstanceMutationHookResult = ReturnType<typeof useDeleteDeviceInstanceMutation>;
export type DeleteDeviceInstanceMutationResult = Apollo.MutationResult<DeleteDeviceInstanceMutation>;
export type DeleteDeviceInstanceMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceInstanceMutation, DeleteDeviceInstanceMutationVariables>;
export const ListDeviceModelsDocument = gql`
    query ListDeviceModels {
  listDeviceModels {
    id
    name
  }
}
    `;

/**
 * __useListDeviceModelsQuery__
 *
 * To run a query within a React component, call `useListDeviceModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeviceModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeviceModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDeviceModelsQuery(baseOptions?: Apollo.QueryHookOptions<ListDeviceModelsQuery, ListDeviceModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeviceModelsQuery, ListDeviceModelsQueryVariables>(ListDeviceModelsDocument, options);
      }
export function useListDeviceModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeviceModelsQuery, ListDeviceModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeviceModelsQuery, ListDeviceModelsQueryVariables>(ListDeviceModelsDocument, options);
        }
export type ListDeviceModelsQueryHookResult = ReturnType<typeof useListDeviceModelsQuery>;
export type ListDeviceModelsLazyQueryHookResult = ReturnType<typeof useListDeviceModelsLazyQuery>;
export type ListDeviceModelsQueryResult = Apollo.QueryResult<ListDeviceModelsQuery, ListDeviceModelsQueryVariables>;
export const ListAccountsDocument = gql`
    query ListAccounts($after: String, $first: Int, $before: String, $last: Int, $sortBy: KeyOfSortArg, $filters: AccountPaginationFilters) {
  listAccounts(
    after: $after
    first: $first
    before: $before
    last: $last
    sortBy: $sortBy
    filters: $filters
  ) {
    edges {
      node {
        id
        name
        industry
      }
    }
    pageInfo {
      totalEdges
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useListAccountsQuery__
 *
 * To run a query within a React component, call `useListAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
      }
export function useListAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
export type ListAccountsQueryHookResult = ReturnType<typeof useListAccountsQuery>;
export type ListAccountsLazyQueryHookResult = ReturnType<typeof useListAccountsLazyQuery>;
export type ListAccountsQueryResult = Apollo.QueryResult<ListAccountsQuery, ListAccountsQueryVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($accountDetails: CreateAccountInput!) {
  createAccount(accountDetails: $accountDetails) {
    id
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      accountDetails: // value for 'accountDetails'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const GetMoxionRepsDocument = gql`
    query GetMoxionReps {
  listAllowedMoxionReps {
    id
    name
    roles {
      name
    }
  }
}
    `;

/**
 * __useGetMoxionRepsQuery__
 *
 * To run a query within a React component, call `useGetMoxionRepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoxionRepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoxionRepsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMoxionRepsQuery(baseOptions?: Apollo.QueryHookOptions<GetMoxionRepsQuery, GetMoxionRepsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoxionRepsQuery, GetMoxionRepsQueryVariables>(GetMoxionRepsDocument, options);
      }
export function useGetMoxionRepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoxionRepsQuery, GetMoxionRepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoxionRepsQuery, GetMoxionRepsQueryVariables>(GetMoxionRepsDocument, options);
        }
export type GetMoxionRepsQueryHookResult = ReturnType<typeof useGetMoxionRepsQuery>;
export type GetMoxionRepsLazyQueryHookResult = ReturnType<typeof useGetMoxionRepsLazyQuery>;
export type GetMoxionRepsQueryResult = Apollo.QueryResult<GetMoxionRepsQuery, GetMoxionRepsQueryVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: String!) {
  getAccount(id: $id) {
    ...BasicDetails
    invites {
      id
      email
    }
    accountRoles {
      name
    }
    createdAt
    updatedAt
  }
  listUsers(first: 1000000, filters: {accountIDs: [$id]}) {
    edges {
      node {
        id
        name
        email
        roles {
          name
        }
        status
      }
    }
  }
}
    ${BasicDetailsFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const UpdateAccountBasicsDocument = gql`
    mutation UpdateAccountBasics($accountInput: AccountInput!) {
  updateAccount(accountInput: $accountInput) {
    ...BasicDetails
  }
}
    ${BasicDetailsFragmentDoc}`;
export type UpdateAccountBasicsMutationFn = Apollo.MutationFunction<UpdateAccountBasicsMutation, UpdateAccountBasicsMutationVariables>;

/**
 * __useUpdateAccountBasicsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountBasicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountBasicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountBasicsMutation, { data, loading, error }] = useUpdateAccountBasicsMutation({
 *   variables: {
 *      accountInput: // value for 'accountInput'
 *   },
 * });
 */
export function useUpdateAccountBasicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountBasicsMutation, UpdateAccountBasicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountBasicsMutation, UpdateAccountBasicsMutationVariables>(UpdateAccountBasicsDocument, options);
      }
export type UpdateAccountBasicsMutationHookResult = ReturnType<typeof useUpdateAccountBasicsMutation>;
export type UpdateAccountBasicsMutationResult = Apollo.MutationResult<UpdateAccountBasicsMutation>;
export type UpdateAccountBasicsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountBasicsMutation, UpdateAccountBasicsMutationVariables>;
export const AssociateNetSuiteCustomerWithAccountDocument = gql`
    mutation AssociateNetSuiteCustomerWithAccount($input: AssociateNetSuiteCustomerWithAccountInput!) {
  associateNetSuiteCustomerWithAccount(input: $input) {
    id
    netsuiteCustomers {
      id
    }
  }
}
    `;
export type AssociateNetSuiteCustomerWithAccountMutationFn = Apollo.MutationFunction<AssociateNetSuiteCustomerWithAccountMutation, AssociateNetSuiteCustomerWithAccountMutationVariables>;

/**
 * __useAssociateNetSuiteCustomerWithAccountMutation__
 *
 * To run a mutation, you first call `useAssociateNetSuiteCustomerWithAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateNetSuiteCustomerWithAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateNetSuiteCustomerWithAccountMutation, { data, loading, error }] = useAssociateNetSuiteCustomerWithAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateNetSuiteCustomerWithAccountMutation(baseOptions?: Apollo.MutationHookOptions<AssociateNetSuiteCustomerWithAccountMutation, AssociateNetSuiteCustomerWithAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateNetSuiteCustomerWithAccountMutation, AssociateNetSuiteCustomerWithAccountMutationVariables>(AssociateNetSuiteCustomerWithAccountDocument, options);
      }
export type AssociateNetSuiteCustomerWithAccountMutationHookResult = ReturnType<typeof useAssociateNetSuiteCustomerWithAccountMutation>;
export type AssociateNetSuiteCustomerWithAccountMutationResult = Apollo.MutationResult<AssociateNetSuiteCustomerWithAccountMutation>;
export type AssociateNetSuiteCustomerWithAccountMutationOptions = Apollo.BaseMutationOptions<AssociateNetSuiteCustomerWithAccountMutation, AssociateNetSuiteCustomerWithAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($accountID: String!) {
  deleteAccount(id: $accountID) {
    id
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const AddAccountRolesDocument = gql`
    mutation AddAccountRoles($input: ModifyAccountRolesInput!) {
  addAccountRoles(input: $input) {
    id
    accountRoles {
      name
    }
  }
}
    `;
export type AddAccountRolesMutationFn = Apollo.MutationFunction<AddAccountRolesMutation, AddAccountRolesMutationVariables>;

/**
 * __useAddAccountRolesMutation__
 *
 * To run a mutation, you first call `useAddAccountRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountRolesMutation, { data, loading, error }] = useAddAccountRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccountRolesMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountRolesMutation, AddAccountRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountRolesMutation, AddAccountRolesMutationVariables>(AddAccountRolesDocument, options);
      }
export type AddAccountRolesMutationHookResult = ReturnType<typeof useAddAccountRolesMutation>;
export type AddAccountRolesMutationResult = Apollo.MutationResult<AddAccountRolesMutation>;
export type AddAccountRolesMutationOptions = Apollo.BaseMutationOptions<AddAccountRolesMutation, AddAccountRolesMutationVariables>;
export const RemoveAccountRolesDocument = gql`
    mutation RemoveAccountRoles($input: ModifyAccountRolesInput!) {
  removeAccountRoles(input: $input) {
    id
    accountRoles {
      name
    }
  }
}
    `;
export type RemoveAccountRolesMutationFn = Apollo.MutationFunction<RemoveAccountRolesMutation, RemoveAccountRolesMutationVariables>;

/**
 * __useRemoveAccountRolesMutation__
 *
 * To run a mutation, you first call `useRemoveAccountRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccountRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccountRolesMutation, { data, loading, error }] = useRemoveAccountRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAccountRolesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccountRolesMutation, RemoveAccountRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccountRolesMutation, RemoveAccountRolesMutationVariables>(RemoveAccountRolesDocument, options);
      }
export type RemoveAccountRolesMutationHookResult = ReturnType<typeof useRemoveAccountRolesMutation>;
export type RemoveAccountRolesMutationResult = Apollo.MutationResult<RemoveAccountRolesMutation>;
export type RemoveAccountRolesMutationOptions = Apollo.BaseMutationOptions<RemoveAccountRolesMutation, RemoveAccountRolesMutationVariables>;
export const GetAccountRolesForAccountDocument = gql`
    query GetAccountRolesForAccount($accountID: String!) {
  getAccount(id: $accountID) {
    accountRoles {
      name
    }
  }
}
    `;

/**
 * __useGetAccountRolesForAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountRolesForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountRolesForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountRolesForAccountQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useGetAccountRolesForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountRolesForAccountQuery, GetAccountRolesForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountRolesForAccountQuery, GetAccountRolesForAccountQueryVariables>(GetAccountRolesForAccountDocument, options);
      }
export function useGetAccountRolesForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountRolesForAccountQuery, GetAccountRolesForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountRolesForAccountQuery, GetAccountRolesForAccountQueryVariables>(GetAccountRolesForAccountDocument, options);
        }
export type GetAccountRolesForAccountQueryHookResult = ReturnType<typeof useGetAccountRolesForAccountQuery>;
export type GetAccountRolesForAccountLazyQueryHookResult = ReturnType<typeof useGetAccountRolesForAccountLazyQuery>;
export type GetAccountRolesForAccountQueryResult = Apollo.QueryResult<GetAccountRolesForAccountQuery, GetAccountRolesForAccountQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($after: String, $first: Int, $before: String, $last: Int, $sortBy: KeyOfSortArg, $filters: UserPaginationFilters) {
  listUsers(
    after: $after
    first: $first
    before: $before
    last: $last
    sortBy: $sortBy
    filters: $filters
  ) {
    edges {
      node {
        id
        name
        email
        roles {
          name
        }
        status
        accounts {
          id
          name
        }
      }
    }
    pageInfo {
      totalEdges
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($userID: String!) {
  getUser(id: $userID) {
    id
    name
    active
    email
    phoneNumber
    accounts {
      id
      name
    }
    roles {
      name
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ListUserRolesDocument = gql`
    query listUserRoles($userID: String!) {
  listUserRoles(userID: $userID)
}
    `;

/**
 * __useListUserRolesQuery__
 *
 * To run a query within a React component, call `useListUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserRolesQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useListUserRolesQuery(baseOptions: Apollo.QueryHookOptions<ListUserRolesQuery, ListUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserRolesQuery, ListUserRolesQueryVariables>(ListUserRolesDocument, options);
      }
export function useListUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserRolesQuery, ListUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserRolesQuery, ListUserRolesQueryVariables>(ListUserRolesDocument, options);
        }
export type ListUserRolesQueryHookResult = ReturnType<typeof useListUserRolesQuery>;
export type ListUserRolesLazyQueryHookResult = ReturnType<typeof useListUserRolesLazyQuery>;
export type ListUserRolesQueryResult = Apollo.QueryResult<ListUserRolesQuery, ListUserRolesQueryVariables>;
export const AddUserRolesDocument = gql`
    mutation AddUserRoles($input: ModifyUserRolesInput!) {
  addUserRoles(addUserRolesInput: $input) {
    id
    roles {
      name
    }
  }
}
    `;
export type AddUserRolesMutationFn = Apollo.MutationFunction<AddUserRolesMutation, AddUserRolesMutationVariables>;

/**
 * __useAddUserRolesMutation__
 *
 * To run a mutation, you first call `useAddUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserRolesMutation, { data, loading, error }] = useAddUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserRolesMutation, AddUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserRolesMutation, AddUserRolesMutationVariables>(AddUserRolesDocument, options);
      }
export type AddUserRolesMutationHookResult = ReturnType<typeof useAddUserRolesMutation>;
export type AddUserRolesMutationResult = Apollo.MutationResult<AddUserRolesMutation>;
export type AddUserRolesMutationOptions = Apollo.BaseMutationOptions<AddUserRolesMutation, AddUserRolesMutationVariables>;
export const RemoveUserRolesDocument = gql`
    mutation RemoveUserRoles($input: ModifyUserRolesInput!) {
  removeUserRoles(removeUserRolesInput: $input) {
    id
    roles {
      name
    }
  }
}
    `;
export type RemoveUserRolesMutationFn = Apollo.MutationFunction<RemoveUserRolesMutation, RemoveUserRolesMutationVariables>;

/**
 * __useRemoveUserRolesMutation__
 *
 * To run a mutation, you first call `useRemoveUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserRolesMutation, { data, loading, error }] = useRemoveUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserRolesMutation, RemoveUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserRolesMutation, RemoveUserRolesMutationVariables>(RemoveUserRolesDocument, options);
      }
export type RemoveUserRolesMutationHookResult = ReturnType<typeof useRemoveUserRolesMutation>;
export type RemoveUserRolesMutationResult = Apollo.MutationResult<RemoveUserRolesMutation>;
export type RemoveUserRolesMutationOptions = Apollo.BaseMutationOptions<RemoveUserRolesMutation, RemoveUserRolesMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userInput: UserInput!) {
  updateUser(userInput: $userInput) {
    id
    name
    status
    email
    phoneNumber
    accounts {
      id
      name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($userID: String!) {
  deactivateUser(id: $userID) {
    id
    status
  }
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const ActivateUserDocument = gql`
    mutation ActivateUser($userID: String!) {
  activateUser(id: $userID) {
    id
    status
  }
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const ListAllAccountsDocument = gql`
    query ListAllAccounts {
  listAccounts {
    edges {
      cursor
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListAllAccountsQuery__
 *
 * To run a query within a React component, call `useListAllAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllAccountsQuery, ListAllAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllAccountsQuery, ListAllAccountsQueryVariables>(ListAllAccountsDocument, options);
      }
export function useListAllAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllAccountsQuery, ListAllAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllAccountsQuery, ListAllAccountsQueryVariables>(ListAllAccountsDocument, options);
        }
export type ListAllAccountsQueryHookResult = ReturnType<typeof useListAllAccountsQuery>;
export type ListAllAccountsLazyQueryHookResult = ReturnType<typeof useListAllAccountsLazyQuery>;
export type ListAllAccountsQueryResult = Apollo.QueryResult<ListAllAccountsQuery, ListAllAccountsQueryVariables>;
export const ListAllRolesDocument = gql`
    query ListAllRoles {
  listRoles {
    name
  }
}
    `;

/**
 * __useListAllRolesQuery__
 *
 * To run a query within a React component, call `useListAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<ListAllRolesQuery, ListAllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllRolesQuery, ListAllRolesQueryVariables>(ListAllRolesDocument, options);
      }
export function useListAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllRolesQuery, ListAllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllRolesQuery, ListAllRolesQueryVariables>(ListAllRolesDocument, options);
        }
export type ListAllRolesQueryHookResult = ReturnType<typeof useListAllRolesQuery>;
export type ListAllRolesLazyQueryHookResult = ReturnType<typeof useListAllRolesLazyQuery>;
export type ListAllRolesQueryResult = Apollo.QueryResult<ListAllRolesQuery, ListAllRolesQueryVariables>;
export const AddItemsToReservationDocument = gql`
    mutation AddItemsToReservation($input: AddReservationItemsToReservationInput!) {
  addItemsToReservation(input: $input) {
    id
    reservationItems {
      ...ReservationItemForReservationPage
    }
  }
}
    ${ReservationItemForReservationPageFragmentDoc}`;
export type AddItemsToReservationMutationFn = Apollo.MutationFunction<AddItemsToReservationMutation, AddItemsToReservationMutationVariables>;

/**
 * __useAddItemsToReservationMutation__
 *
 * To run a mutation, you first call `useAddItemsToReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemsToReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemsToReservationMutation, { data, loading, error }] = useAddItemsToReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemsToReservationMutation(baseOptions?: Apollo.MutationHookOptions<AddItemsToReservationMutation, AddItemsToReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemsToReservationMutation, AddItemsToReservationMutationVariables>(AddItemsToReservationDocument, options);
      }
export type AddItemsToReservationMutationHookResult = ReturnType<typeof useAddItemsToReservationMutation>;
export type AddItemsToReservationMutationResult = Apollo.MutationResult<AddItemsToReservationMutation>;
export type AddItemsToReservationMutationOptions = Apollo.BaseMutationOptions<AddItemsToReservationMutation, AddItemsToReservationMutationVariables>;
export const GetReservationDocument = gql`
    query GetReservation($reservationId: String!) {
  getReservation(id: $reservationId) {
    id
    name
    status
    type
    createdAt
    additionalNotes
    reservation_seq_id
    fulfillerNotes
    serviceArea {
      id
      name
    }
    account {
      id
      name
      industry
      contactPhone
    }
    userRequested {
      id
      name
      email
    }
    reservationItems {
      ...ReservationItemForReservationPage
    }
  }
}
    ${ReservationItemForReservationPageFragmentDoc}`;

/**
 * __useGetReservationQuery__
 *
 * To run a query within a React component, call `useGetReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useGetReservationQuery(baseOptions: Apollo.QueryHookOptions<GetReservationQuery, GetReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationQuery, GetReservationQueryVariables>(GetReservationDocument, options);
      }
export function useGetReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationQuery, GetReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationQuery, GetReservationQueryVariables>(GetReservationDocument, options);
        }
export type GetReservationQueryHookResult = ReturnType<typeof useGetReservationQuery>;
export type GetReservationLazyQueryHookResult = ReturnType<typeof useGetReservationLazyQuery>;
export type GetReservationQueryResult = Apollo.QueryResult<GetReservationQuery, GetReservationQueryVariables>;
export const ListReservationsAllowedStatusTransitionsDocument = gql`
    query ListReservationsAllowedStatusTransitions($reservationId: String!) {
  reservationsAllowedStatusTransitions(reservationId: $reservationId) {
    allowedTransitions
  }
}
    `;

/**
 * __useListReservationsAllowedStatusTransitionsQuery__
 *
 * To run a query within a React component, call `useListReservationsAllowedStatusTransitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReservationsAllowedStatusTransitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReservationsAllowedStatusTransitionsQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useListReservationsAllowedStatusTransitionsQuery(baseOptions: Apollo.QueryHookOptions<ListReservationsAllowedStatusTransitionsQuery, ListReservationsAllowedStatusTransitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReservationsAllowedStatusTransitionsQuery, ListReservationsAllowedStatusTransitionsQueryVariables>(ListReservationsAllowedStatusTransitionsDocument, options);
      }
export function useListReservationsAllowedStatusTransitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReservationsAllowedStatusTransitionsQuery, ListReservationsAllowedStatusTransitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReservationsAllowedStatusTransitionsQuery, ListReservationsAllowedStatusTransitionsQueryVariables>(ListReservationsAllowedStatusTransitionsDocument, options);
        }
export type ListReservationsAllowedStatusTransitionsQueryHookResult = ReturnType<typeof useListReservationsAllowedStatusTransitionsQuery>;
export type ListReservationsAllowedStatusTransitionsLazyQueryHookResult = ReturnType<typeof useListReservationsAllowedStatusTransitionsLazyQuery>;
export type ListReservationsAllowedStatusTransitionsQueryResult = Apollo.QueryResult<ListReservationsAllowedStatusTransitionsQuery, ListReservationsAllowedStatusTransitionsQueryVariables>;
export const UpdateReservationDocument = gql`
    mutation UpdateReservation($reservationInput: ReservationInput!) {
  updateReservation(ReservationInput: $reservationInput) {
    id
    name
    type
    fulfillerNotes
    serviceArea {
      id
      name
    }
  }
}
    `;
export type UpdateReservationMutationFn = Apollo.MutationFunction<UpdateReservationMutation, UpdateReservationMutationVariables>;

/**
 * __useUpdateReservationMutation__
 *
 * To run a mutation, you first call `useUpdateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationMutation, { data, loading, error }] = useUpdateReservationMutation({
 *   variables: {
 *      reservationInput: // value for 'reservationInput'
 *   },
 * });
 */
export function useUpdateReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationMutation, UpdateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationMutation, UpdateReservationMutationVariables>(UpdateReservationDocument, options);
      }
export type UpdateReservationMutationHookResult = ReturnType<typeof useUpdateReservationMutation>;
export type UpdateReservationMutationResult = Apollo.MutationResult<UpdateReservationMutation>;
export type UpdateReservationMutationOptions = Apollo.BaseMutationOptions<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const UpdateReservationStatusDocument = gql`
    mutation UpdateReservationStatus($id: String!, $status: ReservationStatus!) {
  updateReservation(ReservationInput: {id: $id, status: $status}) {
    id
    status
  }
}
    `;
export type UpdateReservationStatusMutationFn = Apollo.MutationFunction<UpdateReservationStatusMutation, UpdateReservationStatusMutationVariables>;

/**
 * __useUpdateReservationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReservationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationStatusMutation, { data, loading, error }] = useUpdateReservationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateReservationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationStatusMutation, UpdateReservationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationStatusMutation, UpdateReservationStatusMutationVariables>(UpdateReservationStatusDocument, options);
      }
export type UpdateReservationStatusMutationHookResult = ReturnType<typeof useUpdateReservationStatusMutation>;
export type UpdateReservationStatusMutationResult = Apollo.MutationResult<UpdateReservationStatusMutation>;
export type UpdateReservationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReservationStatusMutation, UpdateReservationStatusMutationVariables>;
export const UpdateReservationItemDocument = gql`
    mutation UpdateReservationItem($input: ReservationItemUpdateInput!) {
  updateReservationItem(input: $input) {
    id
    start
    end
  }
}
    `;
export type UpdateReservationItemMutationFn = Apollo.MutationFunction<UpdateReservationItemMutation, UpdateReservationItemMutationVariables>;

/**
 * __useUpdateReservationItemMutation__
 *
 * To run a mutation, you first call `useUpdateReservationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservationItemMutation, { data, loading, error }] = useUpdateReservationItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReservationItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservationItemMutation, UpdateReservationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservationItemMutation, UpdateReservationItemMutationVariables>(UpdateReservationItemDocument, options);
      }
export type UpdateReservationItemMutationHookResult = ReturnType<typeof useUpdateReservationItemMutation>;
export type UpdateReservationItemMutationResult = Apollo.MutationResult<UpdateReservationItemMutation>;
export type UpdateReservationItemMutationOptions = Apollo.BaseMutationOptions<UpdateReservationItemMutation, UpdateReservationItemMutationVariables>;
export const ReservationTelemetrySummaryDocument = gql`
    query ReservationTelemetrySummary($input: ReservationTelemetrySummaryInput!) {
  reservationTelemetrySummary(input: $input) {
    chargeDischargeTimes {
      unit
    }
    chargeDischargeTotals {
      average_load_kw_reservation
      average_load_kw_unit
      battery_capacity_used_percent_reservation
      battery_capacity_used_percent_unit
      e_cap_kwh_reservation
      e_cap_kwh_unit
      total_charge_hours_unit
      total_charge_kwh_reservation
      total_charge_kwh_unit
      total_discharge_hours_unit
      total_discharge_kwh_reservation
      total_discharge_kwh_unit
      unit
    }
    faults {
      total_critical_faults_reservation
      total_critical_faults_unit
      total_faults_reservation
      total_faults_unit
      unit
    }
    maxContinousLoad {
      maximum_continuous_load_kw_unit
      maximum_continuous_load_reservation
      unit
    }
  }
}
    `;

/**
 * __useReservationTelemetrySummaryQuery__
 *
 * To run a query within a React component, call `useReservationTelemetrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationTelemetrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationTelemetrySummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReservationTelemetrySummaryQuery(baseOptions: Apollo.QueryHookOptions<ReservationTelemetrySummaryQuery, ReservationTelemetrySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationTelemetrySummaryQuery, ReservationTelemetrySummaryQueryVariables>(ReservationTelemetrySummaryDocument, options);
      }
export function useReservationTelemetrySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationTelemetrySummaryQuery, ReservationTelemetrySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationTelemetrySummaryQuery, ReservationTelemetrySummaryQueryVariables>(ReservationTelemetrySummaryDocument, options);
        }
export type ReservationTelemetrySummaryQueryHookResult = ReturnType<typeof useReservationTelemetrySummaryQuery>;
export type ReservationTelemetrySummaryLazyQueryHookResult = ReturnType<typeof useReservationTelemetrySummaryLazyQuery>;
export type ReservationTelemetrySummaryQueryResult = Apollo.QueryResult<ReservationTelemetrySummaryQuery, ReservationTelemetrySummaryQueryVariables>;
export const ListReservationItemsByReservationStatusDocument = gql`
    query ListReservationItemsByReservationStatus($filterMode: FilterMode, $time: DateTime!) {
  listReservationItemsByReservationStatus(filterMode: $filterMode) {
    id
    createdAt
    start
    end
    quantity
    alias
    assignedDevice(time: $time, assignment: "discharging") {
      id
      name
    }
    deviceInstanceSchedule {
      assignment
      deviceInstance {
        id
        name
      }
      start
      end
    }
    reservation {
      id
      name
      status
      type
      createdAt
      account {
        name
      }
      userRequested {
        name
      }
      serviceArea {
        id
        name
      }
      activeAlerts {
        type
        triggerTime
        severity
        reservation {
          ...ReservationForAlertsPage
        }
        account {
          ...AccountForAlertsPage
        }
        ... on MPUOfflineAlert {
          ...MPUOfflineAlertForAlertsPage
        }
        ... on MPULowSOCAlert {
          ...MPULowSOCAlertForAlertsPage
        }
        ... on MPUCriticalFaultAlert {
          ...MPUCriticalFaultAlertForAlertsPage
        }
        ... on ReservationItemAllocationAlert {
          ...ReservationItemAllocationAlertForAlertsPage
        }
      }
    }
  }
}
    ${ReservationForAlertsPageFragmentDoc}
${AccountForAlertsPageFragmentDoc}
${MpuOfflineAlertForAlertsPageFragmentDoc}
${MpuLowSocAlertForAlertsPageFragmentDoc}
${MpuCriticalFaultAlertForAlertsPageFragmentDoc}
${ReservationItemAllocationAlertForAlertsPageFragmentDoc}`;

/**
 * __useListReservationItemsByReservationStatusQuery__
 *
 * To run a query within a React component, call `useListReservationItemsByReservationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReservationItemsByReservationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReservationItemsByReservationStatusQuery({
 *   variables: {
 *      filterMode: // value for 'filterMode'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useListReservationItemsByReservationStatusQuery(baseOptions: Apollo.QueryHookOptions<ListReservationItemsByReservationStatusQuery, ListReservationItemsByReservationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReservationItemsByReservationStatusQuery, ListReservationItemsByReservationStatusQueryVariables>(ListReservationItemsByReservationStatusDocument, options);
      }
export function useListReservationItemsByReservationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReservationItemsByReservationStatusQuery, ListReservationItemsByReservationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReservationItemsByReservationStatusQuery, ListReservationItemsByReservationStatusQueryVariables>(ListReservationItemsByReservationStatusDocument, options);
        }
export type ListReservationItemsByReservationStatusQueryHookResult = ReturnType<typeof useListReservationItemsByReservationStatusQuery>;
export type ListReservationItemsByReservationStatusLazyQueryHookResult = ReturnType<typeof useListReservationItemsByReservationStatusLazyQuery>;
export type ListReservationItemsByReservationStatusQueryResult = Apollo.QueryResult<ListReservationItemsByReservationStatusQuery, ListReservationItemsByReservationStatusQueryVariables>;
export const GetReservationStatusCountsDocument = gql`
    query GetReservationStatusCounts($fulfillerAccountID: String!) {
  countReservationsByStatus(fulfillerAccountID: $fulfillerAccountID) {
    requested
    confirmed
    started
  }
}
    `;

/**
 * __useGetReservationStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetReservationStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationStatusCountsQuery({
 *   variables: {
 *      fulfillerAccountID: // value for 'fulfillerAccountID'
 *   },
 * });
 */
export function useGetReservationStatusCountsQuery(baseOptions: Apollo.QueryHookOptions<GetReservationStatusCountsQuery, GetReservationStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationStatusCountsQuery, GetReservationStatusCountsQueryVariables>(GetReservationStatusCountsDocument, options);
      }
export function useGetReservationStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationStatusCountsQuery, GetReservationStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationStatusCountsQuery, GetReservationStatusCountsQueryVariables>(GetReservationStatusCountsDocument, options);
        }
export type GetReservationStatusCountsQueryHookResult = ReturnType<typeof useGetReservationStatusCountsQuery>;
export type GetReservationStatusCountsLazyQueryHookResult = ReturnType<typeof useGetReservationStatusCountsLazyQuery>;
export type GetReservationStatusCountsQueryResult = Apollo.QueryResult<GetReservationStatusCountsQuery, GetReservationStatusCountsQueryVariables>;
export const ListCurrentReservationsForCustomerReservationsPageDocument = gql`
    query ListCurrentReservationsForCustomerReservationsPage($requesterAccountID: String!, $assignment: String!, $telemetryEnd: DateTime!, $start: DateTime!, $end: DateTime!) {
  listReservationItems(
    input: {requesterAccountIDs: [$requesterAccountID], interval: {start: $start, end: $end}}
  ) {
    ...FullReservationItemForCustomerReservationsPage
  }
}
    ${FullReservationItemForCustomerReservationsPageFragmentDoc}`;

/**
 * __useListCurrentReservationsForCustomerReservationsPageQuery__
 *
 * To run a query within a React component, call `useListCurrentReservationsForCustomerReservationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCurrentReservationsForCustomerReservationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCurrentReservationsForCustomerReservationsPageQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *      assignment: // value for 'assignment'
 *      telemetryEnd: // value for 'telemetryEnd'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useListCurrentReservationsForCustomerReservationsPageQuery(baseOptions: Apollo.QueryHookOptions<ListCurrentReservationsForCustomerReservationsPageQuery, ListCurrentReservationsForCustomerReservationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCurrentReservationsForCustomerReservationsPageQuery, ListCurrentReservationsForCustomerReservationsPageQueryVariables>(ListCurrentReservationsForCustomerReservationsPageDocument, options);
      }
export function useListCurrentReservationsForCustomerReservationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCurrentReservationsForCustomerReservationsPageQuery, ListCurrentReservationsForCustomerReservationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCurrentReservationsForCustomerReservationsPageQuery, ListCurrentReservationsForCustomerReservationsPageQueryVariables>(ListCurrentReservationsForCustomerReservationsPageDocument, options);
        }
export type ListCurrentReservationsForCustomerReservationsPageQueryHookResult = ReturnType<typeof useListCurrentReservationsForCustomerReservationsPageQuery>;
export type ListCurrentReservationsForCustomerReservationsPageLazyQueryHookResult = ReturnType<typeof useListCurrentReservationsForCustomerReservationsPageLazyQuery>;
export type ListCurrentReservationsForCustomerReservationsPageQueryResult = Apollo.QueryResult<ListCurrentReservationsForCustomerReservationsPageQuery, ListCurrentReservationsForCustomerReservationsPageQueryVariables>;
export const ListUpcomingReservationsForCustomerReservationsPageDocument = gql`
    query ListUpcomingReservationsForCustomerReservationsPage($requesterAccountID: String!, $start: DateTime!, $end: DateTime!) {
  listReservationItems(
    input: {requesterAccountIDs: [$requesterAccountID], interval: {start: $start, end: $end}}
  ) {
    ...BaseReservationItemWithReservationForCustomerReservationsPage
  }
}
    ${BaseReservationItemWithReservationForCustomerReservationsPageFragmentDoc}`;

/**
 * __useListUpcomingReservationsForCustomerReservationsPageQuery__
 *
 * To run a query within a React component, call `useListUpcomingReservationsForCustomerReservationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUpcomingReservationsForCustomerReservationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUpcomingReservationsForCustomerReservationsPageQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useListUpcomingReservationsForCustomerReservationsPageQuery(baseOptions: Apollo.QueryHookOptions<ListUpcomingReservationsForCustomerReservationsPageQuery, ListUpcomingReservationsForCustomerReservationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUpcomingReservationsForCustomerReservationsPageQuery, ListUpcomingReservationsForCustomerReservationsPageQueryVariables>(ListUpcomingReservationsForCustomerReservationsPageDocument, options);
      }
export function useListUpcomingReservationsForCustomerReservationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUpcomingReservationsForCustomerReservationsPageQuery, ListUpcomingReservationsForCustomerReservationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUpcomingReservationsForCustomerReservationsPageQuery, ListUpcomingReservationsForCustomerReservationsPageQueryVariables>(ListUpcomingReservationsForCustomerReservationsPageDocument, options);
        }
export type ListUpcomingReservationsForCustomerReservationsPageQueryHookResult = ReturnType<typeof useListUpcomingReservationsForCustomerReservationsPageQuery>;
export type ListUpcomingReservationsForCustomerReservationsPageLazyQueryHookResult = ReturnType<typeof useListUpcomingReservationsForCustomerReservationsPageLazyQuery>;
export type ListUpcomingReservationsForCustomerReservationsPageQueryResult = Apollo.QueryResult<ListUpcomingReservationsForCustomerReservationsPageQuery, ListUpcomingReservationsForCustomerReservationsPageQueryVariables>;
export const ListPastReservationsForCustomerReservationsPageDocument = gql`
    query ListPastReservationsForCustomerReservationsPage($requesterAccountID: String!, $start: DateTime!, $end: DateTime!) {
  listReservationItems(
    input: {requesterAccountIDs: [$requesterAccountID], interval: {start: $start, end: $end}}
  ) {
    ...BaseReservationItemWithReservationForCustomerReservationsPage
  }
}
    ${BaseReservationItemWithReservationForCustomerReservationsPageFragmentDoc}`;

/**
 * __useListPastReservationsForCustomerReservationsPageQuery__
 *
 * To run a query within a React component, call `useListPastReservationsForCustomerReservationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPastReservationsForCustomerReservationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPastReservationsForCustomerReservationsPageQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useListPastReservationsForCustomerReservationsPageQuery(baseOptions: Apollo.QueryHookOptions<ListPastReservationsForCustomerReservationsPageQuery, ListPastReservationsForCustomerReservationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPastReservationsForCustomerReservationsPageQuery, ListPastReservationsForCustomerReservationsPageQueryVariables>(ListPastReservationsForCustomerReservationsPageDocument, options);
      }
export function useListPastReservationsForCustomerReservationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPastReservationsForCustomerReservationsPageQuery, ListPastReservationsForCustomerReservationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPastReservationsForCustomerReservationsPageQuery, ListPastReservationsForCustomerReservationsPageQueryVariables>(ListPastReservationsForCustomerReservationsPageDocument, options);
        }
export type ListPastReservationsForCustomerReservationsPageQueryHookResult = ReturnType<typeof useListPastReservationsForCustomerReservationsPageQuery>;
export type ListPastReservationsForCustomerReservationsPageLazyQueryHookResult = ReturnType<typeof useListPastReservationsForCustomerReservationsPageLazyQuery>;
export type ListPastReservationsForCustomerReservationsPageQueryResult = Apollo.QueryResult<ListPastReservationsForCustomerReservationsPageQuery, ListPastReservationsForCustomerReservationsPageQueryVariables>;
export const ListCancelledReservationsForCustomerReservationsPageDocument = gql`
    query ListCancelledReservationsForCustomerReservationsPage($requesterAccountID: String!) {
  listReservations(
    input: {requesterAccountIDs: [$requesterAccountID], statuses: [Cancelled]}
  ) {
    ...ReservationForCustomerReservationsPage
    reservationItems {
      ...BaseReservationItemForCustomerReservationsPage
    }
  }
}
    ${ReservationForCustomerReservationsPageFragmentDoc}
${BaseReservationItemForCustomerReservationsPageFragmentDoc}`;

/**
 * __useListCancelledReservationsForCustomerReservationsPageQuery__
 *
 * To run a query within a React component, call `useListCancelledReservationsForCustomerReservationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCancelledReservationsForCustomerReservationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCancelledReservationsForCustomerReservationsPageQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *   },
 * });
 */
export function useListCancelledReservationsForCustomerReservationsPageQuery(baseOptions: Apollo.QueryHookOptions<ListCancelledReservationsForCustomerReservationsPageQuery, ListCancelledReservationsForCustomerReservationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCancelledReservationsForCustomerReservationsPageQuery, ListCancelledReservationsForCustomerReservationsPageQueryVariables>(ListCancelledReservationsForCustomerReservationsPageDocument, options);
      }
export function useListCancelledReservationsForCustomerReservationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCancelledReservationsForCustomerReservationsPageQuery, ListCancelledReservationsForCustomerReservationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCancelledReservationsForCustomerReservationsPageQuery, ListCancelledReservationsForCustomerReservationsPageQueryVariables>(ListCancelledReservationsForCustomerReservationsPageDocument, options);
        }
export type ListCancelledReservationsForCustomerReservationsPageQueryHookResult = ReturnType<typeof useListCancelledReservationsForCustomerReservationsPageQuery>;
export type ListCancelledReservationsForCustomerReservationsPageLazyQueryHookResult = ReturnType<typeof useListCancelledReservationsForCustomerReservationsPageLazyQuery>;
export type ListCancelledReservationsForCustomerReservationsPageQueryResult = Apollo.QueryResult<ListCancelledReservationsForCustomerReservationsPageQuery, ListCancelledReservationsForCustomerReservationsPageQueryVariables>;
export const ListDeclinedReservationsForCustomerReservationsPageDocument = gql`
    query ListDeclinedReservationsForCustomerReservationsPage($requesterAccountID: String!) {
  listReservations(
    input: {requesterAccountIDs: [$requesterAccountID], statuses: [Declined]}
  ) {
    ...ReservationForCustomerReservationsPage
    reservationItems {
      ...BaseReservationItemForCustomerReservationsPage
    }
  }
}
    ${ReservationForCustomerReservationsPageFragmentDoc}
${BaseReservationItemForCustomerReservationsPageFragmentDoc}`;

/**
 * __useListDeclinedReservationsForCustomerReservationsPageQuery__
 *
 * To run a query within a React component, call `useListDeclinedReservationsForCustomerReservationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeclinedReservationsForCustomerReservationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeclinedReservationsForCustomerReservationsPageQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *   },
 * });
 */
export function useListDeclinedReservationsForCustomerReservationsPageQuery(baseOptions: Apollo.QueryHookOptions<ListDeclinedReservationsForCustomerReservationsPageQuery, ListDeclinedReservationsForCustomerReservationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeclinedReservationsForCustomerReservationsPageQuery, ListDeclinedReservationsForCustomerReservationsPageQueryVariables>(ListDeclinedReservationsForCustomerReservationsPageDocument, options);
      }
export function useListDeclinedReservationsForCustomerReservationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeclinedReservationsForCustomerReservationsPageQuery, ListDeclinedReservationsForCustomerReservationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeclinedReservationsForCustomerReservationsPageQuery, ListDeclinedReservationsForCustomerReservationsPageQueryVariables>(ListDeclinedReservationsForCustomerReservationsPageDocument, options);
        }
export type ListDeclinedReservationsForCustomerReservationsPageQueryHookResult = ReturnType<typeof useListDeclinedReservationsForCustomerReservationsPageQuery>;
export type ListDeclinedReservationsForCustomerReservationsPageLazyQueryHookResult = ReturnType<typeof useListDeclinedReservationsForCustomerReservationsPageLazyQuery>;
export type ListDeclinedReservationsForCustomerReservationsPageQueryResult = Apollo.QueryResult<ListDeclinedReservationsForCustomerReservationsPageQuery, ListDeclinedReservationsForCustomerReservationsPageQueryVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($id: String!) {
  cancelReservation(id: $id) {
    id
    status
  }
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const ListEventSubscriptionsDocument = gql`
    query ListEventSubscriptions($userID: String!) {
  listEventSubscriptions(userID: $userID) {
    id
    eventName
    channels
  }
}
    `;

/**
 * __useListEventSubscriptionsQuery__
 *
 * To run a query within a React component, call `useListEventSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventSubscriptionsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useListEventSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>(ListEventSubscriptionsDocument, options);
      }
export function useListEventSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>(ListEventSubscriptionsDocument, options);
        }
export type ListEventSubscriptionsQueryHookResult = ReturnType<typeof useListEventSubscriptionsQuery>;
export type ListEventSubscriptionsLazyQueryHookResult = ReturnType<typeof useListEventSubscriptionsLazyQuery>;
export type ListEventSubscriptionsQueryResult = Apollo.QueryResult<ListEventSubscriptionsQuery, ListEventSubscriptionsQueryVariables>;
export const UpsertEventSubscriptionDocument = gql`
    mutation UpsertEventSubscription($input: UpdateEventSubscriptionInput!) {
  upsertEventSubscription(input: $input) {
    id
    eventName
    channels
  }
}
    `;
export type UpsertEventSubscriptionMutationFn = Apollo.MutationFunction<UpsertEventSubscriptionMutation, UpsertEventSubscriptionMutationVariables>;

/**
 * __useUpsertEventSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpsertEventSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventSubscriptionMutation, { data, loading, error }] = useUpsertEventSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEventSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventSubscriptionMutation, UpsertEventSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventSubscriptionMutation, UpsertEventSubscriptionMutationVariables>(UpsertEventSubscriptionDocument, options);
      }
export type UpsertEventSubscriptionMutationHookResult = ReturnType<typeof useUpsertEventSubscriptionMutation>;
export type UpsertEventSubscriptionMutationResult = Apollo.MutationResult<UpsertEventSubscriptionMutation>;
export type UpsertEventSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpsertEventSubscriptionMutation, UpsertEventSubscriptionMutationVariables>;
export const GetAccountForProfileDocument = gql`
    query GetAccountForProfile($id: String!) {
  getAccount(id: $id) {
    id
    name
    contactPhone
    billingAddressLocation {
      ...BillingAddressLocation
    }
    restrictedUserDomains
  }
}
    ${BillingAddressLocationFragmentDoc}`;

/**
 * __useGetAccountForProfileQuery__
 *
 * To run a query within a React component, call `useGetAccountForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountForProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountForProfileQuery(baseOptions: Apollo.QueryHookOptions<GetAccountForProfileQuery, GetAccountForProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountForProfileQuery, GetAccountForProfileQueryVariables>(GetAccountForProfileDocument, options);
      }
export function useGetAccountForProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountForProfileQuery, GetAccountForProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountForProfileQuery, GetAccountForProfileQueryVariables>(GetAccountForProfileDocument, options);
        }
export type GetAccountForProfileQueryHookResult = ReturnType<typeof useGetAccountForProfileQuery>;
export type GetAccountForProfileLazyQueryHookResult = ReturnType<typeof useGetAccountForProfileLazyQuery>;
export type GetAccountForProfileQueryResult = Apollo.QueryResult<GetAccountForProfileQuery, GetAccountForProfileQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($accountInput: AccountInput!) {
  updateAccount(accountInput: $accountInput) {
    id
    industry
    name
    contactPhone
    billingAddressLocation {
      ...BillingAddressLocation
    }
  }
}
    ${BillingAddressLocationFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      accountInput: // value for 'accountInput'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const ListActiveReservationItemsDocument = gql`
    query ListActiveReservationItems($requesterAccountID: String!, $end: DateTime!) {
  listReservations(
    input: {statuses: [Started], requesterAccountIDs: [$requesterAccountID]}
  ) {
    id
    name
    status
    reservationItems {
      id
      start
      end
      alias
      quantity
      createdAt
      deliveryLocation {
        id
        formattedAddress
      }
      assignedDevice(time: $end, assignment: "discharging") {
        id
        assetID
        name
        latestDeviceLocation {
          lat
          lon
        }
        latestTelemetry(metrics: ["soc", "s_time_to_empty"]) {
          telemetryPoints {
            metric
            timestamp
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListActiveReservationItemsQuery__
 *
 * To run a query within a React component, call `useListActiveReservationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveReservationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveReservationItemsQuery({
 *   variables: {
 *      requesterAccountID: // value for 'requesterAccountID'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useListActiveReservationItemsQuery(baseOptions: Apollo.QueryHookOptions<ListActiveReservationItemsQuery, ListActiveReservationItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveReservationItemsQuery, ListActiveReservationItemsQueryVariables>(ListActiveReservationItemsDocument, options);
      }
export function useListActiveReservationItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveReservationItemsQuery, ListActiveReservationItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveReservationItemsQuery, ListActiveReservationItemsQueryVariables>(ListActiveReservationItemsDocument, options);
        }
export type ListActiveReservationItemsQueryHookResult = ReturnType<typeof useListActiveReservationItemsQuery>;
export type ListActiveReservationItemsLazyQueryHookResult = ReturnType<typeof useListActiveReservationItemsLazyQuery>;
export type ListActiveReservationItemsQueryResult = Apollo.QueryResult<ListActiveReservationItemsQuery, ListActiveReservationItemsQueryVariables>;
export const GetReservationDetailsForMonitoringDocument = gql`
    query GetReservationDetailsForMonitoring($id: String!, $start: DateTime!, $end: DateTime!) {
  getReservation(id: $id) {
    id
    name
    reservationItems {
      id
      alias
      start
      end
      assignedDevice(time: $end, assignment: "discharging") {
        id
        name
        latestDeviceLocation {
          lat
          lon
        }
        telemetry(
          start: $start
          end: $end
          metrics: ["soc", "s_time_to_empty", "p_ess"]
        ) {
          telemetries {
            assetId
            metric
            datapoints {
              value
              timestamp
            }
          }
        }
        latestDataTimestamp
      }
    }
  }
}
    `;

/**
 * __useGetReservationDetailsForMonitoringQuery__
 *
 * To run a query within a React component, call `useGetReservationDetailsForMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationDetailsForMonitoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationDetailsForMonitoringQuery({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetReservationDetailsForMonitoringQuery(baseOptions: Apollo.QueryHookOptions<GetReservationDetailsForMonitoringQuery, GetReservationDetailsForMonitoringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationDetailsForMonitoringQuery, GetReservationDetailsForMonitoringQueryVariables>(GetReservationDetailsForMonitoringDocument, options);
      }
export function useGetReservationDetailsForMonitoringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationDetailsForMonitoringQuery, GetReservationDetailsForMonitoringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationDetailsForMonitoringQuery, GetReservationDetailsForMonitoringQueryVariables>(GetReservationDetailsForMonitoringDocument, options);
        }
export type GetReservationDetailsForMonitoringQueryHookResult = ReturnType<typeof useGetReservationDetailsForMonitoringQuery>;
export type GetReservationDetailsForMonitoringLazyQueryHookResult = ReturnType<typeof useGetReservationDetailsForMonitoringLazyQuery>;
export type GetReservationDetailsForMonitoringQueryResult = Apollo.QueryResult<GetReservationDetailsForMonitoringQuery, GetReservationDetailsForMonitoringQueryVariables>;
export const SubmitResetPasswordTokenDocument = gql`
    mutation SubmitResetPasswordToken($email: String!, $newPassword: String!, $resetToken: String!) {
  submitResetPasswordToken(
    email: $email
    newPassword: $newPassword
    resetToken: $resetToken
  ) {
    reset
  }
}
    `;
export type SubmitResetPasswordTokenMutationFn = Apollo.MutationFunction<SubmitResetPasswordTokenMutation, SubmitResetPasswordTokenMutationVariables>;

/**
 * __useSubmitResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useSubmitResetPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitResetPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitResetPasswordTokenMutation, { data, loading, error }] = useSubmitResetPasswordTokenMutation({
 *   variables: {
 *      email: // value for 'email'
 *      newPassword: // value for 'newPassword'
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useSubmitResetPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<SubmitResetPasswordTokenMutation, SubmitResetPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitResetPasswordTokenMutation, SubmitResetPasswordTokenMutationVariables>(SubmitResetPasswordTokenDocument, options);
      }
export type SubmitResetPasswordTokenMutationHookResult = ReturnType<typeof useSubmitResetPasswordTokenMutation>;
export type SubmitResetPasswordTokenMutationResult = Apollo.MutationResult<SubmitResetPasswordTokenMutation>;
export type SubmitResetPasswordTokenMutationOptions = Apollo.BaseMutationOptions<SubmitResetPasswordTokenMutation, SubmitResetPasswordTokenMutationVariables>;
export const LogInUserDocument = gql`
    mutation LogInUser($loginInput: LoginInput!) {
  loginUser(loginInput: $loginInput) {
    id
    requires2FA
    accounts {
      id
    }
  }
}
    `;
export type LogInUserMutationFn = Apollo.MutationFunction<LogInUserMutation, LogInUserMutationVariables>;

/**
 * __useLogInUserMutation__
 *
 * To run a mutation, you first call `useLogInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInUserMutation, { data, loading, error }] = useLogInUserMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLogInUserMutation(baseOptions?: Apollo.MutationHookOptions<LogInUserMutation, LogInUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInUserMutation, LogInUserMutationVariables>(LogInUserDocument, options);
      }
export type LogInUserMutationHookResult = ReturnType<typeof useLogInUserMutation>;
export type LogInUserMutationResult = Apollo.MutationResult<LogInUserMutation>;
export type LogInUserMutationOptions = Apollo.BaseMutationOptions<LogInUserMutation, LogInUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(email: $email) {
    requested
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($signUpUserInput: CreateUserInput!) {
  createUser(createUserInput: $signUpUserInput) {
    id
    accounts {
      id
    }
  }
}
    `;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      signUpUserInput: // value for 'signUpUserInput'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: Apollo.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const ListScheduleTransitionsDocument = gql`
    query ListScheduleTransitions($input: ListScheduleTransitionsInput!) {
  listScheduleTransitions(input: $input) {
    type
    time
    from {
      id
      reservationItem {
        id
        reservation {
          id
        }
      }
    }
    to {
      id
      reservationItem {
        id
        reservation {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useListScheduleTransitionsQuery__
 *
 * To run a query within a React component, call `useListScheduleTransitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleTransitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleTransitionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListScheduleTransitionsQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleTransitionsQuery, ListScheduleTransitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleTransitionsQuery, ListScheduleTransitionsQueryVariables>(ListScheduleTransitionsDocument, options);
      }
export function useListScheduleTransitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleTransitionsQuery, ListScheduleTransitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleTransitionsQuery, ListScheduleTransitionsQueryVariables>(ListScheduleTransitionsDocument, options);
        }
export type ListScheduleTransitionsQueryHookResult = ReturnType<typeof useListScheduleTransitionsQuery>;
export type ListScheduleTransitionsLazyQueryHookResult = ReturnType<typeof useListScheduleTransitionsLazyQuery>;
export type ListScheduleTransitionsQueryResult = Apollo.QueryResult<ListScheduleTransitionsQuery, ListScheduleTransitionsQueryVariables>;
export const GetMpuBuildDetailsDocument = gql`
    query GetMPUBuildDetails($id: String!) {
  getDeviceInstance(id: $id) {
    id
    serialNumber
    firmwareVersions {
      bmsVersion
      ecuVersion
      evccVersion
      pmcVersion
      tguVersion
    }
    latestTelemetry(
      metrics: ["mp_unit_lifetime_pcs_active_s", "mp_unit_e_lifetime_discharge"]
    ) {
      telemetryPoints {
        metric
        timestamp
        value
      }
    }
  }
}
    `;

/**
 * __useGetMpuBuildDetailsQuery__
 *
 * To run a query within a React component, call `useGetMpuBuildDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMpuBuildDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMpuBuildDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMpuBuildDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMpuBuildDetailsQuery, GetMpuBuildDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMpuBuildDetailsQuery, GetMpuBuildDetailsQueryVariables>(GetMpuBuildDetailsDocument, options);
      }
export function useGetMpuBuildDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMpuBuildDetailsQuery, GetMpuBuildDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMpuBuildDetailsQuery, GetMpuBuildDetailsQueryVariables>(GetMpuBuildDetailsDocument, options);
        }
export type GetMpuBuildDetailsQueryHookResult = ReturnType<typeof useGetMpuBuildDetailsQuery>;
export type GetMpuBuildDetailsLazyQueryHookResult = ReturnType<typeof useGetMpuBuildDetailsLazyQuery>;
export type GetMpuBuildDetailsQueryResult = Apollo.QueryResult<GetMpuBuildDetailsQuery, GetMpuBuildDetailsQueryVariables>;
export const ActiveFaultsPageDocument = gql`
    query ActiveFaultsPage($page: Int, $before: String, $after: String, $first: Int, $last: Int, $ownerAccountID: String, $deviceIDs: [String!], $severities: [FaultSeverity!], $sortBy: KeyOfSortArg) {
  listActiveFaults(
    page: $page
    before: $before
    after: $after
    first: $first
    last: $last
    ownerAccountID: $ownerAccountID
    deviceIDs: $deviceIDs
    severities: $severities
    sortBy: $sortBy
  ) {
    edges {
      node {
        id
        device {
          id
          name
          owner {
            id
            name
          }
          serviceArea {
            id
            name
          }
          deviceModel {
            id
            name
          }
        }
        faultSeverity
        faultName
        firstSeen
        lastUpdate
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      totalEdges
    }
  }
}
    `;

/**
 * __useActiveFaultsPageQuery__
 *
 * To run a query within a React component, call `useActiveFaultsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveFaultsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveFaultsPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      ownerAccountID: // value for 'ownerAccountID'
 *      deviceIDs: // value for 'deviceIDs'
 *      severities: // value for 'severities'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useActiveFaultsPageQuery(baseOptions?: Apollo.QueryHookOptions<ActiveFaultsPageQuery, ActiveFaultsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveFaultsPageQuery, ActiveFaultsPageQueryVariables>(ActiveFaultsPageDocument, options);
      }
export function useActiveFaultsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveFaultsPageQuery, ActiveFaultsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveFaultsPageQuery, ActiveFaultsPageQueryVariables>(ActiveFaultsPageDocument, options);
        }
export type ActiveFaultsPageQueryHookResult = ReturnType<typeof useActiveFaultsPageQuery>;
export type ActiveFaultsPageLazyQueryHookResult = ReturnType<typeof useActiveFaultsPageLazyQuery>;
export type ActiveFaultsPageQueryResult = Apollo.QueryResult<ActiveFaultsPageQuery, ActiveFaultsPageQueryVariables>;
export const ListDeviceInstancesDocument = gql`
    query ListDeviceInstances($after: String, $first: Int, $before: String, $last: Int, $sortBy: KeyOfSortArg, $start: DateTime!, $end: DateTime!, $filters: DeviceInstancePaginationFilters!) {
  listDeviceInstances(
    after: $after
    first: $first
    before: $before
    last: $last
    sortBy: $sortBy
    filters: $filters
  ) {
    edges {
      node {
        ...MPUIndexDeviceInstance
      }
    }
    pageInfo {
      totalEdges
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    ${MpuIndexDeviceInstanceFragmentDoc}`;

/**
 * __useListDeviceInstancesQuery__
 *
 * To run a query within a React component, call `useListDeviceInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeviceInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeviceInstancesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListDeviceInstancesQuery(baseOptions: Apollo.QueryHookOptions<ListDeviceInstancesQuery, ListDeviceInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeviceInstancesQuery, ListDeviceInstancesQueryVariables>(ListDeviceInstancesDocument, options);
      }
export function useListDeviceInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeviceInstancesQuery, ListDeviceInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeviceInstancesQuery, ListDeviceInstancesQueryVariables>(ListDeviceInstancesDocument, options);
        }
export type ListDeviceInstancesQueryHookResult = ReturnType<typeof useListDeviceInstancesQuery>;
export type ListDeviceInstancesLazyQueryHookResult = ReturnType<typeof useListDeviceInstancesLazyQuery>;
export type ListDeviceInstancesQueryResult = Apollo.QueryResult<ListDeviceInstancesQuery, ListDeviceInstancesQueryVariables>;
export const ListLatestMpuLocationsDocument = gql`
    query ListLatestMPULocations($ownerAccountIDs: [String!]!) {
  listDeviceLocations(input: {ownerAccountIDs: $ownerAccountIDs}) {
    ...MPUIndexDeviceLocation
  }
}
    ${MpuIndexDeviceLocationFragmentDoc}`;

/**
 * __useListLatestMpuLocationsQuery__
 *
 * To run a query within a React component, call `useListLatestMpuLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLatestMpuLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLatestMpuLocationsQuery({
 *   variables: {
 *      ownerAccountIDs: // value for 'ownerAccountIDs'
 *   },
 * });
 */
export function useListLatestMpuLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListLatestMpuLocationsQuery, ListLatestMpuLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLatestMpuLocationsQuery, ListLatestMpuLocationsQueryVariables>(ListLatestMpuLocationsDocument, options);
      }
export function useListLatestMpuLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLatestMpuLocationsQuery, ListLatestMpuLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLatestMpuLocationsQuery, ListLatestMpuLocationsQueryVariables>(ListLatestMpuLocationsDocument, options);
        }
export type ListLatestMpuLocationsQueryHookResult = ReturnType<typeof useListLatestMpuLocationsQuery>;
export type ListLatestMpuLocationsLazyQueryHookResult = ReturnType<typeof useListLatestMpuLocationsLazyQuery>;
export type ListLatestMpuLocationsQueryResult = Apollo.QueryResult<ListLatestMpuLocationsQuery, ListLatestMpuLocationsQueryVariables>;
export const ListServiceAreasDocument = gql`
    query ListServiceAreas {
  listServiceAreas(accountID: "") {
    id
    name
  }
}
    `;

/**
 * __useListServiceAreasQuery__
 *
 * To run a query within a React component, call `useListServiceAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useListServiceAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListServiceAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useListServiceAreasQuery(baseOptions?: Apollo.QueryHookOptions<ListServiceAreasQuery, ListServiceAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListServiceAreasQuery, ListServiceAreasQueryVariables>(ListServiceAreasDocument, options);
      }
export function useListServiceAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListServiceAreasQuery, ListServiceAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListServiceAreasQuery, ListServiceAreasQueryVariables>(ListServiceAreasDocument, options);
        }
export type ListServiceAreasQueryHookResult = ReturnType<typeof useListServiceAreasQuery>;
export type ListServiceAreasLazyQueryHookResult = ReturnType<typeof useListServiceAreasLazyQuery>;
export type ListServiceAreasQueryResult = Apollo.QueryResult<ListServiceAreasQuery, ListServiceAreasQueryVariables>;